<template>
  <div class="brevo-editor">
    <!-- Barra de Ações -->
    <div class="action-bar">
      <div class="action-left">
        <button @click="confirmGoBack" class="action-btn">
          <span class="icon"><i class="fa-solid fa-circle-left"></i></span>
          Voltar
        </button>

        <div class="editable-title">
          <input v-model="templateName" class="template-name-title" placeholder="Nome do Template" />
          <i class="fa-solid fa-pencil edit-icon"></i>
        </div>
      </div>


      <div class="action-right">
        <button @click="toggleDevice" class="action-btn">
          <i :class="currentDevice === 'desktop' ? 'fa-solid fa-desktop' : 'fa-solid fa-mobile-screen'"></i>
          {{ currentDevice === 'desktop' ? 'Desktop' : 'Mobile' }}
        </button>

        <button @click="showPreview = true" class="action-btn">
          <span class="icon"><i class="fa-solid fa-eye"></i></span>
          Preview
        </button>

        <button @click="exportHTML" class="action-btn">
          <span class="icon"><i class="fa-solid fa-file-export"></i></span>
          Exportar
        </button>

        <button @click="saveTemplate" class="action-btn" :disabled="saving">
          <span class="icon"><i class="fa-solid fa-floppy-disk"></i></span>
          {{ saving ? 'Salvando...' : 'Salvar Template' }}
        </button>
      </div>
    </div>

    <!-- Área de Trabalho -->
    <div class="workspace">
      <!-- Painel Esquerdo: Blocos + Edição -->
      <div class="left-panel">
        <!-- Abas -->
        <div class="tabs">
          <div class="tab" :class="{ active: activeTab === 'blocks' }" @click="activeTab = 'blocks'"> <i
              class="fa-solid fa-cubes"></i> Blocos
          </div>
          <div class="tab" :class="{ active: activeTab === 'edit' }" @click="activeTab = 'edit'"
            :disabled="selectedIndex === null"> <i class="fa-solid fa-palette"></i> Editar
          </div>
          <div class="tab" :class="{ active: activeTab === 'settings' }" @click="activeTab = 'settings'"><i
              class="fa-solid fa-gear"></i> Config
          </div>
        </div>

        <!-- Conteúdo das Abas -->
        <div class="tab-content">
          <!-- Aba Blocos -->
          <div v-show="activeTab === 'blocks'" class="blocks-tab">
            <div class="blocks-section">
              <div class="section-title">Conteúdo</div>
              <div class="blocks-grid">
                <div v-for="block in contentBlocks" :key="block.type" class="block-card" draggable="true"
                  @dragstart="handleDragStart(block)">
                  <div class="block-icon-lg" v-html="block.icon"></div>
                  <div class="block-name">{{ block.name }}</div>
                </div>
              </div>
            </div>

            <div class="blocks-section">
              <div class="section-title">Layout</div>
              <div class="blocks-grid">
                <div v-for="block in layoutBlocks" :key="block.type" class="block-card" draggable="true"
                  @dragstart="handleDragStart(block)">
                  <div class="block-icon-lg" v-html="block.icon"></div>
                  <div class="block-name">{{ block.name }}</div>
                </div>
              </div>
            </div>

            <div class="blocks-section">
              <div class="section-title">Mídia</div>
              <div class="blocks-grid">
                <div v-for="block in mediaBlocks" :key="block.type" class="block-card" draggable="true"
                  @dragstart="handleDragStart(block)">
                  <div class="block-icon-lg" v-html="block.icon"></div>
                  <div class="block-name">{{ block.name }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Aba Editar -->
          <div v-show="activeTab === 'edit'" class="edit-tab">
            <div v-if="selectedIndex !== null" class="edit-panel">
              <div class="edit-header">
                <strong>{{ getBlockName(components[selectedIndex].type) }}</strong>
                <button @click="confirmDelete(selectedIndex)" class="btn-delete-small">
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>

              <!-- Editor da Tabela -->
              <div v-if="components[selectedIndex].type === 'table'" class="editor-form">
                <div class="form-group">
                  <label>Cabeçalhos</label>
                  <div v-for="(header, idx) in components[selectedIndex].headers" :key="'header-edit-' + idx"
                    style="margin-bottom: 8px;">
                    <div style="display: flex; gap: 8px; align-items: center;">
                      <input v-model="components[selectedIndex].headers[idx]" class="form-input"
                        placeholder="Nome da coluna" @input="forceUpdate()" />
                      <button @click="removeTableHeader(selectedIndex, idx)" class="btn-delete-small"
                        :disabled="components[selectedIndex].headers.length <= 1" style="flex-shrink: 0;">
                        <i class="fa-solid fa-trash"></i>
                      </button>
                    </div>
                  </div>
                  <button @click="addTableHeader(selectedIndex)" class="form-button"
                    style="width: 100%; padding: 8px; margin-top: 8px; background: #28a745; color: white;">
                    <i class="fa-solid fa-plus"></i> Adicionar Coluna
                  </button>
                </div>

                <div class="form-group">
                  <label>Linhas de Dados</label>
                  <div v-for="(row, rowIdx) in components[selectedIndex].rows" :key="'row-edit-' + rowIdx"
                    style="margin-bottom: 10px; padding: 10px; border: 1px solid #e0e0e0; border-radius: 6px; background: #f9f9f9;">

                    <div
                      style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                      <strong style="color: #333;">Linha {{ rowIdx + 1 }}</strong>
                      <button @click="removeTableRow(selectedIndex, rowIdx)" class="btn-delete-small">
                        <i class="fa-solid fa-trash"></i> Remover
                      </button>
                    </div>

                    <div v-for="(cell, cellIdx) in row" :key="'cell-edit-' + rowIdx + '-' + cellIdx"
                      style="margin-bottom: 8px;">
                      <label style="font-size: 12px; color: #666; display: block; margin-bottom: 4px;">
                        {{ components[selectedIndex].headers[cellIdx] || 'Coluna ' + (cellIdx + 1) }}
                      </label>
                      <input v-model="components[selectedIndex].rows[rowIdx][cellIdx]" class="form-input"
                        :placeholder="components[selectedIndex].headers[cellIdx] || 'Valor'" @input="forceUpdate()" />
                    </div>
                  </div>
                </div>

                <div class="variables-container">
                  <div class="variables-header">
                    <i class="fa-solid fa-code"></i>
                    <span>Variáveis Disponíveis (Clique para Usar)</span>
                  </div>
                  <div class="variables-grid">
                    <button v-for="variable in availableVariables" :key="'table-var-' + variable.key"
                      @click="showTableVariableInsertion(variable.key)" type="button" class="variable-btn"
                      :title="'Usar ' + variable.label">
                      <i class="fa-solid fa-plus-circle"></i>
                      <span>{{ variable.label }}</span>
                    </button>
                  </div>
                  <small class="variables-hint">
                    <i class="fa-solid fa-lightbulb"></i>
                    Clique na variável e depois escolha em qual célula deseja inserir
                  </small>
                </div>

                <div class="section-title" style="margin-top: 20px;">Estilo da Tabela</div>

                <div class="form-row">
                  <div class="form-group">
                    <label>Tamanho Fonte Cabeçalho</label>
                    <input type="number" v-model.number="components[selectedIndex].headerFontSize" class="form-input"
                      min="10" max="24" />
                  </div>
                  <div class="form-group">
                    <label>Tamanho Fonte Células</label>
                    <input type="number" v-model.number="components[selectedIndex].cellFontSize" class="form-input"
                      min="10" max="20" />
                  </div>
                </div>

                <!-- <div class="form-row">
                  <div class="form-group">
                    <label>Cor do Cabeçalho</label>
                    <input type="color" v-model="components[selectedIndex].headerColor" class="form-color" />
                  </div>
                  <div class="form-group">
                    <label>Cor das Células</label>
                    <input type="color" v-model="components[selectedIndex].cellColor" class="form-color" />
                  </div>
                </div> -->

                <!-- <div class="form-row">
                  <div class="form-group">
                    <label>Fundo Linhas Pares</label>
                    <input type="color" v-model="components[selectedIndex].evenRowColor" class="form-color" />
                  </div>
                  <div class="form-group">
                    <label>Fundo Linhas Ímpares</label>
                    <input type="color" v-model="components[selectedIndex].oddRowColor" class="form-color" />
                  </div>
                </div> -->

                <!-- <div class="form-group">
                  <label>Cor da Borda</label>
                  <input type="color" v-model="components[selectedIndex].borderColor" class="form-color" />
                </div> -->

                <div class="form-group">
                  <label>Alinhamento</label>
                  <div class="align-buttons">
                    <button @click="setTableAlignment(selectedIndex, 'left')"
                      :class="{ active: components[selectedIndex].headerAlign === 'left' }" class="align-btn">
                      <i class="fas fa-align-left"></i>
                    </button>
                    <button @click="setTableAlignment(selectedIndex, 'center')"
                      :class="{ active: components[selectedIndex].headerAlign === 'center' }" class="align-btn">
                      <i class="fas fa-align-center"></i>
                    </button>
                    <button @click="setTableAlignment(selectedIndex, 'right')"
                      :class="{ active: components[selectedIndex].headerAlign === 'right' }" class="align-btn">
                      <i class="fas fa-align-right"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Editor do Texto -->
              <div v-if="components[selectedIndex].type === 'text'" class="editor-form">
                <div class="form-group">
                  <label>Conteúdo</label>
                  <textarea ref="textContentArea" v-model="components[selectedIndex].content" class="form-textarea"
                    rows="6" placeholder="Digite o texto..."></textarea>

                  <div class="link-tools" style="margin-top: 10px; display: flex; gap: 8px; align-items: center;">
                    <button @click="openLinkEditor('text')" type="button" class="tool-btn"
                      style="padding: 8px 16px; background: #28a745; color: white; border: none; border-radius: 6px !important; cursor: pointer; font-size: 13px; display: flex; align-items: center; gap: 6px;">
                      <i class="fa-solid fa-link"></i>
                      Inserir Link
                    </button>
                    <small style="color: #666;">
                      <i class="fa-solid fa-info-circle"></i>
                      Selecione o texto e clique em "Inserir Link"
                    </small>
                  </div>

                  <div class="variables-container">
                    <div class="variables-header">
                      <i class="fa-solid fa-code"></i>
                      <span>Variáveis Disponíveis</span>
                    </div>
                    <div class="variables-grid">
                      <button v-for="variable in availableVariables" :key="variable.key"
                        @click="insertVariable('text', variable.key)" type="button" class="variable-btn"
                        :title="'Inserir ' + variable.label">
                        <i class="fa-solid fa-plus-circle"></i>
                        <span>{{ variable.label }}</span>
                      </button>
                    </div>
                    <small class="variables-hint">
                      <i class="fa-solid fa-lightbulb"></i>
                      Clique para inserir a variável na posição do cursor
                    </small>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label>Tamanho (px)</label>
                    <input type="number" v-model.number="components[selectedIndex].fontSize" class="form-input" min="10"
                      max="48" placeholder="16" />
                  </div>
                  <div class="form-group">
                    <label>Cor</label>
                    <input type="color" v-model="components[selectedIndex].color" class="form-color" />
                  </div>
                </div>
                <div class="form-group">
                  <label>Fonte</label>
                  <select v-model="components[selectedIndex].fontFamily" class="form-select">
                    <option value="Arial, sans-serif">Arial</option>
                    <option value="'Times New Roman', serif">Times New Roman</option>
                    <option value="'Courier New', monospace">Courier New</option>
                    <option value="Georgia, serif">Georgia</option>
                    <option value="Verdana, sans-serif">Verdana</option>
                    <option value="'Trebuchet MS', sans-serif">Trebuchet MS</option>
                    <option value="'Comic Sans MS', cursive">Comic Sans MS</option>
                    <option value="Impact, sans-serif">Impact</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Alinhamento</label>
                  <div class="align-buttons">
                    <button @click="components[selectedIndex].align = 'left'"
                      :class="{ active: components[selectedIndex].align === 'left' }" class="align-btn">
                      <i class="fas fa-align-left"></i>
                    </button>

                    <button @click="components[selectedIndex].align = 'center'"
                      :class="{ active: components[selectedIndex].align === 'center' }" class="align-btn">
                      <i class="fas fa-align-center"></i>
                    </button>

                    <button @click="components[selectedIndex].align = 'right'"
                      :class="{ active: components[selectedIndex].align === 'right' }" class="align-btn">
                      <i class="fas fa-align-right"></i>
                    </button>

                    <button @click="components[selectedIndex].align = 'justify'"
                      :class="{ active: components[selectedIndex].align === 'justify' }" class="align-btn">
                      <i class="fas fa-align-justify"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Editor do Título -->
              <div v-if="components[selectedIndex].type === 'heading'" class="editor-form">
                <div class="form-group">
                  <label>Título</label>
                  <input ref="headingContentInput" v-model="components[selectedIndex].content" class="form-input"
                    placeholder="Digite o título..." />

                  <div class="variables-container">
                    <div class="variables-header">
                      <i class="fa-solid fa-code"></i>
                      <span>Variáveis Disponíveis</span>
                    </div>
                    <div class="variables-grid">
                      <button v-for="variable in availableVariables" :key="variable.key"
                        @click="insertVariable('text', variable.key)" type="button" class="variable-btn"
                        :title="'Inserir ' + variable.label">
                        <i class="fa-solid fa-plus-circle"></i>
                        <span>{{ variable.label }}</span>
                      </button>
                    </div>
                    <small class="variables-hint">
                      <i class="fa-solid fa-lightbulb"></i>
                      Clique para inserir a variável na posição do cursor
                    </small>
                  </div>

                  <small style="color: #666; display: block; margin-top: 5px;">
                    <i class="fa-solid fa-info-circle"></i>
                    Clique nas variáveis acima para inseri-las no título
                  </small>
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label>Tamanho (px)</label>
                    <input type="number" v-model.number="components[selectedIndex].fontSize" class="form-input" min="12"
                      max="72" placeholder="32" />
                  </div>
                  <div class="form-group">
                    <label>Cor</label>
                    <input type="color" v-model="components[selectedIndex].color" class="form-color" />
                  </div>
                </div>
                <div class="form-group">
                  <label>Fonte</label>
                  <select v-model="components[selectedIndex].fontFamily" class="form-select">
                    <option value="Arial, sans-serif">Arial</option>
                    <option value="'Times New Roman', serif">Times New Roman</option>
                    <option value="'Courier New', monospace">Courier New</option>
                    <option value="Georgia, serif">Georgia</option>
                    <option value="Verdana, sans-serif">Verdana</option>
                    <option value="'Trebuchet MS', sans-serif">Trebuchet MS</option>
                    <option value="'Comic Sans MS', cursive">Comic Sans MS</option>
                    <option value="Impact, sans-serif">Impact</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Alinhamento</label>
                  <div class="align-buttons">
                    <button @click="components[selectedIndex].align = 'left'"
                      :class="{ active: components[selectedIndex].align === 'left' }" class="align-btn">
                      <i class="fas fa-align-left"></i>
                    </button>

                    <button @click="components[selectedIndex].align = 'center'"
                      :class="{ active: components[selectedIndex].align === 'center' }" class="align-btn">
                      <i class="fas fa-align-center"></i>
                    </button>

                    <button @click="components[selectedIndex].align = 'right'"
                      :class="{ active: components[selectedIndex].align === 'right' }" class="align-btn">
                      <i class="fas fa-align-right"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Editor da Imagem -->
              <div v-if="components[selectedIndex].type === 'image'" class="editor-form">
                <div class="form-group">
                  <label>Imagem</label>
                  <div class="upload-area" @click="triggerImageUpload(selectedIndex)">
                    <div v-if="!components[selectedIndex].src" class="upload-placeholder">
                      <span class="upload-icon"><i class="fa-solid fa-camera"></i></span>
                      <span>Clique para fazer upload</span>
                    </div>
                    <img v-else :src="components[selectedIndex].src" class="upload-preview" />
                  </div>
                </div>
                <div class="form-group">
                  <label>OU cole a URL da Imagem</label>
                  <input v-model="components[selectedIndex].src" class="form-input"
                    placeholder="https://exemplo.com/imagem.jpg" />
                </div>
                <!-- 🆕 BOTÃO DE REMOVER IMAGEM SIMPLES -->
                <div class="form-group" v-if="components[selectedIndex].src">
                  <button @click="removeSimpleImage(selectedIndex)" type="button" class="form-button"
                    style="width: 100%; padding: 12px; background: #dc3545; color: white; border: none; border-radius: 6px !important; cursor: pointer; font-weight: 600; display: flex; align-items: center; justify-content: center; gap: 8px;">
                    <i class="fa-solid fa-trash"></i>
                    Remover Imagem
                  </button>
                </div>
                <div class="form-group">
                  <label>Texto Alternativo</label>
                  <input v-model="components[selectedIndex].alt" class="form-input" placeholder="Descrição da imagem" />
                </div>
                <div class="form-group">
                  <label>Link (URL)</label>
                  <input v-model="components[selectedIndex].link" class="form-input"
                    placeholder="https://seusite.com" />
                </div>
                <!-- <div class="form-group">
                  <label>Abrir em</label>
                  <select v-model="components[selectedIndex].linkTarget" class="form-select">
                    <option value="_blank">Nova aba</option>
                    <option value="_self">Mesma aba</option>
                  </select>
                </div> -->
                <div class="form-group">
                  <label>Largura (%)</label>
                  <input type="range" v-model="components[selectedIndex].width" min="10" max="100" class="form-range" />
                  <span class="range-value">{{ components[selectedIndex].width }}%</span>
                </div>
                <div class="form-group">
                  <label>Alinhamento</label>
                  <div class="align-buttons">
                    <button @click="components[selectedIndex].align = 'left'"
                      :class="{ active: components[selectedIndex].align === 'left' }" class="align-btn">
                      <i class="fas fa-align-left"></i>
                    </button>

                    <button @click="components[selectedIndex].align = 'center'"
                      :class="{ active: components[selectedIndex].align === 'center' }" class="align-btn">
                      <i class="fas fa-align-center"></i>
                    </button>

                    <button @click="components[selectedIndex].align = 'right'"
                      :class="{ active: components[selectedIndex].align === 'right' }" class="align-btn">
                      <i class="fas fa-align-right"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Editor do Botão -->
              <div v-if="components[selectedIndex].type === 'button'" class="editor-form">
                <div class="form-group">
                  <label>Texto do Botão</label>
                  <input v-model="components[selectedIndex].text" class="form-input" placeholder="Clique aqui" />
                </div>
                <div class="form-group">
                  <label>Link (URL)</label>
                  <input v-model="components[selectedIndex].url" class="form-input" placeholder="https://seusite.com" />
                </div>

                <!-- 🆕 VARIÁVEIS PARA BOTÃO -->
                <div class="variables-container">
                  <div class="variables-header">
                    <i class="fa-solid fa-code"></i>
                    <span>Link de Pagamento</span>
                  </div>
                  <div class="variables-grid">
                    <button @click="insertVariableInButton('LINK_PAGAMENTO')" type="button" class="variable-btn"
                      title="Inserir Link de Pagamento">
                      <i class="fa-solid fa-plus-circle"></i>
                      <span>Link de Pagamento</span>
                    </button>
                  </div>
                  <small class="variables-hint">
                    <i class="fa-solid fa-lightbulb"></i>
                    Clique para inserir o link de pagamento no botão
                  </small>
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label>Cor de Fundo</label>
                    <input type="color" v-model="components[selectedIndex].bgColor" class="form-color" />
                  </div>
                  <div class="form-group">
                    <label>Cor do Texto</label>
                    <input type="color" v-model="components[selectedIndex].textColor" class="form-color" />
                  </div>
                </div>
                <div class="form-group">
                  <label>Alinhamento</label>
                  <div class="align-buttons">
                    <button @click="components[selectedIndex].align = 'left'"
                      :class="{ active: components[selectedIndex].align === 'left' }" class="align-btn">
                      <i class="fas fa-align-left"></i>
                    </button>

                    <button @click="components[selectedIndex].align = 'center'"
                      :class="{ active: components[selectedIndex].align === 'center' }" class="align-btn">
                      <i class="fas fa-align-center"></i>
                    </button>

                    <button @click="components[selectedIndex].align = 'right'"
                      :class="{ active: components[selectedIndex].align === 'right' }" class="align-btn">
                      <i class="fas fa-align-right"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Editor do Divisor -->
              <div v-if="components[selectedIndex].type === 'divider'" class="editor-form">
                <div class="form-row">
                  <div class="form-group">
                    <label>Cor</label>
                    <input type="color" v-model="components[selectedIndex].color" class="form-color" />
                  </div>
                  <div class="form-group">
                    <label>Espessura</label>
                    <input type="number" v-model.number="components[selectedIndex].thickness" class="form-input" min="1"
                      max="10" />
                  </div>
                </div>
                <div class="form-group">
                  <label>Estilo</label>
                  <select v-model="components[selectedIndex].style" class="form-select">
                    <option value="solid">Sólido</option>
                    <option value="dashed">Tracejado</option>
                    <option value="dotted">Pontilhado</option>
                  </select>
                </div>
              </div>

              <!-- Editor do Espaçador -->
              <div v-if="components[selectedIndex].type === 'spacer'" class="editor-form">
                <div class="form-group">
                  <label>Altura (px)</label>
                  <input type="range" v-model.number="components[selectedIndex].height" min="10" max="200"
                    class="form-range" />
                  <span class="range-value">{{ components[selectedIndex].height }}px</span>
                </div>
              </div>

              <!-- Editor do Vídeo -->
              <div v-if="components[selectedIndex].type === 'video'" class="editor-form">
                <div class="form-group">
                  <label>URL do Vídeo (YouTube ou Vimeo)</label>
                  <input v-model="components[selectedIndex].videoUrl" class="form-input"
                    placeholder="https://youtube.com/watch?v=..." />
                  <small>Cole o link do YouTube ou Vimeo</small>
                </div>

                <div class="form-group">
                  <label>Tamanho (%)</label>
                  <input type="range" v-model.number="components[selectedIndex].scale" min="30" max="100" step="1"
                    class="form-range" />
                  <span class="range-value">{{ components[selectedIndex].scale || 100 }}%</span>
                  <small style="display: block; margin-top: 5px; color: #666;">Controla largura e altura
                    proporcionalmente</small>
                </div>
              </div>

              <!-- Editor de Colunas
              <div v-if="components[selectedIndex].type === 'columns'" class="editor-form">
                <div class="form-group">
                  <label>Número de Colunas</label>
                  <select :value="components[selectedIndex].columnCount"
                    @change="updateColumns(selectedIndex, $event.target.value)" class="form-select">
                    <option value="2">2 Colunas</option>
                    <option value="3">3 Colunas</option>
                  </select>
                </div>
                <div v-for="(col, idx) in components[selectedIndex].columns" :key="idx" class="form-group">
                  <label>Coluna {{ idx + 1 }}</label>
                  <textarea v-model="components[selectedIndex].columns[idx].content" class="form-textarea" rows="3"
                    :placeholder="'Conteúdo da coluna ' + (idx + 1)"></textarea>
                </div>
              </div> -->

              <!-- Editor de Redes Sociais -->
              <div v-if="components[selectedIndex].type === 'social'" class="editor-form">
                <div class="form-group">
                  <label>Título (opcional)</label>
                  <input v-model="components[selectedIndex].title" class="form-input"
                    placeholder="Siga-nos nas redes sociais" />
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label>Cor do Título</label>
                    <input type="color" v-model="components[selectedIndex].titleColor" class="form-color" />
                  </div>
                  <div class="form-group">
                    <label>Cor de Fundo</label>
                    <input type="color" v-model="components[selectedIndex].bgColor" class="form-color" />
                  </div>
                </div>

                <div class="form-group">
                  <label>Fonte</label>
                  <select v-model="components[selectedIndex].fontFamily" class="form-select">
                    <option value="Arial, sans-serif">Arial</option>
                    <option value="'Times New Roman', serif">Times New Roman</option>
                    <option value="Georgia, serif">Georgia</option>
                    <option value="Verdana, sans-serif">Verdana</option>
                  </select>
                </div>

                <div class="form-group">
                  <label>Alinhamento</label>
                  <div class="align-buttons">
                    <button @click="components[selectedIndex].align = 'left'"
                      :class="{ active: components[selectedIndex].align === 'left' }" class="align-btn">
                      <i class="fas fa-align-left"></i>
                    </button>

                    <button @click="components[selectedIndex].align = 'center'"
                      :class="{ active: components[selectedIndex].align === 'center' }" class="align-btn">
                      <i class="fas fa-align-center"></i>
                    </button>

                    <button @click="components[selectedIndex].align = 'right'"
                      :class="{ active: components[selectedIndex].align === 'right' }" class="align-btn">
                      <i class="fas fa-align-right"></i>
                    </button>
                  </div>
                </div>

                <div class="section-title" style="margin-top: 20px; margin-bottom: 10px;">Estilo dos Ícones</div>

                <div class="form-group">
                  <label>Tamanho dos Ícones (px)</label>
                  <input type="range" v-model.number="components[selectedIndex].iconSize" min="30" max="80"
                    class="form-range" />
                  <span class="range-value">{{ components[selectedIndex].iconSize }}px</span>
                </div>

                <div class="form-group">
                  <label>Estilo dos Ícones</label>
                  <select v-model="components[selectedIndex].iconStyle" class="form-select">
                    <option value="square">Quadrado</option>
                    <option value="rounded">Arredondado</option>
                    <option value="circle">Círculo</option>
                  </select>
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label>Cor de Fundo do Ícone</label>
                    <input type="color" v-model="components[selectedIndex].iconBgColor" class="form-color" />
                  </div>
                  <div class="form-group">
                    <label>Cor da Borda</label>
                    <input type="color" v-model="components[selectedIndex].iconBorderColor" class="form-color" />
                  </div>
                </div>

                <div class="form-group">
                  <label>Espaçamento entre Ícones (px)</label>
                  <input type="range" v-model.number="components[selectedIndex].spacing" min="5" max="40"
                    class="form-range" />
                  <span class="range-value">{{ components[selectedIndex].spacing }}px</span>
                </div>

                <div class="form-group">
                  <label>
                    <input type="checkbox" v-model="components[selectedIndex].showShadow" />
                    Mostrar Sombra
                  </label>
                </div>

                <div class="section-title" style="margin-top: 20px; margin-bottom: 10px;">Links das Redes Sociais</div>

                <div class="form-group">
                  <label>Facebook</label>
                  <input v-model="components[selectedIndex].links.facebook" class="form-input"
                    placeholder="https://facebook.com/suaempresa" />
                </div>

                <div class="form-group">
                  <label>Instagram</label>
                  <input v-model="components[selectedIndex].links.instagram" class="form-input"
                    placeholder="https://instagram.com/suaempresa" />
                </div>

                <div class="form-group">
                  <label>Twitter / X</label>
                  <input v-model="components[selectedIndex].links.twitter" class="form-input"
                    placeholder="https://x.com/suaempresa" />
                </div>

                <div class="form-group">
                  <label>LinkedIn</label>
                  <input v-model="components[selectedIndex].links.linkedin" class="form-input"
                    placeholder="https://linkedin.com/company/suaempresa" />
                </div>

                <div class="form-group">
                  <label>YouTube</label>
                  <input v-model="components[selectedIndex].links.youtube" class="form-input"
                    placeholder="https://youtube.com/c/suaempresa" />
                </div>

                <div class="form-group">
                  <label>TikTok</label>
                  <input v-model="components[selectedIndex].links.tiktok" class="form-input"
                    placeholder="https://tiktok.com/@suaempresa" />
                </div>

                <div class="form-group">
                  <label>WhatsApp</label>
                  <input v-model="components[selectedIndex].links.whatsapp" class="form-input"
                    placeholder="https://wa.me/5511999999999" />
                </div>

                <div class="form-group">
                  <label>Telegram</label>
                  <input v-model="components[selectedIndex].links.telegram" class="form-input"
                    placeholder="https://t.me/suaempresa" />
                </div>
              </div>

              <!-- Editor do Footer -->
              <div v-if="components[selectedIndex].type === 'footer'" class="editor-form">
                <div class="form-group">
                  <label>Nome da Empresa</label>
                  <input v-model="components[selectedIndex].companyName" class="form-input" placeholder="Sua Empresa" />
                </div>

                <div class="form-group">
                  <label>Endereço</label>
                  <textarea v-model="components[selectedIndex].address" class="form-textarea" rows="3"
                    placeholder="Rua Exemplo, 123&#10;São Paulo, SP - Brasil"></textarea>
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label>Cor de Fundo</label>
                    <input type="color" v-model="components[selectedIndex].bgColor" class="form-color" />
                  </div>
                  <div class="form-group">
                    <label>Cor do Texto</label>
                    <input type="color" v-model="components[selectedIndex].textColor" class="form-color" />
                  </div>
                </div>

                <div class="form-group">
                  <label>Fonte</label>
                  <select v-model="components[selectedIndex].fontFamily" class="form-select">
                    <option value="Arial, sans-serif">Arial</option>
                    <option value="'Times New Roman', serif">Times New Roman</option>
                    <option value="Georgia, serif">Georgia</option>
                    <option value="Verdana, sans-serif">Verdana</option>
                  </select>
                </div>

                <div class="form-group">
                  <label>Alinhamento</label>
                  <div class="align-buttons">
                    <button @click="components[selectedIndex].align = 'left'"
                      :class="{ active: components[selectedIndex].align === 'left' }" class="align-btn">
                      <i class="fas fa-align-left"></i>
                    </button>

                    <button @click="components[selectedIndex].align = 'center'"
                      :class="{ active: components[selectedIndex].align === 'center' }" class="align-btn">
                      <i class="fas fa-align-center"></i>
                    </button>

                    <button @click="components[selectedIndex].align = 'right'"
                      :class="{ active: components[selectedIndex].align === 'right' }" class="align-btn">
                      <i class="fas fa-align-right"></i>
                    </button>
                  </div>
                </div>

                <div class="section-title" style="margin-top: 20px; margin-bottom: 10px;">Links Úteis</div>

                <div class="form-group">
                  <label>Política de Privacidade</label>
                  <input v-model="components[selectedIndex].usefulLinks.privacy" class="form-input"
                    placeholder="https://seusite.com/privacidade" />
                </div>

                <div class="form-group">
                  <label>Termos de Uso</label>
                  <input v-model="components[selectedIndex].usefulLinks.terms" class="form-input"
                    placeholder="https://seusite.com/termos" />
                </div>

                <!-- LINHA CORRIGIDA AQUI -->

                <div class="form-group">
                  <label>Texto Legal</label>
                  <textarea v-model="components[selectedIndex].legalText" class="form-textarea" rows="3"
                    placeholder="Informações sobre o recebimento do email..."></textarea>
                </div>

                <div class="form-group">
                  <label>Copyright</label>
                  <input v-model="components[selectedIndex].copyright" class="form-input"
                    placeholder="© 2025 Sua Empresa. Todos os direitos reservados." />
                </div>
              </div>

              <!-- Editor do Card -->
              <div v-if="components[selectedIndex].type === 'card'" class="editor-form">
                <div class="form-group">
                  <label>Layout</label>
                  <select :value="components[selectedIndex].layout"
                    @change="updateCardLayout(selectedIndex, $event.target.value)" class="form-select">
                    <option value="image-left">Imagem à Esquerda</option>
                    <option value="image-right">Imagem à Direita</option>
                    <option value="image-top">Imagem no Topo</option>
                    <option value="grid-2">Grade 2 Colunas</option>
                    <option value="grid-3">Grade 3 Colunas</option>
                    <option value="grid-4">Grade 4 Colunas</option>
                    <option value="banner">Banner Grande</option>
                  </select>
                </div>

                <!-- Controles para layouts com imagem única -->
                <div
                  v-if="['image-left', 'image-right', 'image-top', 'banner'].includes(components[selectedIndex].layout)">
                  <div class="section-title" style="margin-top: 20px;">Imagem</div>

                  <div class="form-group">
                    <label>Imagem</label>
                    <div class="upload-area" @click="triggerCardImageUpload(selectedIndex)">
                      <div v-if="!components[selectedIndex].imageUrl" class="upload-placeholder">
                        <span class="upload-icon"><i class="fa-solid fa-camera"></i></span>
                        <span>Clique para fazer upload</span>
                      </div>
                      <img v-else :src="components[selectedIndex].imageUrl" class="upload-preview" />
                    </div>
                  </div>

                  <div class="form-group">
                    <label>OU cole a URL da Imagem</label>
                    <input v-model="components[selectedIndex].imageUrl" class="form-input"
                      placeholder="https://exemplo.com/imagem.jpg" />
                  </div>

                  <div class="form-group">
                    <label>Texto Alternativo</label>
                    <input v-model="components[selectedIndex].imageAlt" class="form-input"
                      placeholder="Descrição da imagem" />
                  </div>

                  <!-- Para layouts com imagem única (left, right, top, banner) -->
                  <div class="form-group" v-if="components[selectedIndex].imageUrl" style="display: flex; gap: 10px;">
                    <!-- Botão de Editar -->
                    <button @click.stop="startImageEdit(selectedIndex)" type="button" class="form-button"
                      style="flex: 1; padding: 12px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; border: none; border-radius: 6px !important; cursor: pointer; font-weight: 600; display: flex; align-items: center; justify-content: center; gap: 8px; transition: all 0.2s;">
                      <i class="fa-solid fa-up-down-left-right"></i>
                      Ajustar Posição e Zoom
                    </button>

                    <!-- 🆕 BOTÃO DE REMOVER -->
                    <button @click.stop="removeCardImage(selectedIndex)" type="button" class="form-button"
                      style="padding: 12px 16px; background: #dc3545; color: white; border: none; border-radius: 6px !important; cursor: pointer; font-weight: 600; display: flex; align-items: center; justify-content: center; gap: 8px; transition: all 0.2s;"
                      title="Remover Imagem">
                      <i class="fa-solid fa-trash"></i>Remover Imagem
                    </button>
                  </div>

                  <!-- Posição Manual (opcional)
                  <div class="form-group">
                    <label>Posição da Imagem (Manual)</label>
                    <select v-model="components[selectedIndex].imagePosition" class="form-select">
                      <option value="center">Centro</option>
                      <option value="top">Topo</option>
                      <option value="bottom">Baixo</option>
                      <option value="left">Esquerda</option>
                      <option value="right">Direita</option>
                      <option value="top left">Topo Esquerda</option>
                      <option value="top right">Topo Direita</option>
                      <option value="bottom left">Baixo Esquerda</option>
                      <option value="bottom right">Baixo Direita</option>
                    </select>
                    <small>Ou use o botão acima para ajustar visualmente</small>
                  </div> -->

                  <!-- Largura para layouts laterais -->
                  <div v-if="['image-left', 'image-right'].includes(components[selectedIndex].layout)"
                    class="form-group">
                    <label>Largura da Imagem (%)</label>
                    <input type="range" v-model.number="components[selectedIndex].imageWidth" min="20" max="60"
                      class="form-range" />
                    <span class="range-value">{{ components[selectedIndex].imageWidth }}%</span>
                  </div>

                  <!-- Altura para image-top -->
                  <div v-if="components[selectedIndex].layout === 'image-top'" class="form-group">
                    <label>Altura da Imagem (px)</label>
                    <input type="range" v-model.number="components[selectedIndex].imageHeight" min="150" max="400"
                      class="form-range" />
                    <span class="range-value">{{ components[selectedIndex].imageHeight }}px</span>
                  </div>

                  <!-- Controles específicos do Banner -->
                  <div v-if="components[selectedIndex].layout === 'banner'">
                    <div class="form-group">
                      <label>Altura do Banner (px)</label>
                      <input type="range" v-model.number="components[selectedIndex].bannerHeight" min="250" max="600"
                        class="form-range" />
                      <span class="range-value">{{ components[selectedIndex].bannerHeight }}px</span>
                    </div>

                    <div class="form-group">
                      <label>Opacidade do Overlay</label>
                      <input type="range" v-model.number="components[selectedIndex].overlayOpacity" min="0" max="0.8"
                        step="0.1" class="form-range" />
                      <span class="range-value">{{ Math.round(components[selectedIndex].overlayOpacity * 100) }}%</span>
                    </div>
                  </div>
                </div>

                <!-- Controles para grid -->
                <div v-if="['grid-2', 'grid-3', 'grid-4'].includes(components[selectedIndex].layout)">
                  <div class="section-title" style="margin-top: 20px;">Itens da Grade</div>

                  <div class="form-group">
                    <label>Altura das Imagens (px)</label>
                    <input type="range" v-model.number="components[selectedIndex].gridImageHeight" min="120" max="300"
                      class="form-range" />
                    <span class="range-value">{{ components[selectedIndex].gridImageHeight }}px</span>
                  </div>

                  <div v-for="(item, idx) in getGridItemsForLayout(selectedIndex)" :key="idx"
                    style="border: 0px solid #e0e0e0; padding: 15px; margin-bottom: 15px; border-radius: 8px; background: #f9f9f9;">
                    <div
                      style="font-weight: bold; margin-bottom: 10px; display: flex; justify-content: space-between; align-items: center;">
                      <span><i class="fa-solid fa-grip-vertical"></i> Item {{ idx + 1 }}</span>
                    </div>

                    <!-- Upload de Imagem -->
                    <div class="form-group">
                      <label>Imagem</label>
                      <div class="upload-area" @click="triggerGridImageUpload(selectedIndex, idx)"
                        style="cursor: pointer;">
                        <div v-if="!item.imageUrl" class="upload-placeholder">
                          <span class="upload-icon"><i class="fa-solid fa-camera"></i></span>
                          <span>Clique para upload</span>
                        </div>
                        <img v-else :src="item.imageUrl" class="upload-preview"
                          style="max-width: 100%; max-height: 150px; border-radius: 4px;" />
                      </div>
                    </div>

                    <div class="form-group">
                      <label>OU URL da Imagem</label>
                      <input v-model="item.imageUrl" class="form-input" placeholder="URL da imagem" />
                    </div>

                    <!-- Botões de Edição para Grid Items - ATUALIZADO -->
                    <div class="form-group" v-if="item.imageUrl" style="display: flex; gap: 8px;">
                      <!-- Botão de Editar Inline -->
                      <button @click="startImageEdit(selectedIndex, idx)" type="button" class="form-button"
                        style="flex: 1; padding: 10px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; border: none; border-radius: 6px !important; cursor: pointer; font-weight: 600; display: flex; align-items: center; justify-content: center; gap: 6px; font-size: 13px; transition: all 0.2s;">
                        <i class="fa-solid fa-up-down-left-right"></i>
                        Ajustar Imagem
                      </button>

                      <!-- 🆕 BOTÃO DE REMOVER -->
                      <button @click="removeCardImage(selectedIndex, idx)" type="button" class="form-button"
                        style="padding: 10px 12px; background: #dc3545; color: white; border: none; border-radius: 6px !important; cursor: pointer; font-weight: 600; display: flex; align-items: center; justify-content: center; gap: 6px; font-size: 13px; transition: all 0.2s;">
                        <i class="fa-solid fa-trash"></i>Remover Imagem
                      </button>
                    </div>
                    <!-- Posição Manual do Grid -->
                    <!-- <div class="form-group">
                      <label>Posição da Imagem (Manual)</label>
                      <select v-model="item.imagePosition" class="form-select">
                        <option value="center">Centro</option>
                        <option value="top">Topo</option>
                        <option value="bottom">Baixo</option>
                        <option value="left">Esquerda</option>
                        <option value="right">Direita</option>
                      </select>
                      <small>Ou use o botão acima para ajustar visualmente</small>
                    </div> -->

                    <div class="form-group">
                      <label>Título</label>
                      <input v-model="item.title" class="form-input" placeholder="Título" />
                    </div>

                    <div class="form-group">
                      <label>Descrição</label>
                      <textarea v-model="item.description" class="form-textarea" rows="2"
                        placeholder="Descrição"></textarea>
                    </div>

                    <div class="form-group">
                      <label>Link do Botão</label>
                      <input v-model="item.buttonUrl" class="form-input" placeholder="#" />
                    </div>
                  </div>
                </div>

                <!-- Título (comum a todos os layouts) -->
                <div class="section-title" style="margin-top: 20px;">Título</div>

                <div class="form-group">
                  <label>Título</label>
                  <input v-model="components[selectedIndex].title" class="form-input" placeholder="Título do card" />
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label>Tamanho (px)</label>
                    <input type="number" v-model.number="components[selectedIndex].titleSize" class="form-input"
                      min="14" max="48" />
                  </div>
                  <div class="form-group">
                    <label>Cor</label>
                    <input type="color" v-model="components[selectedIndex].titleColor" class="form-color" />
                  </div>
                </div>

                <div class="form-group">
                  <label>Alinhamento do Título</label>
                  <div class="align-buttons">
                    <button @click="components[selectedIndex].titleAlign = 'left'"
                      :class="{ active: components[selectedIndex].titleAlign === 'left' }" class="align-btn">
                      <i class="fas fa-align-left"></i>
                    </button>
                    <button @click="components[selectedIndex].titleAlign = 'center'"
                      :class="{ active: components[selectedIndex].titleAlign === 'center' }" class="align-btn">
                      <i class="fas fa-align-center"></i>
                    </button>
                    <button @click="components[selectedIndex].titleAlign = 'right'"
                      :class="{ active: components[selectedIndex].titleAlign === 'right' }" class="align-btn">
                      <i class="fas fa-align-right"></i>
                    </button>
                  </div>
                </div>

                <!-- Descrição (oculta no grid) -->
                <div v-if="!['grid-2', 'grid-3', 'grid-4'].includes(components[selectedIndex].layout)">
                  <div class="section-title" style="margin-top: 20px;">Descrição</div>

                  <div class="form-group">
                    <label>Descrição</label>
                    <textarea v-model="components[selectedIndex].description" class="form-textarea" rows="4"
                      placeholder="Descrição do card..."></textarea>
                  </div>

                  <div class="form-row">
                    <div class="form-group">
                      <label>Tamanho (px)</label>
                      <input type="number" v-model.number="components[selectedIndex].descriptionSize" class="form-input"
                        min="10" max="24" />
                    </div>
                    <div class="form-group">
                      <label>Cor</label>
                      <input type="color" v-model="components[selectedIndex].descriptionColor" class="form-color" />
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Alinhamento da Descrição</label>
                    <div class="align-buttons">
                      <button @click="components[selectedIndex].descriptionAlign = 'left'"
                        :class="{ active: components[selectedIndex].descriptionAlign === 'left' }" class="align-btn">
                        <i class="fas fa-align-left"></i>
                      </button>
                      <button @click="components[selectedIndex].descriptionAlign = 'center'"
                        :class="{ active: components[selectedIndex].descriptionAlign === 'center' }" class="align-btn">
                        <i class="fas fa-align-center"></i>
                      </button>
                      <button @click="components[selectedIndex].descriptionAlign = 'right'"
                        :class="{ active: components[selectedIndex].descriptionAlign === 'right' }" class="align-btn">
                        <i class="fas fa-align-right"></i>
                      </button>
                      <button @click="components[selectedIndex].descriptionAlign = 'justify'"
                        :class="{ active: components[selectedIndex].descriptionAlign === 'justify' }" class="align-btn">
                        <i class="fas fa-align-justify"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Botão -->
                <div class="section-title" style="margin-top: 20px;">Botão</div>

                <div class="form-group">
                  <label>
                    <input type="checkbox" v-model="components[selectedIndex].showButton" />
                    Mostrar Botão
                  </label>
                </div>

                <div v-if="components[selectedIndex].showButton">
                  <div class="form-group">
                    <label>Texto do Botão</label>
                    <input v-model="components[selectedIndex].buttonText" class="form-input" placeholder="Saiba Mais" />
                  </div>

                  <div v-if="!['grid-2', 'grid-3', 'grid-4'].includes(components[selectedIndex].layout)"
                    class="form-group">
                    <label>Link do Botão</label>
                    <input v-model="components[selectedIndex].buttonUrl" class="form-input"
                      placeholder="https://seusite.com" />
                  </div>

                  <div class="form-row">
                    <div class="form-group">
                      <label>Cor de Fundo</label>
                      <input type="color" v-model="components[selectedIndex].buttonBgColor" class="form-color" />
                    </div>
                    <div class="form-group">
                      <label>Cor do Texto</label>
                      <input type="color" v-model="components[selectedIndex].buttonTextColor" class="form-color" />
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Alinhamento do Botão</label>
                    <div class="align-buttons">
                      <button @click="components[selectedIndex].buttonAlign = 'left'"
                        :class="{ active: components[selectedIndex].buttonAlign === 'left' }" class="align-btn">
                        <i class="fas fa-align-left"></i>
                      </button>
                      <button @click="components[selectedIndex].buttonAlign = 'center'"
                        :class="{ active: components[selectedIndex].buttonAlign === 'center' }" class="align-btn">
                        <i class="fas fa-align-center"></i>
                      </button>
                      <button @click="components[selectedIndex].buttonAlign = 'right'"
                        :class="{ active: components[selectedIndex].buttonAlign === 'right' }" class="align-btn">
                        <i class="fas fa-align-right"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Estilo do Card -->
                <div class="section-title" style="margin-top: 20px;">Estilo do Card</div>

                <!-- Estilo da Imagem - NOVO -->
                <div class="section-title" style="margin-top: 20px;">Estilo da Imagem</div>

                <div class="form-group">
                  <label>Arredondamento da Imagem (px)</label>
                  <input type="range" v-model.number="components[selectedIndex].imageRadius" min="0" max="500"
                    class="form-range" />
                  <span class="range-value">{{ components[selectedIndex].imageRadius }}px</span>
                  <small style="display: block; margin-top: 5px; color: #666;">
                    💡 Dica: Use 500px para imagem circular
                  </small>
                </div>

                <!-- Espaçamento entre Imagem e Conteúdo - NOVO -->
                <div class="section-title" style="margin-top: 20px;">Espaçamentos</div>

                <div v-if="!['grid-2', 'grid-3', 'grid-4'].includes(components[selectedIndex].layout)"
                  class="form-group">
                  <label>Espaço entre Imagem e Conteúdo (px)</label>
                  <input type="range" v-model.number="components[selectedIndex].imageGap" min="10" max="60"
                    class="form-range" />
                  <span class="range-value">{{ components[selectedIndex].imageGap }}px</span>
                </div>

                <div v-if="['grid-2', 'grid-3', 'grid-4'].includes(components[selectedIndex].layout)"
                  class="form-group">
                  <label>Espaço entre Cards da Grade (px)</label>
                  <input type="range" v-model.number="components[selectedIndex].gridGap" min="10" max="60"
                    class="form-range" />
                  <span class="range-value">{{ components[selectedIndex].gridGap }}px</span>
                </div>

                <div class="form-group">
                  <label>Cor de Fundo</label>
                  <input type="color" v-model="components[selectedIndex].backgroundColor" class="form-color" />
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label>Cor da Borda</label>
                    <input type="color" v-model="components[selectedIndex].borderColor" class="form-color" />
                  </div>
                  <div class="form-group">
                    <label>Espessura da Borda (px)</label>
                    <input type="number" v-model.number="components[selectedIndex].borderWidth" class="form-input"
                      min="0" max="5" />
                  </div>
                </div>

                <div class="form-group">
                  <label>Arredondamento (px)</label>
                  <input type="range" v-model.number="components[selectedIndex].borderRadius" min="0" max="30"
                    class="form-range" />
                  <span class="range-value">{{ components[selectedIndex].borderRadius }}px</span>
                </div>

                <div class="form-group">
                  <label>Espaçamento Interno (px)</label>
                  <input type="range" v-model.number="components[selectedIndex].padding" min="10" max="50"
                    class="form-range" />
                  <span class="range-value">{{ components[selectedIndex].padding }}px</span>
                </div>

                <div class="form-group">
                  <label>Fonte</label>
                  <select v-model="components[selectedIndex].fontFamily" class="form-select">
                    <option value="Arial, sans-serif">Arial</option>
                    <option value="'Times New Roman', serif">Times New Roman</option>
                    <option value="Georgia, serif">Georgia</option>
                    <option value="Verdana, sans-serif">Verdana</option>
                    <option value="'Trebuchet MS', sans-serif">Trebuchet MS</option>
                  </select>
                </div>
              </div>

            </div>
            <div v-else class="empty-edit">
              <p>Selecione um bloco no email para editar</p>
            </div>
          </div>

          <!-- Aba Configurações -->
          <div v-show="activeTab === 'settings'" class="settings-tab">
            <div class="editor-form">
              <div class="form-group">
                <label>Cor de Fundo</label>
                <input type="color" v-model="globalSettings.backgroundColor" class="form-color" />
              </div>
              <div class="form-group">
                <label>Largura Máxima</label>
                <select v-model="globalSettings.maxWidth" class="form-select">
                  <option value="800px">800px (Padrão)</option>
                  <option value="700px">700px</option>
                  <option value="100%">100%</option>
                </select>
              </div>
              <div class="form-group">
                <label>Espaçamento Interno</label>
                <input type="range" v-model.number="globalSettings.padding" min="0" max="100" class="form-range" />
                <span class="range-value">{{ globalSettings.padding }}px</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Canvas Central -->
      <div class="canvas-panel">
        <div class="canvas-container" :class="{ 'mobile-view': currentDevice === 'mobile' }">
          <div class="email-canvas" :style="canvasStyle" @dragover.prevent @drop="handleDrop">
            <!-- Componentes -->
            <div v-for="(component, index) in components" :key="component.id" class="canvas-block" :class="{
              'selected': selectedIndex === index,
              'hover': hoverIndex === index
            }" @click="selectBlock(index)" @mouseenter="hoverIndex = index" @mouseleave="hoverIndex = null">
              <!-- Mini Toolbar -->
              <div v-if="selectedIndex === index" class="mini-toolbar">
                <button @click.stop="moveUp(index)" :disabled="index === 0" class="mini-btn" title="Mover para cima"><i
                    class="fa-solid fa-arrow-up"></i></button>
                <button @click.stop="moveDown(index)" :disabled="index === components.length - 1" class="mini-btn"
                  title="Mover para baixo"><i class="fa-solid fa-arrow-down"></i></button>
                <button @click.stop="duplicateBlock(index)" class="mini-btn" title="Duplicar"><i
                    class="fa-solid fa-clone"></i></button>
                <button @click.stop="confirmDelete(index)" class="mini-btn mini-delete" title="Excluir"><i
                    class="fa-solid fa-trash"></i></button>
              </div>

              <!-- Renderizar Bloco -->
              <component :is="getComponentType(component.type)" :data="component"
                :key="'comp-' + component.id + '-' + updateTrigger" />
            </div>

            <!-- Estado Vazio -->
            <div v-if="components.length === 0" class="empty-canvas">
              <div class="empty-icon"><i class="fa-solid fa-envelope"></i></div>
              <h3>Arraste blocos aqui</h3>
              <p>Comece criando seu email</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Overlay de Edição Inline MELHORADO E SINCRONIZADO -->
      <div v-if="editingImage.active" class="image-edit-overlay-improved">
        <div class="image-edit-modal-wide">
          <!-- Header -->
          <div class="edit-modal-header">
            <h3>
              <i class="fa-solid fa-image"></i>
              Ajustar Posição e Zoom da Imagem
            </h3>
            <button @click="stopImageEdit" class="btn-close-edit">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>

          <!-- Body com 2 colunas -->
          <div class="edit-modal-body-split">
            <!-- COLUNA ESQUERDA: Editor -->
            <div class="edit-column">
              <h4 class="column-title">
                <i class="fa-solid fa-hand-pointer"></i>
                Editor - Arraste e ajuste
              </h4>

              <!-- Viewport REAL do card/banner -->
              <div class="image-viewport-real" ref="imageViewport" @mousedown="onImageMouseDown"
                @wheel.prevent="onImageWheel">

                <!-- Preview em tamanho real do layout -->
                <!-- Layout: Banner -->
                <div v-if="getEditingLayout() === 'banner'" class="editor-preview-banner" :style="{
                  height: getEditingComponent().bannerHeight + 'px',
                  borderRadius: (getEditingComponent().imageRadius || 8) + 'px'
                }">
                  <div class="editor-image-container">
                    <img :src="getEditingImageUrl()" :style="getEditorImageStyle()" draggable="false" />
                  </div>

                  <div class="editor-banner-overlay" :style="{
                    background: 'rgba(0,0,0,' + getEditingComponent().overlayOpacity + ')',
                    borderRadius: (getEditingComponent().imageRadius || 8) + 'px'
                  }">
                    <h2 style="color: white; font-size: 28px; margin: 0 0 10px 0;">{{ getEditingComponent().title }}
                    </h2>
                    <p style="color: white; font-size: 14px; margin: 0;">{{ getEditingComponent().description }}</p>
                  </div>
                </div>

                <!-- Layout: Image Left -->
                <div v-else-if="getEditingLayout() === 'image-left'" class="editor-preview-horizontal"
                  :style="{ gap: (getEditingComponent().imageGap || 20) + 'px' }">
                  <div class="editor-image-container" :style="{
                    flex: '0 0 ' + getEditingComponent().imageWidth + '%',
                    borderRadius: (getEditingComponent().imageRadius || 8) + 'px'
                  }">
                    <img :src="getEditingImageUrl()" :style="getEditorImageStyle()" draggable="false" />
                  </div>
                  <div class="editor-content-preview">
                    <h3>{{ getEditingComponent().title }}</h3>
                    <p>{{ getEditingComponent().description }}</p>
                  </div>
                </div>

                <!-- Layout: Image Right -->
                <div v-else-if="getEditingLayout() === 'image-right'" class="editor-preview-horizontal reverse"
                  :style="{ gap: (getEditingComponent().imageGap || 20) + 'px' }">
                  <div class="editor-content-preview">
                    <h3>{{ getEditingComponent().title }}</h3>
                    <p>{{ getEditingComponent().description }}</p>
                  </div>
                  <div class="editor-image-container" :style="{
                    flex: '0 0 ' + getEditingComponent().imageWidth + '%',
                    borderRadius: (getEditingComponent().imageRadius || 8) + 'px'
                  }">
                    <img :src="getEditingImageUrl()" :style="getEditorImageStyle()" draggable="false" />
                  </div>
                </div>

                <!-- Layout: Image Top -->
                <div v-else-if="getEditingLayout() === 'image-top'" class="editor-preview-vertical">
                  <div class="editor-image-container" :style="{
                    height: getEditingComponent().imageHeight + 'px',
                    borderRadius: (getEditingComponent().imageRadius || 8) + 'px',
                    marginBottom: (getEditingComponent().imageGap || 20) + 'px'
                  }">
                    <img :src="getEditingImageUrl()" :style="getEditorImageStyle()" draggable="false" />
                  </div>
                  <div class="editor-content-preview">
                    <h3>{{ getEditingComponent().title }}</h3>
                    <p>{{ getEditingComponent().description }}</p>
                  </div>
                </div>

                <!-- Layout: Grid -->
                <div v-else-if="getEditingLayout().startsWith('grid')" class="editor-preview-grid">
                  <div class="editor-image-container" :style="{
                    height: getEditingComponent().gridImageHeight + 'px',
                    borderRadius: (getEditingComponent().imageRadius || 8) + 'px'
                  }">
                    <img :src="getEditingImageUrl()" :style="getEditorImageStyle()" draggable="false" />
                  </div>
                  <div class="editor-content-preview">
                    <h4>{{ getEditingGridItem().title }}</h4>
                    <p>{{ getEditingGridItem().description }}</p>
                  </div>
                </div>

                <!-- Grid de guia -->
                <div class="viewport-grid">
                  <div class="grid-line vertical" style="left: 50%"></div>
                  <div class="grid-line horizontal" style="top: 50%"></div>
                </div>

                <!-- Indicador de centro -->
                <div class="center-indicator">
                  <i class="fa-solid fa-crosshairs"></i>
                </div>
              </div>

              <p class="edit-hint">
                <i class="fa-solid fa-hand-pointer"></i> Clique e arraste para mover &nbsp;|&nbsp;
                <i class="fa-solid fa-computer-mouse"></i> Scroll do mouse para zoom
              </p>
            </div>

            <!-- COLUNA DIREITA: Preview Final -->
            <div class="preview-column">
              <h4 class="column-title">
                <i class="fa-solid fa-eye"></i>
                Preview Final - Como ficará no email
              </h4>

              <!-- Preview do Banner/Card FINAL -->
              <div class="real-preview-container">
                <div v-if="getEditingLayout() === 'banner'" class="preview-banner" :style="getPreviewBannerStyle()">
                  <img :src="getEditingImageUrl()" :style="getPreviewImageStyle()" class="preview-image" />
                  <div class="banner-overlay" :style="getBannerOverlayStyle()">
                    <h2 class="banner-title">{{ getEditingComponent().title }}</h2>
                    <p class="banner-description">{{ getEditingComponent().description }}</p>
                    <div v-if="getEditingComponent().showButton" class="banner-button-preview">
                      <a
                        :style="{ display: 'inline-block', padding: '14px 32px', background: getEditingComponent().buttonBgColor, color: getEditingComponent().buttonTextColor, textDecoration: 'none', borderRadius: '6px', fontWeight: '600' }">
                        {{ getEditingComponent().buttonText }}
                      </a>
                    </div>
                  </div>
                </div>

                <div v-else-if="getEditingLayout() === 'image-left'" class="preview-card-horizontal">
                  <div class="preview-image-container"
                    :style="{ flex: '0 0 ' + getEditingComponent().imageWidth + '%' }">
                    <img :src="getEditingImageUrl()" :style="getPreviewImageStyle()" class="preview-image" />
                  </div>
                  <div class="preview-content">
                    <h3>{{ getEditingComponent().title }}</h3>
                    <p>{{ getEditingComponent().description }}</p>
                    <div v-if="getEditingComponent().showButton" class="preview-button-container">
                      <a
                        :style="{ display: 'inline-block', padding: '10px 24px', background: getEditingComponent().buttonBgColor, color: getEditingComponent().buttonTextColor, textDecoration: 'none', borderRadius: '6px', fontWeight: '600' }">
                        {{ getEditingComponent().buttonText }}
                      </a>
                    </div>
                  </div>
                </div>

                <div v-else-if="getEditingLayout() === 'image-right'" class="preview-card-horizontal reverse">
                  <div class="preview-content">
                    <h3>{{ getEditingComponent().title }}</h3>
                    <p>{{ getEditingComponent().description }}</p>
                    <div v-if="getEditingComponent().showButton" class="preview-button-container">
                      <a
                        :style="{ display: 'inline-block', padding: '10px 24px', background: getEditingComponent().buttonBgColor, color: getEditingComponent().buttonTextColor, textDecoration: 'none', borderRadius: '6px', fontWeight: '600' }">
                        {{ getEditingComponent().buttonText }}
                      </a>
                    </div>
                  </div>
                  <div class="preview-image-container"
                    :style="{ flex: '0 0 ' + getEditingComponent().imageWidth + '%' }">
                    <img :src="getEditingImageUrl()" :style="getPreviewImageStyle()" class="preview-image" />
                  </div>
                </div>

                <div v-else-if="getEditingLayout() === 'image-top'" class="preview-card-vertical">
                  <div class="preview-image-container" :style="{ height: getEditingComponent().imageHeight + 'px' }">
                    <img :src="getEditingImageUrl()" :style="getPreviewImageStyle()" class="preview-image" />
                  </div>
                  <div class="preview-content">
                    <h3>{{ getEditingComponent().title }}</h3>
                    <p>{{ getEditingComponent().description }}</p>
                    <div v-if="getEditingComponent().showButton" class="preview-button-container">
                      <a
                        :style="{ display: 'inline-block', padding: '10px 24px', background: getEditingComponent().buttonBgColor, color: getEditingComponent().buttonTextColor, textDecoration: 'none', borderRadius: '6px', fontWeight: '600' }">
                        {{ getEditingComponent().buttonText }}
                      </a>
                    </div>
                  </div>
                </div>

                <div v-else-if="getEditingLayout().startsWith('grid')" class="preview-grid-item">
                  <div class="preview-image-container"
                    :style="{ height: getEditingComponent().gridImageHeight + 'px' }">
                    <img :src="getEditingImageUrl()" :style="getPreviewImageStyle()" class="preview-image" />
                  </div>
                  <div class="preview-content">
                    <h4>{{ getEditingGridItem().title }}</h4>
                    <p>{{ getEditingGridItem().description }}</p>
                  </div>
                </div>
              </div>

              <!-- Info da posição -->
              <div class="position-info">
                <div class="info-item">
                  <span class="info-label">Horizontal</span>
                  <span class="info-value">{{ editingImage.offsetX.toFixed(0) }}%</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Vertical</span>
                  <span class="info-value">{{ editingImage.offsetY.toFixed(0) }}%</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Zoom</span>
                  <span class="info-value">{{ (editingImage.zoom * 100).toFixed(0) }}%</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Controles -->
          <div class="edit-modal-footer">
            <!-- Controles de Zoom -->
            <div class="zoom-control-group">
              <label>Zoom</label>
              <div class="zoom-buttons">
                <button @click="decreaseZoom" class="zoom-btn" :disabled="editingImage.zoom <= editingImage.minZoom">
                  <i class="fa-solid fa-minus"></i>
                </button>
                <input type="range" v-model.number="editingImage.zoom" :min="editingImage.minZoom"
                  :max="editingImage.maxZoom" step="0.1" @input="updateImagePositionRealtime" class="zoom-slider" />
                <button @click="increaseZoom" class="zoom-btn" :disabled="editingImage.zoom >= editingImage.maxZoom">
                  <i class="fa-solid fa-plus"></i>
                </button>
                <span class="zoom-value">{{ (editingImage.zoom * 100).toFixed(0) }}%</span>
              </div>
            </div>

            <!-- Botões de ação -->
            <div class="action-buttons">
              <button @click="resetImageEdit" class="btn-reset">
                <i class="fa-solid fa-rotate-left"></i>
                Resetar
              </button>
              <button @click="stopImageEdit" class="btn-save">
                <i class="fa-solid fa-check"></i>
                Aplicar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Preview ATUALIZADO -->
    <div v-if="showPreview" class="modal-overlay" @click.self="showPreview = false">
      <div class="modal-box-preview preview-modal">
        <div class="preview-header">
          <h2>Preview do Email</h2>
          <div style="display: flex; gap: 10px;">
            <button @click="showPreview = false" class="btn-close"><i class="fa-solid fa-xmark"></i></button>
          </div>
        </div>

        <!-- Toggle Desktop/Mobile -->
        <div class="preview-toggle-wrapper">
          <div class="toggle-buttons">
            <button @click="previewMode = 'desktop'" :class="['toggle-btn', { active: previewMode === 'desktop' }]">
              <i class="fa-solid fa-desktop"></i>
            </button>
            <button @click="previewMode = 'mobile'" :class="['toggle-btn', { active: previewMode === 'mobile' }]">
              <i class="fa-solid fa-mobile-screen"></i>
            </button>
          </div>
          <div class="width-indicator">
            {{ previewMode === 'desktop' ? '100%' : '400px' }}
          </div>
          <button @click="openSendTestModal" class="btn btn-primary" type="button"
            style="padding: 8px 16px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; border: none; border-radius: 6px !important; cursor: pointer; font-size: 14px; display: flex; align-items: center; gap: 8px;">
            <i class="fa-solid fa-paper-plane"></i>
            Enviar Teste
          </button>
        </div>

        <!-- Preview Content com iframe -->
        <div class="preview-content-wrapper">
          <div :class="['iframe-container', previewMode]">
            <iframe ref="previewIframe" :srcdoc="generateHTML('preview')" class="preview-iframe" frameborder="0"
              scrolling="no" @load="adjustIframeHeight"></iframe>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Envio de Teste -->
    <transition name="fade">
      <div v-if="showSendTestModal" class="test-modal-wrapper">
        <div class="test-modal-overlay" @click="showSendTestModal = false"></div>
        <div class="test-modal-container">
          <div class="test-modal-header">
            <h3>
              <i class="fa-solid fa-flask"></i>
              Enviar Email de Teste
            </h3>
            <button @click.stop="showSendTestModal = false" type="button" class="test-close-btn">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>

          <div class="test-modal-body">
            <!-- Passo 1: Buscar Contato -->
            <div class="test-section">
              <label class="test-label">
                <i class="fa-solid fa-search"></i>
                1. Buscar Contato por Email
              </label>
              <div class="search-container">
                <input v-model="searchEmail" type="email" class="test-input" placeholder="Digite o email do contato..."
                  @keyup.enter="searchContacts" />
                <button @click="searchContacts" :disabled="searchingContacts || !searchEmail" class="btn-search">
                  <i v-if="searchingContacts" class="fa-solid fa-spinner fa-spin"></i>
                  <i v-else class="fa-solid fa-search"></i>
                  Buscar
                </button>
              </div>
            </div>

            <!-- Lista de Contatos Encontrados -->
            <div v-if="foundContacts.length > 0" class="test-section">
              <label class="test-label">
                <i class="fa-solid fa-users"></i>
                2. Selecione o Contato ({{ foundContacts.length }} encontrado{{ foundContacts.length > 1 ? 's' : '' }})
              </label>
              <div class="contacts-list">
                <div v-for="contato in foundContacts" :key="contato.id" @click="selectContato(contato)"
                  :class="['contact-card', { 'selected': selectedContato?.id === contato.id }]">
                  <div class="contact-info">
                    <div class="contact-name">
                      <i class="fa-solid fa-user"></i>
                      {{ contato.nome }}
                    </div>
                    <div class="contact-details">
                      <span class="contact-cpd">
                        <i class="fa-solid fa-hashtag"></i>
                        CPD: {{ contato.cpd || 'N/A' }}
                      </span>
                      <span class="contact-email">
                        <i class="fa-solid fa-envelope"></i>
                        {{ contato.email }}
                      </span>
                      <span class="contact-date">
                        <i class="fa-solid fa-calendar"></i>
                        {{ formatDate(contato.created_at) }}
                      </span>
                    </div>
                  </div>
                  <div class="contact-check">
                    <i v-if="selectedContato?.id === contato.id" class="fa-solid fa-check-circle"></i>
                  </div>
                </div>
              </div>
            </div>

            <!-- Preview dos Parâmetros -->
            <div v-if="selectedContato && contatoData" class="test-section">
              <label class="test-label">
                <i class="fa-solid fa-code"></i>
                3. Parâmetros que serão usados
              </label>
              <div class="params-preview">
                <div class="param-item" v-for="(value, key) in previewParams" :key="key">
                  <span class="param-key">{{ key }}:</span>
                  <span class="param-value">{{ value }}</span>
                </div>
              </div>
            </div>

            <!-- Emails de Destino -->
            <div v-if="selectedContato" class="test-section">
              <label class="test-label">
                <i class="fa-solid fa-paper-plane"></i>
                4. Enviar para (máx. 10 emails)
              </label>
              <textarea v-model="testEmails" class="test-textarea"
                placeholder="email1@example.com, email2@example.com..." rows="3"></textarea>
              <small class="help-text">Separe múltiplos emails com vírgula</small>
            </div>

            <!-- Assunto -->
            <div v-if="selectedContato" class="test-section">
              <label class="test-label">
                <i class="fa-solid fa-heading"></i>
                5. Assunto do Email
              </label>
              <input v-model="testSubject" type="text" class="test-input"
                :placeholder="emailSubject || 'Digite o assunto...'" />
            </div>

            <!-- Mensagens de Erro/Sucesso -->
            <div v-if="sendTestError" class="test-alert test-alert-error">
              <i class="fa-solid fa-exclamation-circle"></i>
              {{ sendTestError }}
            </div>
            <div v-if="sendTestSuccess" class="test-alert test-alert-success">
              <i class="fa-solid fa-check-circle"></i>
              {{ sendTestSuccess }}
            </div>
          </div>

          <div class="test-modal-footer">
            <button @click.stop="showSendTestModal = false" type="button" :disabled="sendingTest"
              class="test-btn test-btn-cancel">
              Cancelar
            </button>
            <button @click.stop="sendTestEmail" type="button" :disabled="sendingTest || !selectedContato || !testEmails"
              class="test-btn test-btn-send">
              <i v-if="sendingTest" class="fa-solid fa-spinner fa-spin"></i>
              <i v-else class="fa-solid fa-paper-plane"></i>
              {{ sendingTest ? 'Enviando...' : 'Enviar Teste' }}
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal de Confirmação -->
    <div v-if="showConfirmModal" class="modal-overlay" @click.self="cancelConfirm">
      <div class="modal-box confirm">
        <div class="modal-icon"><i class="fa-solid fa-triangle-exclamation"></i></div>
        <h2>{{ confirmData.title }}</h2>
        <p>{{ confirmData.message }}</p>
        <div class="modal-buttons">
          <button @click="cancelConfirm" class="btn-modal-secondary">Cancelar</button>
          <button @click="executeConfirm" class="btn-modal-danger">{{ confirmData.confirmText }}</button>
        </div>
      </div>
    </div>

    <!-- Modal de Sucesso -->
    <div v-if="showSuccess" class="modal-overlay" @click.self="handleSuccessClose">
      <div class="modal-box success">
        <div class="modal-icon"><i class="fa-solid fa-circle-check" style="color: #04d600;"></i></div>
        <h2>Sucesso!</h2>
        <p>Template salvo com sucesso.</p>
        <button @click="handleSuccessClose" class="btn-modal-primary">OK</button>
      </div>
    </div>

    <!-- Modal de Erro -->
    <div v-if="errorMessage" class="modal-overlay" @click.self="errorMessage = null">
      <div class="modal-box error">
        <div class="modal-icon">❌</div>
        <h2>Erro</h2>
        <p>{{ errorMessage }}</p>
        <button @click="errorMessage = null" class="btn-modal-secondary">Fechar</button>
      </div>
    </div>

    <!-- Modal de Alerta -->
    <div v-if="showAlert" class="modal-overlay" @click.self="closeAlert">
      <div class="modal-box alert">
        <div class="modal-icon"><i class="fa-solid fa-circle-info" style="color: #007bff;"></i></div>
        <h2>{{ alertData.title }}</h2>
        <p>{{ alertData.message }}</p>
        <button @click="closeAlert" class="btn-modal-primary">OK</button>
      </div>
    </div>

    <!-- 🆕 Modal de Conformidade LGPD/GDPR -->
    <transition name="fade">
      <div v-if="showComplianceModal" class="compliance-modal-wrapper">
        <div class="compliance-modal-overlay" @click="closeComplianceModal"></div>
        <div class="compliance-modal-container">
          <div class="compliance-modal-header">
            <h3>
              <i class="fa-solid fa-shield-halved"></i>
              Conformidade com Políticas de Privacidade
            </h3>
            <button @click="closeComplianceModal" type="button" class="compliance-close-btn">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>

          <div class="compliance-modal-body">
            <div class="compliance-intro">
              <i class="fa-solid fa-info-circle"></i>
              <p>Para estar em conformidade com LGPD/GDPR, você deve seguir estas diretrizes:</p>
            </div>

            <!-- Lista de requisitos -->
            <div class="compliance-checklist">
              <!-- 1. Consentimento -->
              <div class="compliance-item">
                <label class="compliance-checkbox">
                  <input type="checkbox" v-model="complianceChecks.hasConsent" />
                  <span class="checkmark"></span>
                </label>
                <div class="compliance-content">
                  <strong>Consentimento Explícito e Ativo</strong>
                  <p>Seus contatos deram consentimento ativo (caixa de seleção NÃO pré-marcada) e explícito (sabem que
                    tipo de mensagens receberão).</p>
                </div>
              </div>

              <!-- 2. Comprovante -->
              <div class="compliance-item">
                <label class="compliance-checkbox">
                  <input type="checkbox" v-model="complianceChecks.hasProof" />
                  <span class="checkmark"></span>
                </label>
                <div class="compliance-content">
                  <strong>Comprovante de Adesão</strong>
                  <p>Você pode fornecer comprovante de adesão (opt-in) para cada contato a qualquer momento.</p>
                </div>
              </div>

              <!-- 3. Lista de Parceiros
              <div class="compliance-item">
                <label class="compliance-checkbox">
                  <input type="checkbox" v-model="complianceChecks.hasPartnerList" />
                  <span class="checkmark"></span>
                </label>
                <div class="compliance-content">
                  <strong>Transparência sobre Parceiros</strong>
                  <p>Se houver parceiros, todos os nomes estão listados no formulário de adesão (máximo de 10) e são
                    facilmente acessíveis.</p>
                </div>
              </div> -->

              <!-- 4. Link de Descadastro -->
              <div class="compliance-item" :class="{ 'has-warning': !hasUnsubscribeLink }">
                <label class="compliance-checkbox">
                  <input type="checkbox" v-model="complianceChecks.hasUnsubscribeLink"
                    :disabled="!hasUnsubscribeLink" />
                  <span class="checkmark"></span>
                </label>
                <div class="compliance-content">
                  <strong>Link de Descadastro</strong>
                  <p>O template inclui um link de "cancelamento de inscrição" facilmente acessível.</p>

                  <div v-if="!hasUnsubscribeLink" class="compliance-warning">
                    <i class="fa-solid fa-triangle-exclamation"></i>
                    <strong>ATENÇÃO:</strong> Seu template não possui um link de descadastro. Um Footer será adicionado
                    automaticamente.
                  </div>

                  <div v-else class="compliance-success">
                    <i class="fa-solid fa-check-circle"></i>
                    Link de descadastro detectado no template.
                  </div>
                </div>
              </div>

              <!-- 5. Confirmação de Entendimento -->
              <div class="compliance-item">
                <label class="compliance-checkbox">
                  <input type="checkbox" v-model="complianceChecks.understandsRules" />
                  <span class="checkmark"></span>
                </label>
                <div class="compliance-content">
                  <strong>Entendo as Regras</strong>
                  <p>Estou ciente de que o não cumprimento dessas diretrizes pode resultar em penalidades legais e
                    suspensão da conta.</p>
                </div>
              </div>
            </div>

            <!-- Informações Adicionais -->
            <div class="compliance-info-box">
              <i class="fa-solid fa-lightbulb"></i>
              <div>
                <strong>Dica:</strong>
                <p>Use o bloco "Footer" do editor para adicionar links de descadastro e políticas de privacidade
                  facilmente.</p>
              </div>
            </div>
          </div>

          <div class="compliance-modal-footer">
            <button @click="closeComplianceModal" type="button" class="compliance-btn compliance-btn-cancel">
              Cancelar
            </button>
            <button @click="proceedWithSave" type="button" :disabled="!canProceedWithSave"
              class="compliance-btn compliance-btn-save">
              <i class="fa-solid fa-check"></i>
              Confirmar e Salvar
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal de Inserir Link -->
    <transition name="fade">
      <div v-if="showLinkModal" class="link-modal-wrapper">
        <div class="link-modal-overlay" @click="closeLinkModal"></div>
        <div class="link-modal-container">
          <div class="link-modal-header">
            <h3>
              <i class="fa-solid fa-link"></i>
              Inserir Link Rastreável
            </h3>
            <button @click="closeLinkModal" type="button" class="link-close-btn">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>

          <div class="link-modal-body">
            <div class="link-preview">
              <i class="fa-solid fa-quote-left"></i>
              <span>{{ linkData.selectedText }}</span>
              <i class="fa-solid fa-quote-right"></i>
            </div>

            <div class="link-form-group">
              <label for="link-url-input">
                <i class="fa-solid fa-globe"></i>
                URL do Link
              </label>
              <input id="link-url-input" v-model="linkData.url" type="text" placeholder="https://exemplo.com/pagina"
                @keypress.enter="insertLink" />
              <small>
                <i class="fa-solid fa-info-circle"></i>
                A Brevo rastreará automaticamente os cliques neste link
              </small>
            </div>

            <div class="link-info-box">
              <i class="fa-solid fa-chart-line"></i>
              <div>
                <strong>Rastreamento Automático</strong>
                <p>Este link será automaticamente rastreado pela Brevo e aparecerá nas estatísticas de cliques da
                  campanha.</p>
              </div>
            </div>
          </div>

          <div class="link-modal-footer">
            <button @click="closeLinkModal" type="button" class="link-btn link-btn-cancel">
              Cancelar
            </button>
            <button @click="insertLink" type="button" :disabled="!linkData.url" class="link-btn link-btn-insert">
              <i class="fa-solid fa-check"></i>
              Inserir Link
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
const CardBlock = {
  props: ['data'],
  computed: {
    imagePositionKey() {
      return (this.data.imagePosition || 'center') + '-' + (this.data.imageZoom || 1);
    },
    isEditing() {
      return this.$parent.editingImage && this.$parent.editingImage.active;
    }
  },
  template: `
    <div class="block-wrapper card-block" :key="imagePositionKey">
      <div :style="getCardStyle()">
        
        <!-- Layout: Banner Grande -->
        <div v-if="data.layout === 'banner'" style="position: relative; width: 100%; overflow: hidden;">
          <div 
            :style="{ height: data.bannerHeight + 'px', position: 'relative', overflow: 'hidden', cursor: isEditing ? 'move' : 'default', borderRadius: (data.imageRadius || 8) + 'px' }"
            @mousedown="onImageMouseDown"
            @wheel="onImageWheel"
          >
            <img 
              v-if="data.imageUrl" 
              :src="data.imageUrl" 
              :alt="data.imageAlt"
              :style="getBannerImageStyle()"
              draggable="false"
              style="pointer-events: none; user-select: none;"
            />
            <div v-else class="placeholder-img" :style="{ width: '100%', height: data.bannerHeight + 'px', background: '#e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: (data.imageRadius || 8) + 'px' }">
              <i class="fa-solid fa-image" style="font-size: 64px; color: #999;"></i>
            </div>
          </div>
          
          <div :style="{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,' + data.overlayOpacity + ')', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '30px', textAlign: 'center', pointerEvents: isEditing ? 'none' : 'auto', borderRadius: (data.imageRadius || 8) + 'px' }">
            <h2 :style="{ fontSize: (data.titleSize * 1.5) + 'px', color: '#ffffff', margin: '0 0 15px 0', fontFamily: data.fontFamily, fontWeight: 'bold' }">
              {{ data.title }}
            </h2>
            <p data-card-text="true" :style="{ 
  fontSize: data.descriptionSize + 'px',
  color: data.descriptionColor,
  margin: '0 0 15px 0',
  lineHeight: '1.6',
  fontFamily: data.fontFamily,
  textAlign: data.descriptionAlign || 'left',
  whiteSpace: 'pre-line'
}">{{ data.description }}</p>
            <div v-if="data.showButton">
              <a :href="data.buttonUrl" 
                 :style="{ display: 'inline-block', padding: '14px 32px', background: data.buttonBgColor, color: data.buttonTextColor, textDecoration: 'none', borderRadius: '6px', fontWeight: '600', fontSize: '16px' }">
                {{ data.buttonText }}
              </a>
            </div>
          </div>
        </div>

        <!-- Layout: Imagem à Esquerda -->
        <div v-else-if="data.layout === 'image-left'" :style="{ display: 'flex', gap: (data.imageGap || 20) + 'px', alignItems: 'stretch' }">
          <div :style="{ flex: '0 0 ' + data.imageWidth + '%', overflow: 'hidden', borderRadius: (data.imageRadius || 8) + 'px' }">
            <img v-if="data.imageUrl" :src="data.imageUrl" :alt="data.imageAlt" 
                 :style="getImageStyle()" :key="'img-left-' + imagePositionKey" />
            <div v-else class="placeholder-img" :style="{ width: '100%', height: '100%', background: '#e0e0e0', borderRadius: (data.imageRadius || 8) + 'px', display: 'flex', alignItems: 'center', justifyContent: 'center' }">
              <i class="fa-solid fa-image" style="font-size: 32px; color: #999;"></i>
            </div>
          </div>
          <div style="flex: 1; display: flex; flex-direction: column; justify-content: center;">
            <h3 :style="{ fontSize: data.titleSize + 'px', color: data.titleColor, margin: '0 0 10px 0', fontFamily: data.fontFamily, textAlign: data.titleAlign || 'left' }">
              {{ data.title }}
            </h3>
            <p data-card-text="true" :style="{ 
  fontSize: data.descriptionSize + 'px',
  color: data.descriptionColor,
  margin: '0 0 15px 0',
  lineHeight: '1.6',
  fontFamily: data.fontFamily,
  textAlign: data.descriptionAlign || 'left',
  whiteSpace: 'pre-line'
}">{{ data.description }}</p>
            <div v-if="data.showButton" :style="{ textAlign: data.buttonAlign || 'left' }">
              <a :href="data.buttonUrl" 
                 :style="{ display: 'inline-block', padding: '10px 24px', background: data.buttonBgColor, color: data.buttonTextColor, textDecoration: 'none', borderRadius: '6px', fontWeight: '600', fontSize: '14px' }">
                {{ data.buttonText }}
              </a>
            </div>
          </div>
        </div>

        <!-- Layout: Imagem à Direita -->
        <div v-else-if="data.layout === 'image-right'" :style="{ display: 'flex', gap: (data.imageGap || 20) + 'px', alignItems: 'stretch', flexDirection: 'row-reverse' }">
          <div :style="{ flex: '0 0 ' + data.imageWidth + '%', overflow: 'hidden', borderRadius: (data.imageRadius || 8) + 'px' }">
            <img v-if="data.imageUrl" :src="data.imageUrl" :alt="data.imageAlt" 
                 :style="getImageStyle()" :key="'img-right-' + imagePositionKey" />
            <div v-else class="placeholder-img" :style="{ width: '100%', height: '100%', background: '#e0e0e0', borderRadius: (data.imageRadius || 8) + 'px', display: 'flex', alignItems: 'center', justifyContent: 'center' }">
              <i class="fa-solid fa-image" style="font-size: 32px; color: #999;"></i>
            </div>
          </div>
          <div style="flex: 1; display: flex; flex-direction: column; justify-content: center;">
            <h3 :style="{ fontSize: data.titleSize + 'px', color: data.titleColor, margin: '0 0 10px 0', fontFamily: data.fontFamily, textAlign: data.titleAlign || 'left' }">
              {{ data.title }}
            </h3>
            <p data-card-text="true" :style="{ 
  fontSize: data.descriptionSize + 'px',
  color: data.descriptionColor,
  margin: '0 0 15px 0',
  lineHeight: '1.6',
  fontFamily: data.fontFamily,
  textAlign: data.descriptionAlign || 'left',
  whiteSpace: 'pre-line'
}">{{ data.description }}</p>
            <div v-if="data.showButton" :style="{ textAlign: data.buttonAlign || 'left' }">
              <a :href="data.buttonUrl" 
                 :style="{ display: 'inline-block', padding: '10px 24px', background: data.buttonBgColor, color: data.buttonTextColor, textDecoration: 'none', borderRadius: '6px', fontWeight: '600', fontSize: '14px' }">
                {{ data.buttonText }}
              </a>
            </div>
          </div>
        </div>

        <!-- Layout: Imagem no Topo -->
        <div v-else-if="data.layout === 'image-top'">
          <div :style="{ marginBottom: (data.imageGap || 20) + 'px', textAlign: 'center', overflow: 'hidden', borderRadius: (data.imageRadius || 8) + 'px' }">
            <img v-if="data.imageUrl" :src="data.imageUrl" :alt="data.imageAlt" 
                 :style="getImageTopStyle()" :key="'img-top-' + imagePositionKey" />
            <div v-else class="placeholder-img" :style="{ width: '100%', margin: '0 auto', height: data.imageHeight + 'px', background: '#e0e0e0', borderRadius: (data.imageRadius || 8) + 'px', display: 'flex', alignItems: 'center', justifyContent: 'center' }">
              <i class="fa-solid fa-image" style="font-size: 48px; color: #999;"></i>
            </div>
          </div>
          <h3 :style="{ fontSize: data.titleSize + 'px', color: data.titleColor, margin: '0 0 10px 0', fontFamily: data.fontFamily, textAlign: data.titleAlign || 'center' }">
            {{ data.title }}
          </h3>
          <p data-card-text="true" :style="{ 
  fontSize: data.descriptionSize + 'px',
  color: data.descriptionColor,
  margin: '0 0 15px 0',
  lineHeight: '1.6',
  fontFamily: data.fontFamily,
  textAlign: data.descriptionAlign || 'left',
  whiteSpace: 'pre-line'
}">{{ data.description }}</p>
          <div v-if="data.showButton" :style="{ textAlign: data.buttonAlign || 'center' }">
            <a :href="data.buttonUrl" 
               :style="{ display: 'inline-block', padding: '10px 24px', background: data.buttonBgColor, color: data.buttonTextColor, textDecoration: 'none', borderRadius: '6px', fontWeight: '600', fontSize: '14px' }">
              {{ data.buttonText }}
            </a>
          </div>
        </div>

        <!-- Layout: Grid (2, 3 ou 4 colunas) -->
        <div v-else-if="data.layout === 'grid-2' || data.layout === 'grid-3' || data.layout === 'grid-4'">
          <div :style="{ display: 'grid', gridTemplateColumns: getGridColumns(), gap: (data.gridGap || 20) + 'px' }">
            <div v-for="(item, idx) in getActualGridItems()" :key="'grid-' + idx + '-' + (item.imagePosition || 'center')" style="display: flex; flex-direction: column;">
              <div :style="{ marginBottom: '15px', overflow: 'hidden', borderRadius: (data.imageRadius || 8) + 'px' }">
                <img v-if="item.imageUrl" :src="item.imageUrl" :alt="item.imageAlt" 
                     :style="getGridImageStyle(item)" />
                <div v-else class="placeholder-img" :style="{ width: '100%', height: data.gridImageHeight + 'px', background: '#e0e0e0', borderRadius: (data.imageRadius || 8) + 'px', display: 'flex', alignItems: 'center', justifyContent: 'center' }">
                  <i class="fa-solid fa-image" style="font-size: 32px; color: #999;"></i>
                </div>
              </div>
              <h4 :style="{ fontSize: data.titleSize + 'px', color: data.titleColor, margin: '0 0 8px 0', fontFamily: data.fontFamily, textAlign: data.titleAlign || 'left' }">
                {{ item.title }}
              </h4>
              <p :style="{ fontSize: data.descriptionSize + 'px', color: data.descriptionColor, margin: '0 0 12px 0', lineHeight: '1.6', fontFamily: data.fontFamily, textAlign: data.descriptionAlign || 'left', flex: '1' }">
                {{ item.description }}
              </p>
              <div v-if="data.showButton" :style="{ textAlign: data.buttonAlign || 'left' }">
                <a :href="item.buttonUrl" 
                   :style="{ display: 'inline-block', padding: '8px 18px', background: data.buttonBgColor, color: data.buttonTextColor, textDecoration: 'none', borderRadius: '6px', fontWeight: '600', fontSize: '13px' }">
                  {{ data.buttonText }}
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  `,
  methods: {
    onImageMouseDown(event) {
      if (this.$parent.editingImage && this.$parent.editingImage.active) {
        this.$parent.onImageMouseDown(event);
      }
    },

    onImageWheel(event) {
      if (this.$parent.editingImage && this.$parent.editingImage.active) {
        this.$parent.onImageWheel(event);
      }
    },

    getCardStyle() {
      return {
        backgroundColor: this.data.backgroundColor,
        border: `${this.data.borderWidth}px solid ${this.data.borderColor}`,
        borderRadius: this.data.borderRadius + 'px',
        padding: this.data.padding + 'px',
        margin: '20px 0'
      };
    },

    getGridColumns() {
      if (this.data.layout === 'grid-2') return 'repeat(2, 1fr)';
      if (this.data.layout === 'grid-3') return 'repeat(3, 1fr)';
      if (this.data.layout === 'grid-4') return 'repeat(4, 1fr)';
      return 'repeat(2, 1fr)';
    },

    getActualGridItems() {
      const count = this.data.layout === 'grid-2' ? 2 : this.data.layout === 'grid-3' ? 3 : 4;
      return (this.data.gridItems || []).slice(0, count);
    },

    getImageStyle() {
      const position = this.data.imagePosition || 'center';
      const zoom = this.data.imageZoom || 1;

      return {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: position,
        transform: zoom > 1 ? `scale(${zoom})` : 'none',
        transformOrigin: position,
        display: 'block',
        transition: 'all 0.1s ease-out'
      };
    },

    getImageTopStyle() {
      const position = this.data.imagePosition || 'center';
      const zoom = this.data.imageZoom || 1;

      return {
        width: '100%',
        maxWidth: '100%',
        height: this.data.imageHeight + 'px',
        objectFit: 'cover',
        objectPosition: position,
        transform: zoom > 1 ? `scale(${zoom})` : 'none',
        transformOrigin: position,
        display: 'block',
        margin: '0 auto',
        transition: 'all 0.1s ease-out'
      };
    },

    getGridImageStyle(item) {
      const position = item.imagePosition || 'center';
      const zoom = item.imageZoom || 1;

      return {
        width: '100%',
        height: this.data.gridImageHeight + 'px',
        objectFit: 'cover',
        objectPosition: position,
        transform: zoom > 1 ? `scale(${zoom})` : 'none',
        transformOrigin: position,
        display: 'block',
        transition: 'all 0.1s ease-out'
      };
    },

    getBannerImageStyle() {
      const position = this.data.imagePosition || 'center';
      const zoom = this.data.imageZoom || 1;

      return {
        width: '100%',
        height: this.data.bannerHeight + 'px',
        objectFit: 'cover',
        objectPosition: position,
        transform: zoom > 1 ? `scale(${zoom})` : 'none',
        transformOrigin: position,
        display: 'block',
        transition: 'all 0.1s ease-out'
      };
    }
  }
};

const TextBlock = {
  props: ['data'],
  template: `
    <div class="block-wrapper text-block">
      <div class="text-render" :style="{ 
        fontSize: (typeof data.fontSize === 'number' ? data.fontSize + 'px' : data.fontSize), 
        color: data.color, 
        textAlign: data.align, 
        lineHeight: '1.6', 
        padding: '15px', 
        fontFamily: data.fontFamily || 'Arial, sans-serif' 
      }" v-html="renderContent()" @click.capture="handleLinkClick">
      </div>
    </div>
  `,
  methods: {
    renderContent() {
      let content = this.data.content || 'Digite seu texto...';
      content = content.replace(/\n/g, '<br>');

      // 🔥 REGEX ATUALIZADO PARA params.VARIAVEL
      const variableRegex = /\{\{\s*params\.(\w+)\s*\}\}/g;

      content = content.replace(variableRegex, (match, variableName, offset, originalText) => {
        const before = originalText.substring(Math.max(0, offset - 30), offset);
        if (/href\s*=\s*["']?$/i.test(before)) {
          return match;
        }
        return `<span style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 3px 10px; border-radius: 4px; font-weight: 700; font-size: 0.95em; display: inline-block; margin: 0 3px; box-shadow: 0 2px 6px rgba(102, 126, 234, 0.4); white-space: nowrap; font-family: 'Courier New', monospace;">${variableName}</span>`;
      });

      return content;
    },

    handleLinkClick(event) {
      if (event.target.tagName === 'A') {
        event.preventDefault();
      }
    }
  }
};

const TableBlock = {
  props: ['data'],
  template: `
    <div class="block-wrapper table-block">
      <div style="padding: 15px; overflow-x: auto; -webkit-overflow-scrolling: touch;">
        <table style="width: 100%; border-collapse: collapse; font-family: Arial, sans-serif; max-width: 100%;">
          <thead>
            <tr style="background-color: #f0f0f0;">
              <th v-for="(header, idx) in data.headers" 
                  :key="'header-' + idx"
                  :style="getHeaderStyle()">
                {{ header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, rowIdx) in data.rows" 
                :key="'row-' + rowIdx"
                :style="getRowStyle(rowIdx)">
              <td v-for="(cell, cellIdx) in row" 
                  :key="'cell-' + rowIdx + '-' + cellIdx"
                  :style="getCellStyle()"
                  v-html="formatCellContent(cell)">
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  `,
  methods: {
    getHeaderStyle() {
      return {
        padding: '12px 8px',
        textAlign: this.data.headerAlign || 'left',
        fontWeight: 'bold',
        fontSize: (this.data.headerFontSize || 14) + 'px',
        color: this.data.headerColor || '#333333',
        borderBottom: '2px solid ' + (this.data.borderColor || '#dddddd'),
        whiteSpace: 'nowrap'  // 🔥 ADICIONADO
      };
    },
    getRowStyle(index) {
      const bgColor = index % 2 === 0
        ? (this.data.evenRowColor || '#ffffff')
        : (this.data.oddRowColor || '#f9f9f9');
      return {
        backgroundColor: bgColor
      };
    },
    getCellStyle() {
      return {
        padding: '10px 8px',
        textAlign: this.data.cellAlign || 'left',
        fontSize: (this.data.cellFontSize || 13) + 'px',
        color: this.data.cellColor || '#555555',
        borderBottom: '1px solid ' + (this.data.borderColor || '#dddddd'),
        whiteSpace: 'nowrap'  // 🔥 ADICIONADO
      };
    },

    formatCellContent(cellContent) {
      if (!cellContent) return '';

      const variableRegex = /\{\{\s*params\.(\w+)\s*\}\}/g;

      return cellContent.replace(variableRegex, (match, variableName) => {
        return `<span style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 3px 10px; border-radius: 4px; font-weight: 700; font-size: 0.95em; display: inline-block; margin: 0 3px; box-shadow: 0 2px 6px rgba(102, 126, 234, 0.4); white-space: nowrap; font-family: 'Courier New', monospace;">${variableName}</span>`;
      });
    }
  }
};

const HeadingBlock = {
  props: ['data'],
  template: `
    <div class="block-wrapper heading-block">
      <h2
        :style="{
          color: data.color,
          textAlign: data.align,
          fontSize: (data.fontSize ? data.fontSize + 'px' : '26px'),
          fontWeight: 'bold',
          margin: '15px',
          padding: '10px 15px',
          fontFamily: data.fontFamily || 'Arial, sans-serif'
        }"
        v-html="renderContent()"
      ></h2>
    </div>
  `,
  methods: {
    renderContent() {
      let content = this.data.content || 'Digite seu texto...';
      content = content.replace(/\n/g, '<br>');

      const variableRegex = /\{\{\s*params\.(\w+)\s*\}\}/g;

      return content.replace(variableRegex, (_, variableName) => {
        return `<span style="
          background: linear-gradient(135deg,#667eea,#764ba2);
          color:#fff;
          padding:3px 10px;
          border-radius:4px;
          font-weight:700;
          font-size:.95em;
          display:inline-block;
          margin:0 3px;
          white-space:nowrap;
          font-family:'Courier New', monospace;
        ">${variableName}</span>`;
      });
    }
  }
};


const ImageBlock = {
  props: ['data'],
  template: `
    <div class="block-wrapper image-block">
      <div :style="{ textAlign: data.align, padding: '15px' }">
        <template v-if="data.src">
          <a v-if="data.link" :href="data.link" :target="data.linkTarget || '_blank'"
             style="display:block; width:100%;" @click.prevent>
            <img :src="data.src" :alt="data.alt"
              :style="{ width: data.width + '%', maxWidth: '100%', height: 'auto',
                        display: 'inline-block', borderRadius: '4px' }" />
          </a>
          <img v-else :src="data.src" :alt="data.alt"
            :style="{ width: data.width + '%', maxWidth: '100%', height: 'auto',
                      display: 'inline-block', borderRadius: '4px' }" />
        </template>
        <div v-else class="placeholder-img">
          <span style="font-size:48px"><i class="fa-solid fa-images"></i></span>
          <p style="margin:10px 0 0">Adicione uma imagem</p>
        </div>
      </div>
    </div>
  `
};


const ButtonBlock = {
  props: ['data'],
  template: `
    <div class="block-wrapper button-block">
      <div :style="{ textAlign: data.align, padding: '20px 15px' }">
        <a 
          :href="data.url" 
          :style="{ 
            display: 'inline-block', 
            padding: '14px 35px', 
            backgroundColor: data.bgColor, 
            color: data.textColor, 
            textDecoration: 'none', 
            borderRadius: '6px', 
            fontWeight: 'bold', 
            fontSize: '16px', 
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)' 
          }"
          v-html="renderButtonText()"
        >
        </a>
      </div>
    </div>
  `,
  methods: {
    renderButtonText() {
      let text = this.data.text || 'Clique aqui';

      // 🔥 REGEX ATUALIZADO
      const variableRegex = /\{\{\s*params\.(\w+)\s*\}\}/g;

      text = text.replace(variableRegex, (match, variableName) => {
        return `<span style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 3px 10px; border-radius: 4px; font-weight: 700; font-size: 0.95em; display: inline-block; margin: 0 3px; box-shadow: 0 2px 6px rgba(102, 126, 234, 0.4); white-space: nowrap; font-family: 'Courier New', monospace;">${variableName}</span>`;
      });

      return text;
    }
  }
};

const DividerBlock = {
  props: ['data'],
  template: `
    <div class="block-wrapper divider-block">
      <div style="padding: 15px">
        <hr :style="{ border: 'none', borderTop: data.thickness + 'px ' + data.style + ' ' + data.color, margin: '0' }" />
      </div>
    </div>
  `
};

const SpacerBlock = {
  props: ['data'],
  template: `
    <div class="block-wrapper spacer-block">
      <div :style="{ height: data.height + 'px', background: 'repeating-linear-gradient(45deg, #f0f0f0, #f0f0f0 10px, #e0e0e0 10px, #e0e0e0 20px)', borderLeft: '3px solid #007bff' }"></div>
    </div>
  `
};

const VideoBlock = {
  props: ['data'],
  computed: {
    getThumbnailUrl() {
      let url = this.data.videoUrl;
      if (url.includes('youtube.com/watch')) {
        const videoId = url.split('v=')[1]?.split('&')[0];
        return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
      } else if (url.includes('youtu.be')) {
        const videoId = url.split('youtu.be/')[1]?.split('?')[0];
        return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
      }
      return 'https://via.placeholder.com/640x360/667eea/ffffff?text=Reproduzir+Video';
    },
    videoWidth() {
      return this.data.scale || 100;
    },
    videoHeight() {
      const baseHeight = 350;
      const scale = (this.data.scale || 100) / 100;
      return Math.round(baseHeight * scale);
    },
    buttonSize() {
      const scale = (this.data.scale || 100) / 100;
      return {
        width: Math.round(90 * scale),
        height: Math.round(63 * scale)
      };
    }
  },
  template: `
    <div class="block-wrapper video-block">
      <div style="padding: 15px; text-align: center">
        <div v-if="data.videoUrl" :style="{ position: 'relative', maxWidth: videoWidth + '%', width: videoWidth + '%', margin: '0 auto', height: videoHeight + 'px' }">
          <img :src="getThumbnailUrl" alt="Vídeo" :style="{ width: '100%', height: videoHeight + 'px', objectFit: 'cover', display: 'block', borderRadius: '8px' }">
          
          <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); cursor: pointer;">
            <div :style="{ position: 'relative', width: buttonSize.width + 'px', height: buttonSize.height + 'px' }">
              <svg viewBox="0 0 90 63" :style="{ width: buttonSize.width + 'px', height: buttonSize.height + 'px', position: 'absolute', top: 0, left: 0 }">
                <path d="M88.7,9.8c-1-3.9-4.1-6.9-7.9-7.9C73.8,0,45,0,45,0S16.2,0,9.2,1.9c-3.9,1-6.9,4.1-7.9,7.9
                       C0,16.8,0,31.5,0,31.5s0,14.7,1.3,21.7c1,3.9,4.1,6.9,7.9,7.9C16.2,63,45,63,45,63s28.8,0,35.8-1.9
                       c3.9-1,6.9-4.1,7.9-7.9C90,46.2,90,31.5,90,31.5S90,16.8,88.7,9.8z" 
                       fill="#FF0000" />
                <path d="M36,45 L60,31.5 L36,18 Z" fill="#FFFFFF" />
              </svg>
            </div>
          </div>
        </div>
        <div v-else class="placeholder-video">
          <span style="font-size: 48px"><i class="fa-solid fa-video"></i></span>
          <p style="margin: 10px 0 0 0">Adicione um vídeo (YouTube)</p>
        </div>
      </div>
    </div>
  `
};

const ColumnsBlock = {
  props: ['data'],
  template: `
    <div class="block-wrapper columns-block">
      <div style="display: flex; gap: 15px; padding: 15px">
        <div 
          v-for="(col, idx) in data.columns" 
          :key="idx"
          style="flex: 1; padding: 15px; border: 0px solid #e0e0e0; border-radius: 4px !important; background: #f9f9f9"
          v-html="col.content || 'Coluna ' + (idx + 1)"
        ></div>
      </div>
    </div>
  `
};

// NOVO: Componente de Redes Sociais
const SocialBlock = {
  props: ['data'],
  template: `
    <div class="block-wrapper social-block">
      <div :style="{ 
        padding: '30px 20px',
        backgroundColor: data.bgColor || 'transparent',
        textAlign: data.align || 'center'
      }">
        <div v-if="data.title" :style="{
          fontSize: '18px',
          fontWeight: 'bold',
          color: data.titleColor || '#333333',
          marginBottom: '20px',
          fontFamily: data.fontFamily || 'Arial, sans-serif'
        }">
          {{ data.title }}
        </div>
        
        <div style="display: inline-block; max-width: 100%;">
          <div :style="{ 
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: data.spacing + 'px',
            alignItems: 'center',
            maxWidth: '100%'
          }">
            <!-- Facebook -->
            <a v-if="data.links.facebook" :href="data.links.facebook" style="text-decoration:none; flex-shrink: 0;" target="_blank">
              <div :style="getIconStyle('#1877F2')">
                <img :src="'imgs/icons/facebook-icon.png'" :style="getImgStyle(getIconSize)" alt="Facebook" />
              </div>
            </a>
            
            <!-- Instagram -->
            <a v-if="data.links.instagram" :href="data.links.instagram" style="text-decoration:none; flex-shrink: 0;" target="_blank">
              <div :style="getIconStyle('linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)')">
                <img :src="'imgs/icons/instagram-icon.png'" :style="getImgStyle(getIconSize)" alt="Instagram" />
              </div>
            </a>
            
            <!-- Twitter/X -->
            <a v-if="data.links.twitter" :href="data.links.twitter" style="text-decoration:none; flex-shrink: 0;" target="_blank">
              <div :style="getIconStyle('#000000')">
                <img :src="'imgs/icons/twitter-icon.png'" :style="getImgStyle(getIconSizeSmall)" alt="Twitter" />
              </div>
            </a>
            
            <!-- LinkedIn -->
            <a v-if="data.links.linkedin" :href="data.links.linkedin" style="text-decoration:none; flex-shrink: 0;" target="_blank">
              <div :style="getIconStyle('#0A66C2')">
                <img :src="'imgs/icons/linkedin-icon.png'" :style="getImgStyle(getIconSizeSmall)" alt="LinkedIn" />
              </div>
            </a>
            
            <!-- YouTube -->
            <a v-if="data.links.youtube" :href="data.links.youtube" style="text-decoration:none; flex-shrink: 0;" target="_blank">
              <div :style="getIconStyle('#FF0000')">
                <img :src="'imgs/icons/youtube-icon.png'" :style="getImgStyle(getIconSize)" alt="YouTube" />
              </div>
            </a>
            
            <!-- TikTok -->
            <a v-if="data.links.tiktok" :href="data.links.tiktok" style="text-decoration:none; flex-shrink: 0;" target="_blank">
              <div :style="getIconStyle('#000000')">
                <img :src="'imgs/icons/tiktok-icon.png'" :style="getImgStyle(getIconSize)" alt="TikTok" />
              </div>
            </a>
            
            <!-- WhatsApp -->
            <a v-if="data.links.whatsapp" :href="data.links.whatsapp" style="text-decoration:none; flex-shrink: 0;" target="_blank">
              <div :style="getIconStyle('#25D366')">
                <img :src="'imgs/icons/whatsapp-icon.png'" :style="getImgStyle(getIconSize)" alt="WhatsApp" />
              </div>
            </a>
            
            <!-- Telegram -->
            <a v-if="data.links.telegram" :href="data.links.telegram" style="text-decoration:none; flex-shrink: 0;" target="_blank">
              <div :style="getIconStyle('#26A5E4')">
                <img :src="'imgs/icons/telegram-icon.png'" :style="getImgStyle(getIconSize)" alt="Telegram" />
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  `,
  computed: {
    getIconSize() {
      return Math.round((this.data.iconSize || 50) * 0.6);
    },
    getIconSizeSmall() {
      return Math.round((this.data.iconSize || 50) * 0.55);
    }
  },
  methods: {
    getIconStyle(bgColor) {
      const iconSize = this.data.iconSize || 50;
      const iconStyle = this.data.iconStyle || 'circle';
      const showShadow = this.data.showShadow !== false;

      return {
        width: iconSize + 'px',
        height: iconSize + 'px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: bgColor,
        borderRadius: iconStyle === 'circle' ? '50%' : iconStyle === 'rounded' ? '8px' : '0',
        boxShadow: showShadow ? '0 2px 8px rgba(0,0,0,0.2)' : 'none',
        flexShrink: '0'
      };
    },
    getImgStyle(size) {
      return {
        width: size + 'px',
        height: size + 'px',
        display: 'block'
      };
    }
  }
};
// NOVO: Componente de Footer
const FooterBlock = {
  props: ['data'],
  template: `
    <div class="block-wrapper footer-block">
      <div :style="{ 
        backgroundColor: data.bgColor, 
        color: data.textColor, 
        padding: '40px 20px',
        fontFamily: data.fontFamily || 'Arial, sans-serif'
      }">
        <div style="max-width: 800px; margin: 0 auto;">
          <div v-if="data.companyName" :style="{ 
            fontSize: '20px', 
            fontWeight: 'bold', 
            marginBottom: '15px',
            textAlign: data.align
          }">
            {{ data.companyName }}
          </div>
          
          <div v-if="data.address" :style="{ 
            fontSize: '14px', 
            marginBottom: '15px',
            textAlign: data.align,
            lineHeight: '1.6',
            whiteSpace: 'pre-wrap'
          }">
            {{ data.address }}
          </div>
          
          <div v-if="hasUsefulLinks" :style="{ 
            display: 'flex', 
            justifyContent: getAlignment,
            gap: '20px',
            marginBottom: '20px',
            flexWrap: 'wrap',
            fontSize: '13px'
          }">
            <a v-if="data.usefulLinks.privacy" :href="data.usefulLinks.privacy" :style="{ color: data.textColor, textDecoration: 'underline' }" target="_blank">Política de Privacidade</a>
            <a v-if="data.usefulLinks.terms" :href="data.usefulLinks.terms" :style="{ color: data.textColor, textDecoration: 'underline' }" target="_blank">Termos de Uso</a>
            <a v-if="data.usefulLinks.unsubscribe" :href="data.usefulLinks.unsubscribe" :style="{ color: data.textColor, textDecoration: 'underline' }" target="_blank">Descadastrar</a>
          </div>
          
          <div v-if="data.legalText" :style="{ 
            fontSize: '12px', 
            marginTop: '20px',
            textAlign: data.align,
            lineHeight: '1.6',
            opacity: '0.9',
            whiteSpace: 'pre-wrap'
          }">
            {{ data.legalText }}
          </div>
          
          <div v-if="data.copyright" :style="{ 
            fontSize: '12px', 
            marginTop: '15px',
            textAlign: data.align,
            opacity: '0.8'
          }">
            {{ data.copyright }}
          </div>
        </div>
      </div>
    </div>
  `,
  computed: {
    hasSocialLinks() {
      return this.data.socialLinks && (
        this.data.socialLinks.facebook ||
        this.data.socialLinks.instagram ||
        this.data.socialLinks.linkedin ||
        this.data.socialLinks.twitter ||
        this.data.socialLinks.youtube
      );
    },
    hasUsefulLinks() {
      return this.data.usefulLinks && (
        this.data.usefulLinks.privacy ||
        this.data.usefulLinks.terms ||
        this.data.usefulLinks.unsubscribe
      );
    },
    getAlignment() {
      if (this.data.align === 'left') return 'flex-start';
      if (this.data.align === 'right') return 'flex-end';
      return 'center';
    }
  }
};

export default {
  name: 'BrevoEditor',

  components: {
    TextBlock,
    HeadingBlock,
    ImageBlock,
    ButtonBlock,
    DividerBlock,
    SpacerBlock,
    VideoBlock,
    ColumnsBlock,
    SocialBlock,    // NOVO
    FooterBlock,     // NOVO
    CardBlock,
    TableBlock
  },

  props: {
    templateId: {
      type: [String, Number],
      default: null
    },
    templateData: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      availableVariables: [
        { key: 'NOME', label: 'Nome' },
        { key: 'SOBRENOME', label: 'Sobrenome' },
        { key: 'EMAIL', label: 'Email' },
        { key: 'CPF_CNPJ', label: 'CPF / CNPJ' },
        { key: 'CPD', label: 'CPD' },
        { key: 'LINK_PAGAMENTO', label: 'Link de Pagamento' },
        { key: 'RAZAO_SOCIAL', label: 'Razão Social' },
        { key: 'EMPRESA', label: 'Empresa' },
        { key: 'NOTA_FISCAL', label: 'Notal Fiscal' },
        { key: 'TITULO', label: 'Título' },
        { key: 'EMISSAO', label: 'Emissão' },
        { key: 'VENCIMENTO', label: 'Vencimento' },
        { key: 'VALOR_ORIGINAL', label: 'Valor Original' },
        { key: 'DIAS_ATRASO', label: 'Dias em Atraso' },
      ],
      showLinkModal: false,
      linkData: {
        componentType: '',
        selectedText: '',
        url: '',
        startPos: 0,
        endPos: 0
      },
      updateTrigger: 0,
      showImagePositionEditor: false,
      initialImages: [],
      showComplianceModal: false,
      complianceChecks: {
        hasConsent: false,
        hasProof: false,
        hasUnsubscribeLink: false,
        understandsRules: false
      },
      complianceWarnings: [],
      editingImage: {
        active: false,
        componentIndex: null,
        gridItemIndex: null,
        isDragging: false,
        startX: 0,
        startY: 0,
        offsetX: 0,
        offsetY: 0,
        zoom: 1,
        minZoom: 0.5,
        maxZoom: 3
      },
      showSendTestModal: false,
      searchEmail: '',
      searchingContacts: false,
      foundContacts: [],
      selectedContato: null,
      contatoData: null,
      previewParams: {},
      testEmails: '',
      testSubject: '',
      sendingTest: false,
      sendTestError: '',
      sendTestSuccess: '',
      templateName: 'Novo Template de Email',
      emailSubject: '',
      activeTab: 'blocks',
      components: [],
      selectedIndex: null,
      hoverIndex: null,
      draggedBlock: null,
      saving: false,
      showSuccess: false,
      showPreview: false,
      errorMessage: null,
      currentDevice: 'desktop',
      previewMode: 'desktop',
      showConfirmModal: false,
      confirmData: {
        title: '',
        message: '',
        confirmText: 'Confirmar',
        onConfirm: null
      },
      showAlert: false,
      alertData: {
        title: '',
        message: ''
      },
      globalSettings: {
        backgroundColor: '#FFFFFF',
        maxWidth: '100%',
        padding: 30
      },
      contentBlocks: [
        {
          type: 'heading',
          name: 'Título',
          icon: '<svg width="45" height="45" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><text x="6" y="18" font-size="16" font-weight="bold" fill="currentColor">T</text></svg>'
        },
        {
          type: 'text',
          name: 'Texto',
          icon: '<svg width="45" height="45" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="4" y1="8" x2="20" y2="8"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="16" x2="16" y2="16"/></svg>'
        },
        {
          type: 'button',
          name: 'Botão',
          icon: `<svg width="60" height="40" viewBox="0 0 60 40" fill="none">
      <rect x="8" y="13" width="44" height="14" rx="2" fill="currentColor" stroke="currentColor" stroke-width="2"/>
      <rect x="12" y="19" width="36" height="2" rx="1" fill="white"/>
      <path d="M46.7692 24.1538C46.0211 23.8422 45.1589 24.0128 44.5858 24.5858C44.0128 25.1589 43.8422 26.0211 44.1538 26.7692L48.8672 38.0825C49.1871 38.8505 49.9492 39.3402 50.7807 39.3122C51.6122 39.2842 52.3395 38.7444 52.6071 37.9566L53.2463 36.0747L55.2525 38.0809C56.0335 38.862 57.2999 38.862 58.0809 38.0809C58.862 37.2999 58.862 36.0335 58.0809 35.2525L56.0747 33.2463L57.9566 32.6071C58.7444 32.3395 59.2842 31.6122 59.3122 30.7807C59.3402 29.9492 58.8505 29.1871 58.0825 28.8672L46.7692 24.1538ZM51.6584 30.524C51.1386 30.7272 50.7272 31.1386 50.524 31.6584L49.7139 29.7139L51.6584 30.524Z" fill="currentColor" stroke="white" stroke-width="2"/>
    </svg>`
        },
        {
          type: 'divider',
          name: 'Divisor',
          icon: '<svg width="45" height="45" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="4" y1="12" x2="20" y2="12" stroke-dasharray="2 2"/></svg>'
        },
        {
          type: 'spacer',
          name: 'Espaço',
          icon: '<svg width="45" height="45" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="6" y="8" width="12" height="8" rx="1" stroke-dasharray="2 2"/><path d="M12 10v4M12 10l-1.5 1.5M12 10l1.5 1.5M12 14l-1.5-1.5M12 14l1.5-1.5"/></svg>'
        },
        {
          type: 'social',
          name: 'Social',
          icon: `<svg width="60" height="40" viewBox="0 0 60 40" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M23.8125 5.00488H14.1875C13.4626 5.00488 12.875 5.59251 12.875 6.31738V15.9424C12.875 16.6673 13.4626 17.2549 14.1875 17.2549H17.9404V13.0902H16.2178V11.1299H17.9404V9.63582C17.9404 7.93641 18.9521 6.9977 20.5017 6.9977C21.2438 6.9977 22.0198 7.13004 22.0198 7.13004V8.79801H21.1648C20.3223 8.79801 20.0596 9.32082 20.0596 9.85703V11.1299H21.9403L21.6395 13.0902H20.0596V17.2549H23.8125C24.5374 17.2549 25.125 16.6673 25.125 15.9424V6.31738C25.125 5.59251 24.5374 5.00488 23.8125 5.00488V5.00488Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M24.5609 26.2781C24.5698 26.4024 24.5698 26.5268 24.5698 26.6512C24.5698 30.4443 21.6827 34.8149 16.4061 34.8149C14.7804 34.8149 13.2703 34.344 12 33.5268C12.231 33.5535 12.453 33.5623 12.6929 33.5623C14.0342 33.5623 15.269 33.1093 16.2551 32.3365C14.9936 32.3098 13.9365 31.4837 13.5723 30.3466C13.75 30.3732 13.9277 30.391 14.1142 30.391C14.3718 30.391 14.6295 30.3555 14.8693 30.2933C13.5546 30.0268 12.5685 28.872 12.5685 27.4773V27.4418C12.9505 27.655 13.3947 27.7882 13.8654 27.806C13.0926 27.2908 12.5863 26.4113 12.5863 25.4164C12.5863 24.8834 12.7284 24.3948 12.9771 23.9684C14.3896 25.7095 16.5127 26.8466 18.8934 26.971C18.849 26.7578 18.8223 26.5357 18.8223 26.3136C18.8223 24.7324 20.1015 23.4443 21.6916 23.4443C22.5177 23.4443 23.2639 23.7908 23.788 24.3504C24.4365 24.2261 25.0583 23.9862 25.6091 23.6575C25.3959 24.3238 24.9428 24.8834 24.3477 25.2387C24.9251 25.1766 25.4847 25.0167 25.9999 24.7946C25.6091 25.3631 25.1205 25.8694 24.5609 26.2781Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M37.0027 7.98525C35.2636 7.98525 33.8609 9.38799 33.8609 11.1271C33.8609 12.8661 35.2636 14.2688 37.0027 14.2688C38.7418 14.2688 40.1445 12.8661 40.1445 11.1271C40.1445 9.38799 38.7418 7.98525 37.0027 7.98525ZM37.0027 13.1691C35.8789 13.1691 34.9601 12.2531 34.9601 11.1266C34.9601 10 35.8762 9.08398 37.0027 9.08398C38.1293 9.08398 39.0453 10 39.0453 11.1266C39.0453 12.2531 38.1266 13.1691 37.0027 13.1691ZM41.0058 7.85674C41.0058 8.26416 40.6777 8.58955 40.273 8.58955C39.8656 8.58955 39.5402 8.26143 39.5402 7.85674C39.5402 7.45205 39.8683 7.12393 40.273 7.12393C40.6777 7.12393 41.0058 7.45205 41.0058 7.85674ZM43.0867 8.60049C43.0402 7.61885 42.816 6.74932 42.0969 6.03291C41.3804 5.3165 40.5109 5.09229 39.5293 5.04307C38.5176 4.98564 35.4851 4.98564 34.4734 5.04307C33.4945 5.08955 32.625 5.31377 31.9058 6.03018C31.1867 6.74658 30.9652 7.61611 30.916 8.59775C30.8586 9.60947 30.8586 12.6419 30.916 13.6536C30.9625 14.6353 31.1867 15.5048 31.9058 16.2212C32.625 16.9376 33.4918 17.1618 34.4734 17.211C35.4851 17.2685 38.5176 17.2685 39.5293 17.211C40.5109 17.1646 41.3804 16.9403 42.0969 16.2212C42.8133 15.5048 43.0375 14.6353 43.0867 13.6536C43.1441 12.6419 43.1441 9.61221 43.0867 8.60049ZM41.7797 14.7392C41.5664 15.2751 41.1535 15.688 40.6148 15.904C39.8082 16.2239 37.8941 16.1501 37.0027 16.1501C36.1113 16.1501 34.1945 16.2212 33.3906 15.904C32.8547 15.6907 32.4418 15.2778 32.2258 14.7392C31.9058 13.9325 31.9797 12.0185 31.9797 11.1271C31.9797 10.2356 31.9086 8.31885 32.2258 7.51494C32.439 6.979 32.8519 6.56611 33.3906 6.3501C34.1972 6.03018 36.1113 6.104 37.0027 6.104C37.8941 6.104 39.8109 6.03291 40.6148 6.3501C41.1508 6.56338 41.5636 6.97627 41.7797 7.51494C42.0996 8.32158 42.0258 10.2356 42.0258 11.1271C42.0258 12.0185 42.0996 13.9353 41.7797 14.7392Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M43.3596 25.9232C43.207 25.3484 42.7572 24.8957 42.1861 24.7421C41.1509 24.4629 37 24.4629 37 24.4629C37 24.4629 32.8491 24.4629 31.8139 24.7421C31.2428 24.8957 30.793 25.3484 30.6403 25.9232C30.3629 26.9651 30.3629 29.139 30.3629 29.139C30.3629 29.139 30.3629 31.3128 30.6403 32.3547C30.793 32.9296 31.2428 33.3634 31.8139 33.5171C32.8491 33.7962 37 33.7962 37 33.7962C37 33.7962 41.1509 33.7962 42.1861 33.5171C42.7572 33.3634 43.207 32.9296 43.3596 32.3547C43.637 31.3128 43.637 29.139 43.637 29.139C43.637 29.139 43.637 26.9651 43.3596 25.9232ZM35.6424 31.1124V27.165L39.1117 29.1388L35.6424 31.1124Z" fill="currentColor"/>
    </svg>`
        },
        {
          type: 'footer',
          name: 'Footer',
          icon: '<svg width="45" height="45" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="4" y="4" width="16" height="16" rx="1"/><line x1="4" y1="15" x2="20" y2="15"/><line x1="7" y1="17.5" x2="10" y2="17.5" stroke-width="1"/><line x1="14" y1="17.5" x2="17" y2="17.5" stroke-width="1"/></svg>'
        }
      ],

      layoutBlocks: [
        {
          type: 'card',
          name: 'Cards',
          icon: `<svg width="60" height="40" viewBox="0 0 60 40" fill="none">
      <rect x="8" y="8" width="44" height="24" rx="4" stroke="currentColor" stroke-width="2"/>
      <rect x="12" y="12" width="14" height="16" rx="2" fill="currentColor"/>
      <line x1="30" y1="14" x2="48" y2="14" stroke="currentColor" stroke-width="2"/>
      <line x1="30" y1="19" x2="48" y2="19" stroke="currentColor" stroke-width="1.5"/>
      <line x1="30" y1="24" x2="44" y2="24" stroke="currentColor" stroke-width="1.5"/>
    </svg>`
        },
        {
          type: 'table',
          name: 'Tabela',
          icon: `<svg width="60" height="40" viewBox="0 0 60 40" fill="none">
      <rect x="8" y="8" width="44" height="24" rx="2" stroke="currentColor" stroke-width="2"/>
      <line x1="8" y1="16" x2="52" y2="16" stroke="currentColor" stroke-width="2"/>
      <line x1="8" y1="24" x2="52" y2="24" stroke="currentColor" stroke-width="2"/>
      <line x1="22" y1="8" x2="22" y2="32" stroke="currentColor" stroke-width="2"/>
      <line x1="38" y1="8" x2="38" y2="32" stroke="currentColor" stroke-width="2"/>
    </svg>`
        }
      ],

      mediaBlocks: [
        {
          type: 'image',
          name: 'Imagem',
          icon: '<svg width="45" height="45" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="4" y="4" width="16" height="16" rx="1"/><path d="M4 16l4-4 3 3 5-5 4 4"/><circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/></svg>'
        },
        {
          type: 'video',
          name: 'Vídeo',
          icon: `<svg width="60" height="40" viewBox="0 0 60 40" fill="none">
      <rect x="8" y="8" width="44" height="24" rx="2" stroke="currentColor" stroke-width="2"/>
      <rect x="15.5" y="7.5" width="1" height="25" rx="0.5" fill="currentColor" stroke="currentColor"/>
      <rect x="47.5" y="11.5" width="1" height="1" rx="0.5" fill="currentColor" stroke="currentColor"/>
      <rect x="11.5" y="11.5" width="1" height="1" rx="0.5" fill="currentColor" stroke="currentColor"/>
      <rect x="47.5" y="15.5" width="1" height="1" rx="0.5" fill="currentColor" stroke="currentColor"/>
      <rect x="11.5" y="15.5" width="1" height="1" rx="0.5" fill="currentColor" stroke="currentColor"/>
      <rect x="47.5" y="19.5" width="1" height="1" rx="0.5" fill="currentColor" stroke="currentColor"/>
      <rect x="11.5" y="19.5" width="1" height="1" rx="0.5" fill="currentColor" stroke="currentColor"/>
      <rect x="47.5" y="23.5" width="1" height="1" rx="0.5" fill="currentColor" stroke="currentColor"/>
      <rect x="11.5" y="23.5" width="1" height="1" rx="0.5" fill="currentColor" stroke="currentColor"/>
      <rect x="47.5" y="27.5" width="1" height="1" rx="0.5" fill="currentColor" stroke="currentColor"/>
      <rect x="11.5" y="27.5" width="1" height="1" rx="0.5" fill="currentColor" stroke="currentColor"/>
      <rect x="43.5" y="7.5" width="1" height="25" rx="0.5" fill="currentColor" stroke="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M38 20C38 24.4183 34.4183 28 30 28C25.5817 28 22 24.4183 22 20C22 15.5817 25.5817 12 30 12C34.4183 12 38 15.5817 38 20ZM28.6219 16.4146C28.3561 16.2374 28 16.4279 28 16.7474V23.2526C28 23.5721 28.3561 23.7626 28.6219 23.5854L33.5008 20.3328C33.7383 20.1745 33.7383 19.8255 33.5008 19.6672L28.6219 16.4146Z" fill="currentColor"/>
    </svg>`
        }
      ]
    };
  },

  computed: {
    canProceedWithSave() {
      return this.complianceChecks.hasConsent &&
        this.complianceChecks.hasProof &&
        this.complianceChecks.understandsRules;
    },

    // 🆕 Verifica se tem link de descadastro
    hasUnsubscribeLink() {
      return this.detectUnsubscribeLink(this.generateHTML());
    },

    canvasStyle() {
      return {
        backgroundColor: this.globalSettings.backgroundColor,
        maxWidth: this.globalSettings.maxWidth,
        padding: this.globalSettings.padding + 'px',
        margin: '0 auto'
      };
    }
  },

  watch: {
    previewMode(newMode) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.adjustIframeHeight();
        }, 350);
      });
    },

    selectedIndex(newVal) {
      if (newVal !== null) {
        this.activeTab = 'edit';
      }
    },

    // Watch profundo nos componentes
    components: {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
      deep: true
    }
  },

  mounted() {
    if (this.templateData) {
      this.loadTemplateFromData(this.templateData);
    } else if (this.templateId) {
      this.loadTemplate(this.templateId);
    }
  },

  methods: {

    // 🆕 MÉTODOS DA TABELA - ATUALIZADOS
    forceUpdate() {
      this.$forceUpdate();
    },

    addTableHeader(index) {
      const comp = this.components[index];
      comp.headers.push('Nova Coluna');

      // Adiciona célula vazia em todas as linhas existentes
      comp.rows.forEach(row => {
        row.push('');
      });

      this.$forceUpdate();
    },

    removeTableHeader(index, headerIdx) {
      const comp = this.components[index];

      if (comp.headers.length <= 1) {
        this.showAlertModal('Atenção', 'A tabela precisa ter pelo menos 1 coluna!');
        return;
      }

      // Remove o cabeçalho
      comp.headers.splice(headerIdx, 1);

      // Remove a célula correspondente em todas as linhas
      comp.rows.forEach(row => {
        row.splice(headerIdx, 1);
      });

      this.$forceUpdate();
    },

    addTableRow(index) {
      const comp = this.components[index];
      const headerCount = comp.headers.length;
      const newRow = Array(headerCount).fill('');
      comp.rows.push(newRow);
      this.$forceUpdate();
    },

    removeTableRow(index, rowIdx) {
      const comp = this.components[index];

      if (comp.rows.length <= 1) {
        this.showAlertModal('Atenção', 'A tabela precisa ter pelo menos 1 linha!');
        return;
      }

      comp.rows.splice(rowIdx, 1);
      this.$forceUpdate();
    },

    setTableAlignment(index, align) {
      this.$set(this.components[index], 'headerAlign', align);
      this.$set(this.components[index], 'cellAlign', align);
      this.$forceUpdate();
    },

    showTableVariableInsertion(varKey) {
      const comp = this.components[this.selectedIndex];

      // Encontra o label da variável
      const variable = this.availableVariables.find(v => v.key === varKey);
      const varLabel = variable ? variable.label : varKey;

      // Cria modal melhorado
      const modalHtml = `
    <div id="table-var-modal" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.6); display: flex; align-items: center; justify-content: center; z-index: 10000; backdrop-filter: blur(4px);">
      <div style="background: white; border-radius: 16px; max-width: 700px; width: 90%; padding: 0; max-height: 85vh; overflow: hidden; box-shadow: 0 20px 60px rgba(0,0,0,0.3); animation: slideIn 0.3s ease-out;">
        
        <!-- Header -->
        <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 25px 30px; border-radius: 16px 16px 0 0;">
          <h3 style="margin: 0; color: white; font-size: 20px; font-weight: 600; display: flex; align-items: center; gap: 12px;">
            <i class="fa-solid fa-table-cells" style="font-size: 24px;"></i>
            Inserir Variável na Tabela
          </h3>
          <p style="margin: 8px 0 0 0; color: rgba(255,255,255,0.9); font-size: 14px;">
            Escolha em qual célula deseja inserir: <strong>${varLabel}</strong>
          </p>
        </div>

        <!-- Body -->
        <div style="padding: 30px; max-height: calc(85vh - 180px); overflow-y: auto;">
          
          <!-- Preview da variável -->
          <div style="background: linear-gradient(135deg, #667eea15 0%, #764ba215 100%); border: 2px solid #667eea40; border-radius: 12px; padding: 20px; margin-bottom: 25px; text-align: center;">
            <div style="font-size: 13px; color: #666; margin-bottom: 8px; font-weight: 500;">
              <i class="fa-solid fa-code"></i> Variável Selecionada
            </div>
            <div style="display: inline-block; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 8px 20px; border-radius: 8px; font-weight: 700; font-size: 16px; box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4); font-family: 'Courier New', monospace;">
              ${varLabel}
            </div>
          </div>

          <div style="margin-bottom: 15px;">
            <h4 style="margin: 0 0 15px 0; color: #333; font-size: 16px; font-weight: 600; display: flex; align-items: center; gap: 8px;">
              <i class="fa-solid fa-hand-pointer"></i>
              Clique na célula onde deseja inserir
            </h4>
          </div>

          <!-- Grid de células -->
<div id="table-cells-grid" style="display: grid; grid-template-columns: repeat(${Math.min(comp.headers.length, 4)}, 1fr); gap: 15px; margin-bottom: 20px;">
  ${comp.rows.map((row, rowIdx) =>
        row.map((cell, cellIdx) => {
          const hasContent = cell && cell.trim().length > 0;
          const headerName = comp.headers[cellIdx] || `Coluna ${cellIdx + 1}`;

          return `
        <button 
          class="table-cell-btn" 
          data-row="${rowIdx}" 
          data-cell="${cellIdx}"
          style="
            padding: 0;
            background: white;
            border: 2px solid ${hasContent ? '#667eea' : '#e0e0e0'};
            border-radius: 12px;
            cursor: pointer;
            text-align: center;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            box-shadow: 0 2px 8px rgba(0,0,0,0.08);
            position: relative;
            overflow: hidden;
            min-height: 120px;
            display: flex;
            flex-direction: column;
          "
          onmouseover="
            this.style.borderColor='#667eea';
            this.style.transform='translateY(-4px) scale(1.02)';
            this.style.boxShadow='0 8px 24px rgba(102, 126, 234, 0.3)';
            this.querySelector('.cell-header').style.background='linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
            this.querySelector('.cell-header').style.color='white';
          "
          onmouseout="
            this.style.borderColor='${hasContent ? '#667eea' : '#e0e0e0'}';
            this.style.transform='translateY(0) scale(1)';
            this.style.boxShadow='0 2px 8px rgba(0,0,0,0.08)';
            this.querySelector('.cell-header').style.background='${hasContent ? 'linear-gradient(135deg, #667eea20 0%, #764ba220 100%)' : '#f8f9fa'}';
            this.querySelector('.cell-header').style.color='#333';
          ">
          
          <!-- Header do Card -->
          <div class="cell-header" style="
            background: ${hasContent ? 'linear-gradient(135deg, #667eea20 0%, #764ba220 100%)' : '#f8f9fa'};
            padding: 12px 10px;
            border-bottom: 1px solid #e0e0e0;
            transition: all 0.3s;
          ">
            <div style="
              font-size: 12px;
              font-weight: 600;
              color: #333;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 6px;
              line-height: 1.3;
              word-break: break-word;
            ">
              <i class="fa-solid fa-table-cells" style="font-size: 14px; opacity: 0.7;"></i>
              <span>${headerName}</span>
            </div>
          </div>

          <!-- Body do Card -->
          <div style="
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 12px 10px;
            gap: 8px;
          ">
            <!-- Badge de Linha -->
            <div style="
              display: inline-flex;
              align-items: center;
              gap: 4px;
              padding: 4px 10px;
              background: linear-gradient(135deg, #667eea15 0%, #764ba215 100%);
              border: 1px solid #667eea30;
              border-radius: 20px;
              font-size: 11px;
              font-weight: 600;
              color: #667eea;
            ">
              <i class="fa-solid fa-list-ol" style="font-size: 10px;"></i>
              Linha ${rowIdx + 1}
            </div>

            <!-- Status -->
            ${hasContent ? `
              <div style="
                display: inline-flex;
                align-items: center;
                gap: 4px;
                padding: 4px 10px;
                background: linear-gradient(135deg, #28a74515 0%, #20c99715 100%);
                border: 1px solid #28a74530;
                border-radius: 20px;
                font-size: 10px;
                font-weight: 600;
                color: #28a745;
                margin-top: 4px;
              ">
                <i class="fa-solid fa-check-circle"></i>
                Com conteúdo
              </div>
            ` : `
              <div style="
                display: inline-flex;
                align-items: center;
                gap: 4px;
                padding: 4px 10px;
                background: #f8f9fa;
                border: 1px solid #e0e0e0;
                border-radius: 20px;
                font-size: 10px;
                font-weight: 600;
                color: #999;
                margin-top: 4px;
              ">
                <i class="fa-solid fa-circle" style="font-size: 6px;"></i>
                Vazio
              </div>
            `}
          </div>

          <!-- Hover Indicator -->
          <div style="
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 3px;
            background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
            transform: scaleX(0);
            transition: transform 0.3s;
          " class="hover-indicator"></div>
        </button>
      `;
        }).join('')
      ).join('')}
</div>
          <!-- Info -->
          <div style="background: #f8f9fa; border-left: 4px solid #667eea; padding: 15px; border-radius: 8px; margin-top: 20px;">
            <div style="display: flex; align-items: start; gap: 12px;">
              <i class="fa-solid fa-lightbulb" style="color: #667eea; font-size: 20px; margin-top: 2px;"></i>
              <div>
                <div style="font-weight: 600; color: #333; margin-bottom: 4px; font-size: 14px;">Dica</div>
                <div style="font-size: 13px; color: #666; line-height: 1.5;">
                  A variável será <strong>adicionada ao final</strong> do conteúdo existente na célula. Você pode editar depois se necessário.
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div style="padding: 20px 30px; border-top: 1px solid #e0e0e0; background: #f8f9fa; border-radius: 0 0 16px 16px; display: flex; justify-content: flex-end;">
          <button 
            id="cancel-table-var" 
            style="
              padding: 12px 24px; 
              background: white; 
              color: #666; 
              border: 2px solid #e0e0e0; 
              border-radius: 8px; 
              cursor: pointer; 
              font-size: 14px; 
              font-weight: 600;
              transition: all 0.2s;
            "
            onmouseover="this.style.background='#f8f9fa'; this.style.borderColor='#ccc';"
            onmouseout="this.style.background='white'; this.style.borderColor='#e0e0e0';">
            <i class="fa-solid fa-xmark"></i> Cancelar
          </button>
        </div>
      </div>
    </div>

    <style>
      @keyframes slideIn {
        from {
          opacity: 0;
          transform: translateY(-20px) scale(0.95);
        }
        to {
          opacity: 1;
          transform: translateY(0) scale(1);
        }
      }
    </style>
  `;

      const modalContainer = document.createElement('div');
      modalContainer.innerHTML = modalHtml;
      document.body.appendChild(modalContainer);

      // Event listeners para as células
      const cellButtons = modalContainer.querySelectorAll('.table-cell-btn');
      cellButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          const rowIdx = parseInt(btn.getAttribute('data-row'));
          const cellIdx = parseInt(btn.getAttribute('data-cell'));

          // Insere a variável
          const currentValue = comp.rows[rowIdx][cellIdx] || '';
          const separator = currentValue ? ' ' : ''; // Adiciona espaço se já tem conteúdo
          this.$set(comp.rows[rowIdx], cellIdx, currentValue + separator + `{{ params.${varKey} }}`);
          this.$forceUpdate();

          // Fecha modal com animação
          const modal = document.getElementById('table-var-modal');
          modal.style.animation = 'slideOut 0.2s ease-in';
          setTimeout(() => {
            document.body.removeChild(modalContainer);
          }, 200);

          // Mostra confirmação
          this.showAlertModal('✅ Sucesso', `Variável "${varLabel}" inserida na célula ${comp.headers[cellIdx]} - Linha ${rowIdx + 1}`);
        });
      });

      // Botão cancelar
      const cancelBtn = modalContainer.querySelector('#cancel-table-var');
      cancelBtn.addEventListener('click', () => {
        const modal = document.getElementById('table-var-modal');
        modal.style.animation = 'slideOut 0.2s ease-in';
        setTimeout(() => {
          document.body.removeChild(modalContainer);
        }, 200);
      });

      // Fechar ao clicar fora
      const overlay = modalContainer.querySelector('#table-var-modal');
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
          overlay.style.animation = 'slideOut 0.2s ease-in';
          setTimeout(() => {
            document.body.removeChild(modalContainer);
          }, 200);
        }
      });
    },

    insertVariableInButton(variableKey) {
      const comp = this.components[this.selectedIndex];
      // 🔥 ADICIONA O PREFIXO params.
      const variableTag = `{{ params.${variableKey} }}`;

      if (variableKey === 'LINK_PAGAMENTO') {
        this.$set(comp, 'url', variableTag);
        this.showAlertModal('Sucesso', 'Variável inserida no link do botão!');
      } else {
        const currentText = comp.text || '';
        this.$set(comp, 'text', currentText + ' ' + variableTag);
        this.showAlertModal('Sucesso', 'Variável inserida no texto do botão!');
      }
    },
    openLinkEditor(componentType) {
      const comp = this.components[this.selectedIndex];

      let textElement;
      if (componentType === 'text') {
        textElement = this.$refs.textContentArea;
      } else {
        textElement = this.$refs.headingContentInput;
      }

      if (!textElement) {
        this.showAlertModal('Erro', 'Elemento de texto não encontrado');
        return;
      }

      const start = textElement.selectionStart;
      const end = textElement.selectionEnd;
      const selectedText = comp.content.substring(start, end);

      if (!selectedText || selectedText.trim().length === 0) {
        this.showAlertModal('Atenção', 'Por favor, selecione o texto que deseja transformar em link.');
        return;
      }

      this.linkData = {
        componentType: componentType,
        selectedText: selectedText,
        url: '',
        startPos: start,
        endPos: end
      };

      this.showLinkModal = true;

      this.$nextTick(() => {
        const urlInput = document.getElementById('link-url-input');
        if (urlInput) urlInput.focus();
      });
    },

    insertLink() {
      if (!this.linkData.url || this.linkData.url.trim().length === 0) {
        this.showAlertModal('Erro', 'Por favor, digite uma URL válida.');
        return;
      }

      // Valida URL
      let url = this.linkData.url.trim();
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = 'https://' + url;
      }

      const comp = this.components[this.selectedIndex];
      const content = comp.content;

      const beforeLink = content.substring(0, this.linkData.startPos);
      const afterLink = content.substring(this.linkData.endPos);

      const linkHtml = `<a href="${url}" target="_blank" style="color: #007bff; text-decoration: underline;">${this.linkData.selectedText}</a>`;

      const newContent = beforeLink + linkHtml + afterLink;

      this.$set(comp, 'content', newContent);

      this.showLinkModal = false;
      this.showAlertModal('Sucesso', 'Link inserido com sucesso! A Brevo rastreará os cliques automaticamente.');
    },

    closeLinkModal() {
      this.showLinkModal = false;
      this.linkData = {
        componentType: '',
        selectedText: '',
        url: '',
        startPos: 0,
        endPos: 0
      };
    },
    processContentForEmail(content) {
      if (!content) return '';

      let processed = content.replace(/\n/g, '<br>');

      processed = processed.replace(/\{\{\s*contact\.(\w+)\s*\}\}/g, (match) => {
        return `<strong>${match}</strong>`;
      });

      return processed;
    },

    processContentForPreview(content) {
      if (!content) return '';

      let processed = content.replace(/\n/g, '<br>');

      const isInsideHref = (text, index) => {
        const before = text.substring(Math.max(0, index - 120), index);
        return /href\s*=\s*["'][^"']*$/i.test(before) || /src\s*=\s*["'][^"']*$/i.test(before);
      };

      const highlightSpan = (variableName) => {
        return `<span style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 3px 10px; border-radius: 4px; font-weight: 700; font-size: 0.95em; display: inline-block; margin: 0 3px; box-shadow: 0 2px 6px rgba(102, 126, 234, 0.4); white-space: nowrap; font-family: 'Courier New', monospace;"><strong>${variableName}</strong></span>`;
      };

      // 🔥 REGEX ATUALIZADO
      processed = processed.replace(/(<a\b[^>]*>)(\s*\{\{\s*params\.([A-Z0-9_]+)\s*\}\}\s*)(<\/a>)/gi, (match, openTag, varText, variableName, closeTag) => {
        return `${openTag}${highlightSpan(variableName)}${closeTag}`;
      });

      processed = processed.replace(/\{\{\s*params\.([A-Z0-9_]+)\s*\}\}/gi, (match, variableName, offset) => {
        if (isInsideHref(processed, offset)) {
          return match;
        }
        return highlightSpan(variableName);
      });

      return processed;
    },


    insertVariable(componentType, variableKey) {
      const comp = this.components[this.selectedIndex];

      // 🔥 ADICIONA O PREFIXO params.
      let variableTag;
      if (variableKey === 'LINK_PAGAMENTO') {
        variableTag = `<strong><a href="{{ params.${variableKey} }}" target="_blank" style="color: #007bff; text-decoration: underline;">{{ params.${variableKey} }}</a></strong>`;
      } else {
        variableTag = `<strong>{{ params.${variableKey} }}</strong>`;
      }

      if (componentType === 'text') {
        this.$nextTick(() => {
          const textarea = this.$refs.textContentArea;

          if (textarea) {
            const start = textarea.selectionStart || 0;
            const end = textarea.selectionEnd || 0;
            const text = comp.content || '';
            const newContent = text.substring(0, start) + variableTag + text.substring(end);
            this.$set(comp, 'content', newContent);

            this.$nextTick(() => {
              const newPosition = start + variableTag.length;
              textarea.focus();
              textarea.setSelectionRange(newPosition, newPosition);
            });
          } else {
            const currentContent = comp.content || '';
            this.$set(comp, 'content', currentContent + ' ' + variableTag);
          }
        });

      } else if (componentType === 'heading') {
        this.$nextTick(() => {
          const input = this.$refs.headingContentInput;

          if (input) {
            const start = input.selectionStart || 0;
            const end = input.selectionEnd || 0;
            const text = comp.content || '';
            const newContent = text.substring(0, start) + variableTag + text.substring(end);
            this.$set(comp, 'content', newContent);

            this.$nextTick(() => {
              const newPosition = start + variableTag.length;
              input.focus();
              input.setSelectionRange(newPosition, newPosition);
            });
          } else {
            const currentContent = comp.content || '';
            this.$set(comp, 'content', currentContent + ' ' + variableTag);
          }
        });
      }
    },

    // 🆕 Método para remover imagem do card
    async removeCardImage(componentIndex, gridItemIndex = null) {
      const comp = this.components[componentIndex];

      this.showConfirm(
        'Remover Imagem?',
        'Esta ação não pode ser desfeita. A imagem será excluída do servidor.',
        'Remover',
        async () => {
          try {
            this.saving = true;

            let imageUrl = '';

            // Determina qual imagem remover
            if (gridItemIndex !== null) {
              // Grid item
              imageUrl = comp.gridItems[gridItemIndex].imageUrl;
            } else {
              // Card normal
              imageUrl = comp.imageUrl;
            }

            if (!imageUrl) {
              this.showAlertModal('Aviso', 'Nenhuma imagem para remover');
              return;
            }

            // Extrai o filename da URL
            const filename = imageUrl.split('/').pop();

            // Chama a API para deletar a imagem
            const response = await fetch('/emails/api/brevo/delete-image', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
              },
              body: JSON.stringify({
                filename: filename,
                template_id: this.templateId
              })
            });

            const result = await response.json();

            if (result.success) {
              // Remove a URL da imagem do componente
              if (gridItemIndex !== null) {
                this.$set(comp.gridItems[gridItemIndex], 'imageUrl', '');
                this.$set(comp.gridItems[gridItemIndex], 'imageAlt', '');
                this.$set(comp.gridItems[gridItemIndex], 'imagePosition', 'center');
                this.$set(comp.gridItems[gridItemIndex], 'imageZoom', 1);
              } else {
                this.$set(comp, 'imageUrl', '');
                this.$set(comp, 'imageAlt', '');
                this.$set(comp, 'imagePosition', 'center');
                this.$set(comp, 'imageZoom', 1);
              }

              // Força atualização
              this.updateTrigger++;
              this.$forceUpdate();

              this.showAlertModal('Sucesso', 'Imagem removida com sucesso!');
            } else {
              throw new Error(result.message || 'Erro ao remover imagem');
            }
          } catch (error) {
            console.error('Erro ao remover imagem:', error);
            this.showAlertModal('Erro', error.message || 'Erro ao remover imagem');
          } finally {
            this.saving = false;
          }
        }
      );
    },

    // O método removeSimpleImage também precisa ser movido para cá
    async removeSimpleImage(componentIndex) {
      const comp = this.components[componentIndex];

      this.showConfirm(
        'Remover Imagem?',
        'Esta ação não pode ser desfeita. A imagem será excluída do servidor.',
        'Remover',
        async () => {
          try {
            this.saving = true;

            const imageUrl = comp.src;

            if (!imageUrl) {
              this.showAlertModal('Aviso', 'Nenhuma imagem para remover');
              return;
            }

            const filename = imageUrl.split('/').pop();

            const response = await fetch('/emails/api/brevo/delete-image', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
              },
              body: JSON.stringify({
                filename: filename,
                template_id: this.templateId
              })
            });

            const result = await response.json();

            if (result.success) {
              this.$set(comp, 'src', '');
              this.$set(comp, 'alt', '');

              this.$forceUpdate();

              this.showAlertModal('Sucesso', 'Imagem removida com sucesso!');
            } else {
              throw new Error(result.message || 'Erro ao remover imagem');
            }
          } catch (error) {
            console.error('Erro ao remover imagem:', error);
            this.showAlertModal('Erro', error.message || 'Erro ao remover imagem');
          } finally {
            this.saving = false;
          }
        }
      );
    },

    getEditorImageStyle() {
      const offset = this.editingImage.offsetX || 0;
      const offsetY = this.editingImage.offsetY || 0;
      const zoom = this.editingImage.zoom || 1;

      // Converte offset para object-position
      const percentX = 50 - (offset / 2);
      const percentY = 50 - (offsetY / 2);

      return {
        objectFit: 'cover',
        objectPosition: `${percentX}% ${percentY}%`,
        transform: zoom > 1 ? `scale(${zoom})` : 'none',
        transformOrigin: `${percentX}% ${percentY}%`
      };
    },

    getEditingComponent() {
      const compIndex = this.editingImage.componentIndex;
      return this.components[compIndex] || {};
    },

    getEditingLayout() {
      const comp = this.getEditingComponent();
      return comp.layout || '';
    },

    getEditingGridItem() {
      const comp = this.getEditingComponent();
      const itemIndex = this.editingImage.gridItemIndex;
      if (itemIndex !== null && comp.gridItems) {
        return comp.gridItems[itemIndex] || {};
      }
      return {};
    },

    getPreviewBannerStyle() {
      const comp = this.getEditingComponent();
      return {
        height: (comp.bannerHeight || 400) + 'px'
      };
    },

    getBannerOverlayStyle() {
      const comp = this.getEditingComponent();
      return {
        background: `rgba(0, 0, 0, ${comp.overlayOpacity || 0.4})`
      };
    },

    getPreviewImageStyle() {
      const offset = this.editingImage.offsetX || 0;
      const offsetY = this.editingImage.offsetY || 0;
      const zoom = this.editingImage.zoom || 1;

      const percentX = 50 - (offset / 2);
      const percentY = 50 - (offsetY / 2);

      return {
        objectFit: 'cover',
        objectPosition: `${percentX}% ${percentY}%`,
        transform: zoom > 1 ? `scale(${zoom})` : 'none',
        transformOrigin: `${percentX}% ${percentY}%`,
        transition: 'all 0.05s ease-out'
      };
    },

    getDraggableImageStyle() {
      const offset = this.editingImage.offsetX || 0;
      const offsetY = this.editingImage.offsetY || 0;
      const zoom = this.editingImage.zoom || 1;

      const translateX = (offset / 100) * 50;
      const translateY = (offsetY / 100) * 50;

      return {
        transform: `translate(${translateX}%, ${translateY}%) scale(${zoom})`,
        transformOrigin: 'center center'
      };
    },

    getEditingImageUrl() {
      const compIndex = this.editingImage.componentIndex;
      const itemIndex = this.editingImage.gridItemIndex;
      const comp = this.components[compIndex];

      if (!comp) return '';

      if (itemIndex !== null && comp.gridItems) {
        return comp.gridItems[itemIndex]?.imageUrl || '';
      }

      return comp.imageUrl || comp.src || '';
    },

    startImageEdit(componentIndex, gridItemIndex = null) {

      const comp = this.components[componentIndex];
      let currentPosition, currentZoom;

      if (gridItemIndex !== null) {
        currentPosition = comp.gridItems[gridItemIndex].imagePosition || 'center';
        currentZoom = comp.gridItems[gridItemIndex].imageZoom || 1;
      } else {
        currentPosition = comp.imagePosition || 'center';
        currentZoom = comp.imageZoom || 1;
      }

      this.editingImage = {
        active: true,
        componentIndex,
        gridItemIndex,
        isDragging: false,
        startX: 0,
        startY: 0,
        offsetX: 0,
        offsetY: 0,
        zoom: currentZoom,
        minZoom: 0.5,
        maxZoom: 3
      };

      // Converte position para offset
      this.loadPositionToOffset(currentPosition);

      // Impede scroll da página
      document.body.style.overflow = 'hidden';

      // Força atualização
      this.updateTrigger++;
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },

    stopImageEdit() {
      this.editingImage.active = false;
      document.body.style.overflow = '';

      // Salva a posição final
      this.saveImagePosition();

      // Força atualização
      this.updateTrigger++;
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },

    loadPositionToOffset(position) {
      // Converte CSS position (ex: "30% 70%") para offset
      const matches = position.match(/([\d.]+)%\s+([\d.]+)%/);
      if (matches) {
        // Normaliza de 0-100% para -100 a +100 offset
        this.editingImage.offsetX = (parseFloat(matches[1]) - 50) * 2;
        this.editingImage.offsetY = (parseFloat(matches[2]) - 50) * 2;
      } else {
        this.editingImage.offsetX = 0;
        this.editingImage.offsetY = 0;
      }
    },

    onImageMouseDown(event) {
      if (!this.editingImage.active) return;

      event.preventDefault();
      event.stopPropagation();

      this.editingImage.isDragging = true;
      this.editingImage.startX = event.clientX;
      this.editingImage.startY = event.clientY;

      const moveHandler = this.onImageMouseMove.bind(this);
      const upHandler = () => {
        this.editingImage.isDragging = false;
        document.removeEventListener('mousemove', moveHandler);
        document.removeEventListener('mouseup', upHandler);
      };

      document.addEventListener('mousemove', moveHandler);
      document.addEventListener('mouseup', upHandler);
    },

    onImageMouseMove(event) {
      if (!this.editingImage.isDragging) return;

      const deltaX = event.clientX - this.editingImage.startX;
      const deltaY = event.clientY - this.editingImage.startY;

      // Sensibilidade de movimento ajustada
      this.editingImage.offsetX += deltaX * 0.3;
      this.editingImage.offsetY += deltaY * 0.3;

      // Limita os valores
      this.editingImage.offsetX = Math.max(-100, Math.min(100, this.editingImage.offsetX));
      this.editingImage.offsetY = Math.max(-100, Math.min(100, this.editingImage.offsetY));

      this.editingImage.startX = event.clientX;
      this.editingImage.startY = event.clientY;

      this.updateImagePositionRealtime();
    },

    onImageWheel(event) {
      if (!this.editingImage.active) return;

      event.preventDefault();

      const delta = event.deltaY > 0 ? -0.1 : 0.1;
      this.editingImage.zoom += delta;

      this.editingImage.zoom = Math.max(
        this.editingImage.minZoom,
        Math.min(this.editingImage.maxZoom, this.editingImage.zoom)
      );

      this.updateImagePositionRealtime();
    },

    updateImagePositionRealtime() {
      const compIndex = this.editingImage.componentIndex;
      const itemIndex = this.editingImage.gridItemIndex;
      const comp = this.components[compIndex];

      const percentX = 50 - (this.editingImage.offsetX / 2);
      const percentY = 50 - (this.editingImage.offsetY / 2);
      const positionValue = `${percentX.toFixed(1)}% ${percentY.toFixed(1)}%`;

      if (itemIndex !== null) {
        this.$set(comp.gridItems[itemIndex], 'imagePosition', positionValue);
        this.$set(comp.gridItems[itemIndex], 'imageZoom', this.editingImage.zoom);
      } else {
        this.$set(comp, 'imagePosition', positionValue);
        this.$set(comp, 'imageZoom', this.editingImage.zoom);
      }

      this.$forceUpdate();
    },

    saveImagePosition() {
      this.updateImagePositionRealtime();
    },

    resetImageEdit() {
      this.editingImage.offsetX = 0;
      this.editingImage.offsetY = 0;
      this.editingImage.zoom = 1;
      this.updateImagePositionRealtime();
    },

    increaseZoom() {
      if (this.editingImage.zoom < this.editingImage.maxZoom) {
        this.editingImage.zoom += 0.1;
        this.updateImagePositionRealtime();
      }
    },

    decreaseZoom() {
      if (this.editingImage.zoom > this.editingImage.minZoom) {
        this.editingImage.zoom -= 0.1;
        this.updateImagePositionRealtime();
      }
    },

    forceComponentUpdate(index) {
      const comp = this.components[index];
      this.components.splice(index, 1, { ...comp });
      this.$forceUpdate();
    },
    openImagePositionEditor(componentIndex, gridItemIndex = null) {
      const comp = this.components[componentIndex];

      let imageUrl = '';
      let viewportWidth = 600;
      let viewportHeight = 400;

      if (gridItemIndex !== null) {
        // Grid item
        imageUrl = comp.gridItems[gridItemIndex].imageUrl;
        viewportHeight = comp.gridImageHeight || 180;
      } else if (comp.layout === 'banner') {
        // Banner
        imageUrl = comp.imageUrl;
        viewportHeight = comp.bannerHeight || 400;
      } else if (comp.layout === 'image-top') {
        // Image top
        imageUrl = comp.imageUrl;
        viewportHeight = comp.imageHeight || 200;
      } else {
        // Image left/right
        imageUrl = comp.imageUrl;
        viewportHeight = 300;
      }

      if (!imageUrl) {
        this.showAlertModal('Erro', 'Adicione uma imagem primeiro!');
        return;
      }

      this.imagePositionData = {
        componentIndex,
        gridItemIndex,
        imageUrl,
        viewportWidth,
        viewportHeight,
        offsetX: 0,
        offsetY: 0,
        zoom: 1,
        isDragging: false,
        startX: 0,
        startY: 0,
        imageWidth: 0,
        imageHeight: 0
      };

      this.showImagePositionEditor = true;

      // Carrega a posição atual se existir
      this.$nextTick(() => {
        this.loadCurrentPosition(componentIndex, gridItemIndex);
      });
    },

    loadCurrentPosition(componentIndex, gridItemIndex) {
      const comp = this.components[componentIndex];
      let currentPosition = '';

      if (gridItemIndex !== null) {
        currentPosition = comp.gridItems[gridItemIndex].imagePosition || 'center';
      } else {
        currentPosition = comp.imagePosition || 'center';
      }

      // Converte position CSS para offset
      this.positionToOffset(currentPosition);
    },

    positionToOffset(position) {
      const viewport = this.imagePositionData;

      // Calcula os offsets baseado no position CSS
      switch (position) {
        case 'center':
          viewport.offsetX = 0;
          viewport.offsetY = 0;
          break;
        case 'top':
          viewport.offsetX = 0;
          viewport.offsetY = viewport.viewportHeight / 4;
          break;
        case 'bottom':
          viewport.offsetX = 0;
          viewport.offsetY = -viewport.viewportHeight / 4;
          break;
        case 'left':
          viewport.offsetX = viewport.viewportWidth / 4;
          viewport.offsetY = 0;
          break;
        case 'right':
          viewport.offsetX = -viewport.viewportWidth / 4;
          viewport.offsetY = 0;
          break;
        case 'top left':
          viewport.offsetX = viewport.viewportWidth / 4;
          viewport.offsetY = viewport.viewportHeight / 4;
          break;
        case 'top right':
          viewport.offsetX = -viewport.viewportWidth / 4;
          viewport.offsetY = viewport.viewportHeight / 4;
          break;
        case 'bottom left':
          viewport.offsetX = viewport.viewportWidth / 4;
          viewport.offsetY = -viewport.viewportHeight / 4;
          break;
        case 'bottom right':
          viewport.offsetX = -viewport.viewportWidth / 4;
          viewport.offsetY = -viewport.viewportHeight / 4;
          break;
      }
    },

    closeImagePositionEditor() {
      this.showImagePositionEditor = false;
      this.imagePositionData = {
        componentIndex: null,
        gridItemIndex: null,
        imageUrl: '',
        viewportWidth: 600,
        viewportHeight: 400,
        offsetX: 0,
        offsetY: 0,
        zoom: 1,
        isDragging: false,
        startX: 0,
        startY: 0,
        imageWidth: 0,
        imageHeight: 0
      };
    },

    getViewportStyle() {
      return {
        width: this.imagePositionData.viewportWidth + 'px',
        height: this.imagePositionData.viewportHeight + 'px'
      };
    },

    getImageStyle() {
      const data = this.imagePositionData;
      return {
        width: (data.imageWidth * data.zoom) + 'px',
        height: (data.imageHeight * data.zoom) + 'px',
        transform: `translate(${data.offsetX}px, ${data.offsetY}px)`,
        transition: data.isDragging ? 'none' : 'transform 0.1s ease-out'
      };
    },

    onImageLoad(event) {
      const img = event.target;
      const viewport = this.imagePositionData;

      // Calcula o tamanho da imagem para cobrir o viewport
      const imgRatio = img.naturalWidth / img.naturalHeight;
      const viewportRatio = viewport.viewportWidth / viewport.viewportHeight;

      if (imgRatio > viewportRatio) {
        // Imagem mais larga
        viewport.imageHeight = viewport.viewportHeight;
        viewport.imageWidth = viewport.viewportHeight * imgRatio;
      } else {
        // Imagem mais alta
        viewport.imageWidth = viewport.viewportWidth;
        viewport.imageHeight = viewport.viewportWidth / imgRatio;
      }
    },

    startDragging(event) {
      event.preventDefault();
      const data = this.imagePositionData;
      data.isDragging = true;

      const clientX = event.type === 'touchstart' ? event.touches[0].clientX : event.clientX;
      const clientY = event.type === 'touchstart' ? event.touches[0].clientY : event.clientY;

      data.startX = clientX - data.offsetX;
      data.startY = clientY - data.offsetY;

      document.addEventListener('mousemove', this.onDragging);
      document.addEventListener('mouseup', this.stopDragging);
      document.addEventListener('touchmove', this.onDragging);
      document.addEventListener('touchend', this.stopDragging);
    },

    onDragging(event) {
      if (!this.imagePositionData.isDragging) return;

      const data = this.imagePositionData;
      const clientX = event.type === 'touchmove' ? event.touches[0].clientX : event.clientX;
      const clientY = event.type === 'touchmove' ? event.touches[0].clientY : event.clientY;

      let newOffsetX = clientX - data.startX;
      let newOffsetY = clientY - data.startY;

      // Limita o movimento para não ultrapassar as bordas
      const maxX = (data.imageWidth * data.zoom - data.viewportWidth) / 2;
      const maxY = (data.imageHeight * data.zoom - data.viewportHeight) / 2;

      newOffsetX = Math.max(-maxX, Math.min(maxX, newOffsetX));
      newOffsetY = Math.max(-maxY, Math.min(maxY, newOffsetY));

      data.offsetX = newOffsetX;
      data.offsetY = newOffsetY;
    },

    stopDragging() {
      this.imagePositionData.isDragging = false;
      document.removeEventListener('mousemove', this.onDragging);
      document.removeEventListener('mouseup', this.stopDragging);
      document.removeEventListener('touchmove', this.onDragging);
      document.removeEventListener('touchend', this.stopDragging);
    },

    zoomIn() {
      if (this.imagePositionData.zoom < 3) {
        this.imagePositionData.zoom += 0.1;
      }
    },

    zoomOut() {
      if (this.imagePositionData.zoom > 1) {
        this.imagePositionData.zoom -= 0.1;

        // Reajusta os offsets se necessário
        const data = this.imagePositionData;
        const maxX = (data.imageWidth * data.zoom - data.viewportWidth) / 2;
        const maxY = (data.imageHeight * data.zoom - data.viewportHeight) / 2;

        data.offsetX = Math.max(-maxX, Math.min(maxX, data.offsetX));
        data.offsetY = Math.max(-maxY, Math.min(maxY, data.offsetY));
      }
    },

    resetPosition() {
      this.imagePositionData.offsetX = 0;
      this.imagePositionData.offsetY = 0;
      this.imagePositionData.zoom = 1;
    },

    applyImagePosition() {
      const data = this.imagePositionData;
      const compIndex = data.componentIndex;
      const comp = this.components[compIndex];

      // Calcula as dimensões da imagem com zoom
      const scaledWidth = data.imageWidth * data.zoom;
      const scaledHeight = data.imageHeight * data.zoom;

      // Calcula a posição em porcentagem (invertida)
      let percentX = 50;
      let percentY = 50;

      if (scaledWidth > data.viewportWidth) {
        const normalizedX = -data.offsetX / (scaledWidth - data.viewportWidth);
        percentX = 50 + (normalizedX * 50);
      }

      if (scaledHeight > data.viewportHeight) {
        const normalizedY = -data.offsetY / (scaledHeight - data.viewportHeight);
        percentY = 50 + (normalizedY * 50);
      }

      percentX = Math.max(0, Math.min(100, percentX));
      percentY = Math.max(0, Math.min(100, percentY));

      const positionValue = `${percentX.toFixed(1)}% ${percentY.toFixed(1)}%`;
      const zoomValue = data.zoom;



      // Atualização com zoom
      if (data.gridItemIndex !== null) {
        const updatedGridItems = [...comp.gridItems];
        updatedGridItems[data.gridItemIndex] = {
          ...updatedGridItems[data.gridItemIndex],
          imagePosition: positionValue,
          imageZoom: zoomValue // NOVO
        };

        const updatedComp = {
          ...comp,
          gridItems: updatedGridItems
        };

        this.components.splice(compIndex, 1, updatedComp);
      } else {
        const updatedComp = {
          ...comp,
          imagePosition: positionValue,
          imageZoom: zoomValue // NOVO
        };

        this.components.splice(compIndex, 1, updatedComp);
      }

      this.updateTrigger++;
      this.$nextTick(() => {
        this.$forceUpdate();
      });

      this.showAlertModal('Sucesso', 'Posição da imagem aplicada com zoom!');
      this.closeImagePositionEditor();
    },

    getGridItemsForLayout(index) {
      const layout = this.components[index].layout;
      const items = this.components[index].gridItems;

      if (layout === 'grid-2') return items.slice(0, 2);
      if (layout === 'grid-3') return items.slice(0, 3);
      if (layout === 'grid-4') return items.slice(0, 4);

      return items;
    },

    triggerGridImageUpload(cardIndex, itemIndex) {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.onchange = async (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith('image/')) {
          try {
            this.saving = true;

            const formData = new FormData();
            formData.append('image', file);

            if (this.templateId) {
              formData.append('template_id', this.templateId);
            }

            const response = await fetch('/emails/api/brevo/upload-image', {
              method: 'POST',
              headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
              },
              body: formData
            });

            const result = await response.json();

            if (result.success) {
              this.$set(this.components[cardIndex].gridItems[itemIndex], 'imageUrl', result.url);
              this.showAlertModal('Sucesso', `Imagem enviada com sucesso!`);
            } else {
              this.showAlertModal('Erro', result.message);
            }
          } catch (error) {
            console.error('Erro ao fazer upload:', error);
            this.showAlertModal('Erro', 'Erro ao fazer upload da imagem');
          } finally {
            this.saving = false;
          }
        }
      };
      input.click();
    },
    triggerCardImageUpload(index) {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.onchange = async (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith('image/')) {
          try {
            this.saving = true;

            const formData = new FormData();
            formData.append('image', file);

            if (this.templateId) {
              formData.append('template_id', this.templateId);
            }

            const response = await fetch('/emails/api/brevo/upload-image', {
              method: 'POST',
              headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
              },
              body: formData
            });

            const result = await response.json();

            if (result.success) {
              // Atualiza a propriedade imageUrl (não src!)
              this.$set(this.components[index], 'imageUrl', result.url);
              this.$set(this.components[index], 'imageId', result.imageId);

              this.showAlertModal('Sucesso', `Imagem enviada com sucesso! Tamanho: ${result.size_mb}MB`);
            } else {
              this.showAlertModal('Erro', result.message);
            }
          } catch (error) {
            console.error('Erro ao fazer upload:', error);
            this.showAlertModal('Erro', 'Erro ao fazer upload da imagem');
          } finally {
            this.saving = false;
          }
        } else {
          this.showAlertModal('Erro', 'Por favor, selecione um arquivo de imagem válido');
        }
      };
      input.click();
    },
    openSendTestModal() {
      // Fecha o preview primeiro se estiver aberto
      this.showPreview = false;

      // Pequeno delay para garantir que o preview fechou
      setTimeout(() => {
        this.showSendTestModal = true;
        this.resetTestForm();
      }, 100);
    },

    resetTestForm() {
      this.searchEmail = '';
      this.foundContacts = [];
      this.selectedContato = null;
      this.contatoData = null;
      this.previewParams = {};
      this.testEmails = '';
      this.testSubject = this.emailSubject || '';
      this.sendTestError = '';
      this.sendTestSuccess = '';
    },

    async searchContacts() {
      this.sendTestError = '';
      this.foundContacts = [];
      this.selectedContato = null;

      if (!this.searchEmail.trim()) {
        this.sendTestError = 'Digite um email para buscar';
        return;
      }

      this.searchingContacts = true;

      try {
        const response = await fetch('/emails/api/brevo/search-contacts', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
          },
          body: JSON.stringify({
            email: this.searchEmail
          })
        });

        const result = await response.json();

        if (!response.ok || !result.success) {
          throw new Error(result.message || 'Erro ao buscar contatos');
        }

        this.foundContacts = result.contatos;

        // Se encontrou apenas 1, seleciona automaticamente
        if (this.foundContacts.length === 1) {
          await this.selectContato(this.foundContacts[0]);
        }

      } catch (error) {
        console.error('Erro ao buscar contatos:', error);
        this.sendTestError = error.message;
      } finally {
        this.searchingContacts = false;
      }
    },

    async selectContato(contato) {
      this.selectedContato = contato;
      this.sendTestError = '';

      // Preenche automaticamente o email de destino
      if (!this.testEmails) {
        this.testEmails = contato.email;
      }

      // Busca dados completos do contato
      try {
        const response = await fetch('/emails/api/brevo/get-contato-data', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
          },
          body: JSON.stringify({
            contato_id: contato.id
          })
        });

        const result = await response.json();

        if (result.success) {
          this.contatoData = result.contato;
          this.generatePreviewParams();
        }

      } catch (error) {
        console.error('Erro ao buscar dados do contato:', error);
      }
    },

    generatePreviewParams() {
      // Gera preview dos principais parâmetros
      if (!this.contatoData) return;

      this.previewParams = {
        'NOME': this.contatoData.nome || 'N/A',
        'EMAIL': this.contatoData.email || 'N/A',
        'CPD': this.contatoData.cpd || 'N/A',
        'RAZAO_SOCIAL': this.contatoData.razao_social || 'N/A',
        'CPF_CNPJ': this.contatoData.cpf_cnpj || 'N/A'
        // Adicione outros campos relevantes aqui
      };
    },

    async sendTestEmail() {
      this.sendTestError = '';
      this.sendTestSuccess = '';

      if (!this.selectedContato) {
        this.sendTestError = 'Selecione um contato primeiro!';
        return;
      }

      if (!this.testEmails.trim()) {
        this.sendTestError = 'Digite pelo menos um email de destino!';
        return;
      }

      this.sendingTest = true;

      try {
        const emails = this.testEmails
          .split(',')
          .map(e => e.trim())
          .filter(e => e.length > 0);

        if (emails.length > 10) {
          throw new Error('Máximo de 10 emails por vez.');
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const invalidEmails = emails.filter(e => !emailRegex.test(e));

        if (invalidEmails.length > 0) {
          throw new Error(`Emails inválidos: ${invalidEmails.join(', ')}`);
        }

        const htmlContent = this.generateHTML();

        const response = await fetch('/emails/api/brevo/send-test-email', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
          },
          body: JSON.stringify({
            contato_id: this.selectedContato.id,
            emails: emails,
            subject: this.testSubject || this.emailSubject || 'Email de Teste',
            htmlContent: htmlContent,
            templateName: this.templateName
          })
        });

        const contentType = response.headers.get('content-type');

        if (contentType && contentType.includes('text/html')) {
          throw new Error('Servidor retornou HTML ao invés de JSON. Verifique os logs.');
        }

        const result = await response.json();

        if (!response.ok || !result.success) {
          throw new Error(result.message || 'Erro ao enviar email de teste');
        }

        this.sendTestSuccess = result.message;

        setTimeout(() => {
          this.showSendTestModal = false;
        }, 2500);

      } catch (error) {
        console.error('Erro completo:', error);
        this.sendTestError = error.message || 'Erro ao enviar email de teste.';
      } finally {
        this.sendingTest = false;
      }
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('pt-BR');
    },
    openPreview() {
      this.previewMode = 'desktop';
      this.showPreview = true;

      this.$nextTick(() => {
        const iframe = this.$refs.previewIframe;
        if (iframe) {
          // ✅ PASSA 'preview' como parâmetro para ativar a estilização
          const html = this.generateHTML('preview');
          iframe.srcdoc = html;

          if (iframe.contentWindow && iframe.contentWindow.document.body) {
            this.adjustIframeHeight();
          }
        }
      });
    },

    loadPreviewContent() {
      const iframe = this.$refs.previewIframe;
      if (iframe) {
        const html = this.generateHTML();
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        iframeDoc.open();
        iframeDoc.write(html);
        iframeDoc.close();

        // Remove qualquer scroll do body do iframe
        setTimeout(() => {
          const iframeBody = iframeDoc.body;
          if (iframeBody) {
            iframeBody.style.overflow = 'hidden';
            iframeBody.style.margin = '0';
            iframeBody.style.padding = '0';
          }
          this.adjustIframeHeight();
        }, 100);
      }
    },

    adjustIframeHeight() {
      const iframe = this.$refs.previewIframe;
      if (iframe && iframe.contentWindow) {
        try {
          const iframeDoc = iframe.contentWindow.document;
          const height = iframeDoc.documentElement.scrollHeight;
          iframe.style.height = (height + 20) + 'px'; // +20px de margem de segurança
        } catch (e) {
          iframe.style.height = '800px';
        }
      }
    },

    getIconPath(platform) {
      const base = '/imgs/icons';
      return `${base}/${platform}.svg`;
    },

    // Upload de Imagem
    triggerImageUpload(index) {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.onchange = (e) => this.handleImageUpload(e, index);
      input.click();
    },

    async handleImageUpload(event, index) {
      const file = event.target.files[0];
      if (file && file.type.startsWith('image/')) {
        try {
          this.saving = true;

          const formData = new FormData();
          formData.append('image', file);

          // Adiciona o template_id se existir
          if (this.templateId) {
            formData.append('template_id', this.templateId);
          }

          const response = await fetch('/emails/api/brevo/upload-image', {
            method: 'POST',
            headers: {
              'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
            },
            body: formData
          });

          const result = await response.json();

          if (result.success) {
            this.$set(this.components[index], 'src', result.url);

            // Armazena o ID da imagem para referência futura
            this.$set(this.components[index], 'imageId', result.imageId);

            this.showAlertModal('Sucesso', `Imagem enviada com sucesso! Tamanho: ${result.size_mb}MB`);
          } else {
            this.showAlertModal('Erro', result.message);
          }
        } catch (error) {
          console.error('Erro ao fazer upload:', error);
          this.showAlertModal('Erro', 'Erro ao fazer upload da imagem');
        } finally {
          this.saving = false;
        }
      } else {
        this.showAlertModal('Erro', 'Por favor, selecione um arquivo de imagem válido');
      }
    },

    // Métodos de Modal
    showConfirm(title, message, confirmText, onConfirm) {
      this.confirmData = { title, message, confirmText, onConfirm };
      this.showConfirmModal = true;
    },

    cancelConfirm() {
      this.showConfirmModal = false;
      this.confirmData = { title: '', message: '', confirmText: 'Confirmar', onConfirm: null };
    },

    executeConfirm() {
      if (this.confirmData.onConfirm) {
        this.confirmData.onConfirm();
      }
      this.cancelConfirm();
    },

    showAlertModal(title, message) {
      this.alertData = { title, message };
      this.showAlert = true;
    },

    closeAlert() {
      this.showAlert = false;
      this.alertData = { title: '', message: '' };
    },

    confirmGoBack() {
      this.showConfirm(
        'Deseja sair?',
        'Alterações não salvas serão perdidas, incluindo imagens enviadas.',
        'Sair',
        async () => {
          // 🆕 Deleta apenas imagens NOVAS (não as iniciais)
          if (this.templateId) {
            await this.deleteNewImages(this.templateId);
          }
          this.$emit('close');
        }
      );
    },

    // 🆕 Método para deletar apenas imagens NOVAS
    async deleteNewImages(templateId) {
      try {
        // Extrai imagens atuais do HTML
        const currentHtml = this.generateHTML();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = currentHtml;

        const currentImages = Array.from(tempDiv.querySelectorAll('img[src*="uploads/email-images/"]'))
          .map(img => {
            const url = img.getAttribute('src');
            return url.split('/').pop();
          });

        // Identifica quais são NOVAS (não estavam nas iniciais)
        const newImages = currentImages.filter(img => !this.initialImages.includes(img));

        const response = await fetch('/emails/api/brevo/delete-new-images', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
          },
          body: JSON.stringify({
            template_id: templateId,
            new_images: newImages
          })
        });

        const result = await response.json();

        if (result.success) {
          console.log(`✅ ${result.deleted} imagem(ns) nova(s) removida(s)`);
        }
      } catch (error) {
        console.error('Erro ao deletar imagens novas:', error);
      }
    },

    // 🆕 Método para deletar imagens ao cancelar
    async deleteTemplateImages(templateId) {
      try {
        const response = await fetch('/emails/api/brevo/delete-template-images', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
          },
          body: JSON.stringify({
            template_id: templateId
          })
        });

        const result = await response.json();

        if (result.success) {
          console.log(`✅ ${result.deleted} imagem(ns) removida(s) ao cancelar`);
        }
      } catch (error) {
        console.error('Erro ao deletar imagens:', error);
        // Não bloqueia o fechamento se falhar
      }
    },

    confirmDelete(index) {
      this.showConfirm(
        'Excluir bloco?',
        'Esta ação não pode ser desfeita.',
        'Excluir',
        () => {
          this.components.splice(index, 1);
          this.selectedIndex = null;
          this.activeTab = 'blocks';
        }
      );
    },

    toggleDevice() {
      this.currentDevice = this.currentDevice === 'desktop' ? 'mobile' : 'desktop';
    },

    handleDragStart(block) {
      this.draggedBlock = block;
    },

    handleDrop(e) {
      if (!this.draggedBlock) return;
      const newComponent = this.createComponent(this.draggedBlock.type);
      this.components.push(newComponent);
      this.draggedBlock = null;
      this.selectedIndex = this.components.length - 1;
    },

    createComponent(type) {
      const id = Date.now() + Math.random();
      const defaults = {
        table: {
          headers: ['Empresa', 'Título', 'Nota Fiscal', 'Emissão', 'Vencimento', 'Valor Original'],
          rows: [
            ['{{ params.EMPRESA }}', '{{ params.TITULO }}', '{{ params.NOTA_FISCAL }}', '{{ params.EMISSAO }}', '{{ params.VENCIMENTO }}', '{{ params.VALOR_ORIGINAL }}']
          ],
          headerAlign: 'left',
          cellAlign: 'left',
          headerFontSize: 14,
          cellFontSize: 13,
          headerColor: '#333333',
          cellColor: '#555555',
          borderColor: '#dddddd',
          evenRowColor: '#ffffff',
          oddRowColor: '#f9f9f9'
        },
        card: {
          layout: 'image-left',
          isNew: true,
          imageUrl: '',
          imageAlt: 'Imagem do card',
          imageWidth: 40,
          imageHeight: 200,
          imagePosition: 'center',
          imageZoom: 1,
          imageRadius: 8,
          imageGap: 20,
          gridGap: 20,

          gridItems: [
            { imageUrl: '', imageAlt: '', imagePosition: 'center', imageZoom: 1, title: 'Item 1', description: 'Descrição 1', buttonUrl: '#' },
            { imageUrl: '', imageAlt: '', imagePosition: 'center', imageZoom: 1, title: 'Item 2', description: 'Descrição 2', buttonUrl: '#' },
            { imageUrl: '', imageAlt: '', imagePosition: 'center', imageZoom: 1, title: 'Item 3', description: 'Descrição 3', buttonUrl: '#' },
            { imageUrl: '', imageAlt: '', imagePosition: 'center', imageZoom: 1, title: 'Item 4', description: 'Descrição 4', buttonUrl: '#' }
          ],
          gridImageHeight: 180,

          bannerHeight: 400,
          overlayOpacity: 0.4,

          title: 'Título do Card',
          titleSize: 20,
          titleColor: '#333333',
          titleAlign: 'left',

          description: 'Descrição ou texto do card. Adicione mais detalhes aqui.',
          descriptionSize: 14,
          descriptionColor: '#666666',
          descriptionAlign: 'left',

          buttonText: 'Saiba Mais',
          buttonUrl: '#',
          buttonBgColor: '#667eea',
          buttonTextColor: '#ffffff',
          buttonAlign: 'left',
          showButton: true,

          backgroundColor: '#f0f0f0',
          borderColor: '#e0e0e0',
          borderWidth: 0,
          borderRadius: 8,
          padding: 20,
          fontFamily: 'Arial, sans-serif'
        },
        text: {
          content: 'Digite seu texto aqui',
          fontSize: 16,
          color: '#333333',
          align: 'left',
          fontFamily: 'Arial, sans-serif'
        },
        heading: {
          content: 'Título do Email',
          fontSize: 26,
          color: '#333333',
          align: 'left',
          fontFamily: 'Arial, sans-serif'
        },
        image: {
          src: '',
          alt: '',
          width: 100,
          align: 'center',
          link: '',
          linkTarget: '_blank'
        },
        button: {
          text: 'Clique aqui',
          url: '#',
          bgColor: '#007bff',
          textColor: '#ffffff',
          align: 'center'
        },
        divider: {
          color: '#dddddd',
          style: 'solid',
          thickness: 1
        },
        spacer: {
          height: 30
        },
        video: {
          videoUrl: '',
          scale: 100  // SUBSTITUA height e width por scale
        },
        columns: {
          columnCount: 2,
          columns: [{ content: '' }, { content: '' }]
        },
        // NOVO: Bloco de Redes Sociais
        social: {
          title: 'Siga-nos nas redes sociais',
          titleColor: '#333333',
          bgColor: 'transparent',
          align: 'center',
          fontFamily: 'Arial, sans-serif',
          iconSize: 50,
          iconStyle: 'circle',
          iconBgColor: '#ffffff',
          iconColor: '#333333',
          iconBorderColor: '#dddddd',
          spacing: 15,
          showShadow: true,
          links: {
            facebook: '',
            instagram: '',
            twitter: '',
            linkedin: '',
            youtube: '',
            tiktok: '',
            whatsapp: '',
            telegram: ''
          }
        },
        // NOVO: Bloco de Footer
        footer: {
          companyName: 'Wurth do Brasil',
          address: '\nR. Adolf Wurth, 557 - Cotia - SP',
          bgColor: '#2c3e50',
          textColor: '#ffffff',
          fontFamily: 'Arial, sans-serif',
          align: 'center',
          socialLinks: {
            facebook: '',
            instagram: '',
            linkedin: '',
            twitter: '',
            youtube: ''
          },
          usefulLinks: {
            privacy: 'https://www.wurth.com.br/politica/privacidade',
            terms: 'https://www.wurthdobrasil.com.br/PT/TERMO%20LGPD%20-%20WURTH_v3.pdf',
            unsubscribe: '{{ UNSUBSCRIBE_URL }}'
          },
          legalText: '\nVocê está recebendo este email devido à relação comercial existente entre você e Wurth do Brasil referente aos títulos em aberto.\nSe não deseja mais receber, clique no link de descadastro acima.',
          copyright: '© 2025 Wurth do Brasil. Todos os direitos reservados.'
        }
      };
      return { id, type, ...defaults[type] };
    },

    getComponentType(type) {
      const map = {
        text: 'TextBlock',
        heading: 'HeadingBlock',
        image: 'ImageBlock',
        button: 'ButtonBlock',
        divider: 'DividerBlock',
        spacer: 'SpacerBlock',
        video: 'VideoBlock',
        columns: 'ColumnsBlock',
        social: 'SocialBlock',    // NOVO
        footer: 'FooterBlock',     // NOVO
        card: 'CardBlock',
        table: 'TableBlock'
      };
      return map[type];
    },

    getBlockName(type) {
      const names = {
        text: 'Texto',
        heading: 'Título',
        image: 'Imagem',
        button: 'Botão',
        divider: 'Divisor',
        spacer: 'Espaçador',
        video: 'Vídeo',
        columns: 'Colunas',
        social: 'Redes Sociais',  // NOVO
        footer: 'Footer',           // NOVO
        card: 'Card',
        table: 'Tabela'
      };
      return names[type];
    },

    selectBlock(index) {
      this.selectedIndex = index;

      if (this.components[index].type === 'video' && !this.components[index].scale) {
        this.$set(this.components[index], 'scale', 100);
      }
    },

    duplicateBlock(index) {
      const copy = JSON.parse(JSON.stringify(this.components[index]));
      copy.id = Date.now() + Math.random();
      this.components.splice(index + 1, 0, copy);
      this.selectedIndex = index + 1;
    },

    moveUp(index) {
      if (index > 0) {
        const temp = this.components[index];
        this.$set(this.components, index, this.components[index - 1]);
        this.$set(this.components, index - 1, temp);
        this.selectedIndex = index - 1;
      }
    },

    moveDown(index) {
      if (index < this.components.length - 1) {
        const temp = this.components[index];
        this.$set(this.components, index, this.components[index + 1]);
        this.$set(this.components, index + 1, temp);
        this.selectedIndex = index + 1;
      }
    },

    updateColumns(index, count) {
      const newCount = parseInt(count);
      const newColumns = Array(newCount).fill(null).map((_, i) => ({
        content: this.components[index].columns[i]?.content || ''
      }));
      this.components[index].columnCount = newCount;
      this.components[index].columns = newColumns;
    },

    exportHTML() {
      // ✅ NÃO passa parâmetro = salva sem estilização
      const html = this.generateHTML();
      const blob = new Blob([html], { type: 'text/html' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${this.templateName || 'template'}.html`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },

    generateHTML(mode = 'save') {
      let html = `<!DOCTYPE html>
<html lang="pt-BR">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${this.templateName}</title>
    <style>
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
      
      body { 
        margin: 0; 
        padding: 0; 
        background: #f4f4f4; 
        font-family: Arial, sans-serif;
        width: 100%;
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
      }
      
      .email-wrapper {
        width: 100%;
        background: #f4f4f4;
        padding: 20px 0;
      }
      
      .email-container { 
    max-width: 800px; 
    margin: 0 auto; 
    background: #FFFFFF; 
    padding: 0;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    width: 100%;
    overflow: hidden;
}

.table-scroll-container {
    width: 100%;
    overflow-x: auto;
    overflow-y: visible;
    -webkit-overflow-scrolling: touch;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
}

.table-scroll-container table {
    border-collapse: collapse;
    font-family: Arial, sans-serif;
    width: 100%;
    min-width: max-content;
    table-layout: auto;
}

.table-scroll-container th,
.table-scroll-container td {
    white-space: nowrap;
    padding: 10px 8px;
}

.table-scroll-container::-webkit-scrollbar {
    height: 10px;
}

.table-scroll-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 0 0 8px 8px;
}

.table-scroll-container::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}

.table-scroll-container::-webkit-scrollbar-thumb:hover {
    background: #555;
}

/* Mobile - comportamento responsivo */
@media only screen and (max-width: 800px) {
    .email-wrapper {
        padding: 10px !important;
    }
    
    .email-container {
        width: 100% !important;
        max-width: 100% !important;
        border-radius: 0 !important;
        overflow: hidden !important;
    }
    
    .table-scroll-container {
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;
    }
    
    .table-scroll-container table {
        width: auto !important;
        min-width: 100%;
    }
}
        
        table[class="responsive-table"] {
          width: 100% !important;
        }
        
        td[class="responsive-padding"] {
          padding: 20px 15px !important;
        }
        
        img[class="responsive-image"] {
          width: 100% !important;
          max-width: 100% !important;
          height: auto !important;
        }
        
        table[class="video-table"] {
          width: 100% !important;
        }
        
        td[class="video-td"] {
          width: 100% !important;
          height: auto !important;
        }
        
        p, h1, h2, h3, h4, h5, h6 {
          word-wrap: break-word !important;
          word-break: break-word !important;
        }
        
        a[class="responsive-button"] {
          display: block !important;
          width: 100% !important;
          max-width: 280px !important;
          margin: 0 auto !important;
        }
        
        .social-icons-container {
          display: block !important;
          text-align: center !important;
        }
        
        .social-icon-wrapper {
          display: inline-block !important;
          margin: 0 8px 10px 8px !important;
        }
      }
    </style>
</head>
<body>
    <div class="email-wrapper">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background:#f4f4f4;">
        <tr>
          <td align="center" style="padding:0;">
            <table width="800" cellpadding="0" cellspacing="0" border="0" class="responsive-table" style="max-width:800px;width:100%;">
              <tr>
                <td align="center" style="padding:10px 20px;font-size:12px;color:#666;">
                  <a href="{{ mirror }}" style="color:#667eea;text-decoration:underline;">Ver este email no navegador</a>
                </td>
              </tr>
            </table>
            <!-- Container principal -->
            <table width="800" cellpadding="0" cellspacing="0" border="0" class="responsive-table" style="max-width:800px;width:100%;background:${this.globalSettings.backgroundColor};border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.1);">
              <tr>
                <td class="responsive-padding" style="padding:${this.globalSettings.padding}px;">
`;

      // Método auxiliar: Pega thumbnail do YouTube
      const getYoutubeThumbnail = (url) => {
        if (url.includes('youtube.com/watch')) {
          const videoId = url.split('v=')[1]?.split('&')[0];
          return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
        } else if (url.includes('youtu.be')) {
          const videoId = url.split('youtu.be/')[1]?.split('?')[0];
          return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
        }
        return 'https://via.placeholder.com/640x360/667eea/ffffff?text=Reproduzir+Video';
      };

      // URL base do site
      const baseUrl = window.location.origin;

      this.components.forEach(comp => {
        if (comp.type === 'text') {
          const fontSize = typeof comp.fontSize === 'number' ? comp.fontSize + 'px' : comp.fontSize;
          const fontFamily = comp.fontFamily || 'Arial, sans-serif';

          const isPreview = arguments[0] === 'preview';

          let processedContent;
          if (isPreview) {
            // Preview: usa box colorida
            processedContent = this.processContentForPreview(comp.content);
          } else {
            // ✅ PARA SALVAR: Apenas converte quebras de linha (NÃO adiciona <strong> porque já vem do editor)
            processedContent = (comp.content || '').replace(/\n/g, '<br>');
          }

          html += `                  <p style="font-size:${fontSize};color:${comp.color};text-align:${comp.align};line-height:1.6;margin:15px 0;white-space:pre-wrap;font-family:${fontFamily};word-wrap:break-word;">${processedContent}</p>\n`;
        }
        else if (comp.type === 'table') {

          // 🔹 Comentário com metadados (lido pelo backend)
          html += `<!-- TABLE_META:evenRowColor=${comp.evenRowColor || '#ffffff'},oddRowColor=${comp.oddRowColor || '#f9f9f9'},headerColor=${comp.headerColor || '#333333'},cellColor=${comp.cellColor || '#555555'},borderColor=${comp.borderColor || '#dddddd'},headerFontSize=${comp.headerFontSize || 14},cellFontSize=${comp.cellFontSize || 13},headerAlign=${comp.headerAlign || 'center'},cellAlign=${comp.cellAlign || 'center'} -->\n`;

          // 🔹 Wrapper fixo
          html += `
<div style="width:100%;max-width:800px;margin:20px auto;overflow:hidden;">
  <div class="table-scroll-container" style="width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;border:1px solid ${comp.borderColor || '#dddddd'};border-radius:8px;">
    <table cellpadding="0" cellspacing="0" style="border-collapse:collapse;font-family:Arial,sans-serif;width:100%;min-width:max-content;">
      <thead>
        <tr style="background-color:#f0f0f0;">
`;

          // 🔹 Headers
          comp.headers.forEach(header => {
            html += `
    <th style="
      padding:12px 8px;
      text-align:${comp.headerAlign || 'center'};
      font-weight:bold;
      font-size:${comp.headerFontSize || 14}px;
      color:${comp.headerColor || '#333333'};
      border-bottom:2px solid ${comp.borderColor || '#dddddd'};
      white-space:nowrap;
    ">${header}</th>
  `;
          });

          html += `
        </tr>
      </thead>
      <tbody>
        <tr style="background-color:${comp.evenRowColor || '#ffffff'};">
`;

          // 🔹 Linha MODELO (variáveis)
          if (comp.rows && comp.rows.length > 0) {
            // 🔥 USA A PRIMEIRA LINHA COMO MODELO (preserva variáveis originais)
            comp.rows[0].forEach((cellContent, cellIdx) => {
              // 🎨 Preview visual
              let displayContent = cellContent;

              if (mode === 'preview') {
                // Substitui variáveis por badges coloridas no preview
                displayContent = cellContent.replace(
                  /\{\{\s*params\.(\w+)\s*\}\}/g,
                  (match, varName) => {
                    return `
            <span style="
              background:linear-gradient(135deg,#667eea 0%,#764ba2 100%);
              color:#fff;
              padding:3px 10px;
              border-radius:4px;
              font-weight:700;
              font-size:0.9em;
              display:inline-block;
              white-space:nowrap;
              font-family:'Courier New', monospace;
            ">${varName}</span>
          `;
                  }
                );
              }

              html += `
      <td style="
        padding:10px 8px;
        text-align:${comp.cellAlign || 'center'};
        font-size:${comp.cellFontSize || 13}px;
        color:${comp.cellColor || '#555555'};
        border-bottom:1px solid ${comp.borderColor || '#dddddd'};
        white-space:nowrap;
      ">${displayContent}</td>
    `;
            });
          } else {
            // 🔥 FALLBACK: se não houver rows, cria automaticamente baseado nos headers
            comp.headers.forEach(header => {
              const key = header
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toUpperCase()
                .replace(/\s+/g, '_')
                .replace(/[^A-Z0-9_]/g, '');

              let cellContent = `{{ params.${key} }}`;

              if (mode === 'preview') {
                cellContent = `
        <span style="
          background:linear-gradient(135deg,#667eea 0%,#764ba2 100%);
          color:#fff;
          padding:3px 10px;
          border-radius:4px;
          font-weight:700;
          font-size:0.9em;
          display:inline-block;
          white-space:nowrap;
          font-family:'Courier New', monospace;
        ">${key}</span>
      `;
              }

              html += `
      <td style="
        padding:10px 8px;
        text-align:${comp.cellAlign || 'center'};
        font-size:${comp.cellFontSize || 13}px;
        color:${comp.cellColor || '#555555'};
        border-bottom:1px solid ${comp.borderColor || '#dddddd'};
        white-space:nowrap;
      ">${cellContent}</td>
    `;
            });
          }

          html += `
        </tr>
      </tbody>
    </table>
  </div>
</div>
`;
        }
        else if (comp.type === 'heading') {
          const fontSize = comp.fontSize ? comp.fontSize + 'px' : '26px';
          const fontFamily = comp.fontFamily || 'Arial, sans-serif';

          const processedContent = (comp.content || '').replace(/\n/g, '<br>');

          html += `
  <h2
    style="
      color:${comp.color};
      text-align:${comp.align};
      font-size:${fontSize};
      font-weight:bold;
      margin:20px 0;
      font-family:${fontFamily};
      word-wrap:break-word;
    "
    data-heading="true"
    data-color="${comp.color}"
    data-align="${comp.align}"
    data-font-size="${comp.fontSize}"
    data-font-family="${fontFamily}"
  >
    ${processedContent}
  </h2>
  `;
        }
        else if (comp.type === 'image' && comp.src) {
          let imgSrc = comp.src;
          if (imgSrc.startsWith('/')) imgSrc = baseUrl + imgSrc;

          const containerWidth = 800 - (this.globalSettings.padding * 2);
          const imgWidthPx = Math.round((containerWidth * comp.width) / 100);

          const imgTag = `<img src="${imgSrc}" alt="${comp.alt || ''}" width="${imgWidthPx}"
    data-width-percent="${comp.width}"
    style="width:${comp.width}%;max-width:100%;height:auto;display:inline-block;border:0;" />`;

          const content = comp.link
            ? `<a href="${comp.link}" target="${comp.linkTarget || '_blank'}" style="display:block;width:100%;">${imgTag}</a>`
            : imgTag;

          html += `
  <table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin:20px 0;">
    <tr>
      <td align="${comp.align}">${content}</td>
    </tr>
  </table>\n`;
        }

        else if (comp.type === 'button') {
          // Processa o texto do botão (remove as boxes de preview)
          let buttonText = comp.text || 'Clique aqui';

          // Remove os spans de preview, mantém apenas o texto da variável
          buttonText = buttonText.replace(/<span[^>]*>(.*?)<\/span>/g, '{{ params.$1 }}');

          // Se não tem variável processada, mantém o texto original
          if (!buttonText.includes('{{ params.')) {
            // Adiciona strong nas variáveis para o email final
            buttonText = buttonText.replace(/\{\{\s*params\.(\w+)\s*\}\}/g, '<strong>{{ params.$1 }}</strong>');
          }

          // 🔥 NOVO: Botão compatível com Outlook usando tabela
          html += `                  <!--[if mso]>
                  <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="${comp.url}" style="height:48px;v-text-anchor:middle;width:200px;" arcsize="13%" stroke="f" fillcolor="${comp.bgColor}">
                    <w:anchorlock/>
                    <center style="color:${comp.textColor};font-family:Arial,sans-serif;font-size:16px;font-weight:bold;">${buttonText}</center>
                  </v:roundrect>
                  <![endif]-->
                  <!--[if !mso]><!-->
                  <table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin:20px 0;">
                    <tr>
                      <td align="${comp.align}" style="padding:0;">
                        <table cellpadding="0" cellspacing="0" border="0" style="margin:0 auto;">
                          <tr>
                            <td align="center" bgcolor="${comp.bgColor}" style="background-color:${comp.bgColor};border-radius:6px;padding:14px 35px;">
                              <a href="${comp.url}" target="_blank" style="color:${comp.textColor};font-family:Arial,sans-serif;font-size:16px;font-weight:bold;text-decoration:none;display:inline-block;line-height:1.4;">${buttonText}</a>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <!--<![endif]-->\n`;
        }
        else if (comp.type === 'divider') {
          html += `                  <hr style="border:none;border-top:${comp.thickness}px ${comp.style} ${comp.color};margin:20px 0;" />\n`;
        }
        else if (comp.type === 'spacer') {
          html += `                  <div style="height:${comp.height}px;"></div>\n`;
        }
        else if (comp.type === 'video' && comp.videoUrl) {
          const thumbnailUrl = getYoutubeThumbnail(comp.videoUrl);
          const videoUrl = comp.videoUrl;
          const scale = comp.scale || 100;
          const videoWidth = scale;
          const baseHeight = 350;
          const videoHeight = Math.round(baseHeight * (scale / 100));
          const buttonWidth = Math.round(90 * (scale / 100));
          const buttonHeight = Math.round(63 * (scale / 100));

          html += `
                  <table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin:20px 0;">
                    <tr>
                      <td align="center" style="padding:0;">
                        <a href="${videoUrl}" target="_blank" style="text-decoration:none;display:block;">
                          <table width="${videoWidth}%" cellpadding="0" cellspacing="0" border="0" class="video-table responsive-table" style="max-width:${videoWidth}%;border-radius:8px;overflow:hidden;margin:0 auto;">
                            <tr>
                              <td class="video-td" background="${thumbnailUrl}" bgcolor="#000000" width="100%" 
                                  style="background-image:url('${thumbnailUrl}');
                                         background-size:cover;
                                         background-position:center;
                                         background-repeat:no-repeat;
                                         text-align:center;
                                         vertical-align:middle;
                                         height:${videoHeight}px;
                                         padding:0;">
                                
                                <center>
                                  <table cellpadding="0" cellspacing="0" border="0">
                                    <tr>
                                      <td bgcolor="#ff0000" width="${buttonWidth}" height="${buttonHeight}" align="center" valign="middle" style="background-color:#ff0000;width:${buttonWidth}px;height:${buttonHeight}px;border-radius:${Math.round(12 * (scale / 100))}px;text-align:center;vertical-align:middle;">
                                        <div style="width:0;height:0;border-top:${Math.round(15 * (scale / 100))}px solid transparent;border-bottom:${Math.round(15 * (scale / 100))}px solid transparent;border-left:${Math.round(25 * (scale / 100))}px solid #ffffff;display:inline-block;margin-left:${Math.round(8 * (scale / 100))}px;"></div>
                                      </td>
                                    </tr>
                                  </table>
                                </center>
                                
                              </td>
                            </tr>
                          </table>
                        </a>
                      </td>
                    </tr>
                  </table>\n`;
        }
        else if (comp.type === 'columns') {
          html += `                  <table style="width:100%;margin:20px 0;" cellpadding="0" cellspacing="0"><tr>\n`;
          comp.columns.forEach(col => {
            const width = 100 / comp.columnCount;
            html += `                    <td style="width:${width}%;padding:10px;vertical-align:top;">${col.content}</td>\n`;
          });
          html += `                  </tr></table>\n`;
        }
        else if (comp.type === 'social') {
          const align = comp.align || 'center';
          const bgColor = comp.bgColor || 'transparent';
          const titleColor = comp.titleColor || '#333333';
          const fontFamily = comp.fontFamily || 'Arial, sans-serif';
          const iconSize = comp.iconSize || 50;
          const iconStyle = comp.iconStyle || 'circle';
          const showShadow = comp.showShadow !== false;
          const spacing = comp.spacing || 20;

          const borderRadius =
            iconStyle === 'circle' ? '50%' : iconStyle === 'rounded' ? '8px' : '0';

          html += `
    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:${bgColor};">
      <tr>
        <td style="padding:30px 20px;" align="${align}">
  `;

          if (comp.title) {
            html += `
      <div style="font-size:18px;font-weight:bold;color:${titleColor};
        margin-bottom:20px;font-family:${fontFamily};">
        ${comp.title}
      </div>\n`;
          }

          html += `
    <div class="social-icons-container" style="text-align:${align};line-height:0;">
      <!--[if mso]><table cellpadding="0" cellspacing="0" border="0" align="${align}"><tr><![endif]-->
  `;

          const socialLinks = [
            { name: 'Facebook', url: comp.links?.facebook, icon: 'facebook-icon.png', color: '#1877F2', iconScale: 0.6 },
            { name: 'Instagram', url: comp.links?.instagram, icon: 'instagram-icon.png', color: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)', iconScale: 0.6 },
            { name: 'Twitter', url: comp.links?.twitter, icon: 'twitter-icon.png', color: '#000000', iconScale: 0.55 },
            { name: 'LinkedIn', url: comp.links?.linkedin, icon: 'linkedin-icon.png', color: '#0A66C2', iconScale: 0.55 },
            { name: 'YouTube', url: comp.links?.youtube, icon: 'youtube-icon.png', color: '#FF0000', iconScale: 0.6 },
            { name: 'TikTok', url: comp.links?.tiktok, icon: 'tiktok-icon.png', color: '#000000', iconScale: 0.6 },
            { name: 'WhatsApp', url: comp.links?.whatsapp, icon: 'whatsapp-icon.png', color: '#25D366', iconScale: 0.6 },
            { name: 'Telegram', url: comp.links?.telegram, icon: 'telegram-icon.png', color: '#26A5E4', iconScale: 0.6 }
          ];

          const activeSocials = socialLinks.filter(s => s.url);

          activeSocials.forEach((social, index) => {
            const iconUrl = `${baseUrl}/imgs/icons/${social.icon}`;
            const innerIconSize = Math.round(iconSize * social.iconScale);
            const boxShadow = showShadow ? 'box-shadow:0 2px 8px rgba(0,0,0,0.2);' : '';
            const marginRight = index < activeSocials.length - 1 ? `${spacing}px` : '0';

            const backgroundStyle =
              social.name === 'Instagram'
                ? 'background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%); background-color:#dc2743;'
                : `background-color:${social.color};`;

            html += `
      <!--[if mso]><td style="padding-right:${marginRight};"><![endif]-->
      <span class="social-icon-wrapper" style="display:inline-block;vertical-align:middle;margin-right:${marginRight};line-height:0;">
        <a href="${social.url}" target="_blank" style="text-decoration:none;display:inline-block;vertical-align:middle;">
          <table cellpadding="0" cellspacing="0" border="0" width="${iconSize}" height="${iconSize}"
            style="border-collapse:collapse;width:${iconSize}px;height:${iconSize}px;
            ${backgroundStyle}border-radius:${borderRadius};${boxShadow};vertical-align:middle;">
            <tr>
              <td align="center" valign="middle" 
                  style="line-height:0;padding:0;text-align:center;vertical-align:middle;">
                <img src="${iconUrl}" alt="${social.name}" 
                     width="${innerIconSize}" height="${innerIconSize}" 
                     style="display:block;margin:0 auto;border:0;width:${innerIconSize}px;height:${innerIconSize}px;" />
              </td>
            </tr>
          </table>
        </a>
      </span>
      <!--[if mso]></td><![endif]-->
    `;
          });

          html += `
      <!--[if mso]></tr></table><![endif]-->
    </div>
  </td>
</tr>
</table>\n`;
        }

        else if (comp.type === 'footer') {
          const bgColor = comp.bgColor || '#2c3e50';
          const textColor = comp.textColor || '#ffffff';
          const fontFamily = comp.fontFamily || 'Arial, sans-serif';
          const align = comp.align || 'center';

          html += `                  <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:${bgColor};color:${textColor};margin-top:30px;border-radius:0 0 8px 8px;">
                    <tr>
                      <td style="padding:40px 20px;">
                        <table width="100%" cellpadding="0" cellspacing="0" border="0" style="max-width:800px;margin:0 auto;">
                          <tr>
                            <td align="${align}" style="font-family:${fontFamily};">\n`;

          if (comp.companyName) {
            html += `                              <div style="font-size:20px;font-weight:bold;margin-bottom:15px;">${comp.companyName}</div>\n`;
          }

          if (comp.address) {
            html += `                              <div style="font-size:14px;margin-bottom:15px;line-height:1.6;word-wrap:break-word;">${comp.address}</div>\n`;
          }

          const hasUsefulLinks = comp.usefulLinks && (comp.usefulLinks.privacy || comp.usefulLinks.terms);
          if (hasUsefulLinks) {
            html += `<div style="margin-bottom:20px;font-size:13px;">\n`;
            if (comp.usefulLinks.privacy)
              html += `<a href="${comp.usefulLinks.privacy}" target="_blank" style="color:${textColor};text-decoration:underline;margin:0 10px;">Política de Privacidade</a>\n`;
            if (comp.usefulLinks.terms)
              html += `<a href="${comp.usefulLinks.terms}" target="_blank" style="color:${textColor};text-decoration:underline;margin:0 10px;">Termos de Uso</a>\n`;
            html += `<a href="{{ UNSUBSCRIBE_URL }}" target="_blank" style="color:${textColor};text-decoration:underline;margin:0 10px;">Descadastrar</a>\n`;
            html += `</div>\n`;
          }

          if (comp.legalText) {
            html += `                              <div style="font-size:12px;margin-top:20px;line-height:1.6;opacity:0.9;word-wrap:break-word;">${comp.legalText}</div>\n`;
          }

          if (comp.copyright) {
            html += `                              <div style="font-size:12px;margin-top:15px;opacity:0.8;">${comp.copyright}</div>\n`;
          }

          html += `                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>\n`;
        }
        else if (comp.type === 'card') {
          const baseUrl = window.location.origin;
          let imgSrc = comp.imageUrl;
          if (imgSrc && imgSrc.startsWith('/')) {
            imgSrc = baseUrl + imgSrc;
          }

          const titleAlign = comp.titleAlign || 'left';
          const descriptionAlign = comp.descriptionAlign || 'left';
          const buttonAlign = comp.buttonAlign || 'left';
          const imagePosition = comp.imagePosition || 'center';
          const imageZoom = comp.imageZoom || 1;
          const imageRadius = comp.imageRadius || 8;
          const imageGap = comp.imageGap || 20;
          const gridGap = comp.gridGap || 20;

          html += `                  <table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin:20px 0;">
                    <tr>
                     <td style="background-color:${comp.backgroundColor};border:${comp.borderWidth}px solid ${comp.borderColor};border-radius:${comp.borderRadius}px;padding:${comp.padding}px;">
                  `;
          // Layout: Imagem à Esquerda ou Direita
          if (comp.layout === 'image-left' || comp.layout === 'image-right') {
            html += `                        <table width="100%" cellpadding="0" cellspacing="0" border="0" class="email-card-wrapper" data-card-layout="${comp.layout}">
                    <tr>
                      <td style="background-color:${comp.backgroundColor};border:${comp.borderWidth}px solid ${comp.borderColor};border-radius:${comp.borderRadius}px;padding:${comp.padding}px;">
                        <table width="100%" cellpadding="0" cellspacing="0" border="0">
                          <tr>
                  `;

            // ✅ Usar background-image para compatibilidade total com email clients
            const baseImageHeight = 210;

            // Calcula multiplicador dinâmico baseado na largura da imagem
            // Quanto menor a largura, maior o multiplicador necessário
            const imageWidthPercent = comp.imageWidth || 50;
            const widthMultiplier = imageWidthPercent < 40 ? 1.3 : imageWidthPercent < 50 ? 1.2 : 1.15;

            // Para zoom, usamos largura escalada com multiplicador dinâmico
            let bgSize = 'cover';
            if (imageZoom !== 1) {
              const scaledSize = Math.round(100 * imageZoom * widthMultiplier);
              bgSize = `${scaledSize}% auto`;
            }

            // Calcula a posição do background baseado no imagePosition
            let bgPosition = imagePosition.replace(' ', ' ');

            const containerStyle = `
              background-image: url('${imgSrc}');
              background-size: ${bgSize};
              background-position: ${bgPosition};
              background-repeat: no-repeat;
              height: ${baseImageHeight}px;
              border-radius: ${imageRadius}px;
              overflow: hidden;
            `.replace(/\s+/g, ' ').trim();

            if (comp.layout === 'image-left') {
              html += `                            <td width="${comp.imageWidth}%" class="card-image" style="padding-right:${imageGap}px;vertical-align:top;">
                              <!--[if mso]>
                              <v:rect xmlns:v="urn:schemas-microsoft-com:vml" stroked="false" style="width:${Math.round((800 * comp.imageWidth) / 100)}px;height:${baseImageHeight}px;">
                                <v:fill type="frame" src="${imgSrc}" />
                              </v:rect>
                              <![endif]-->
                              <!--[if !mso]><!-->
                              <table width="100%" cellpadding="0" cellspacing="0" border="0" style="${containerStyle}">
                                <tr>
                                  <td height="${baseImageHeight}" style="height:${baseImageHeight}px;">
                                    <!-- Fallback para clients que não suportam background -->
                                    ${imgSrc ? `<img src="${imgSrc}" alt="${comp.imageAlt}" width="1" height="1" border="0" style="display:block;width:1px;height:1px;opacity:0;" />` : ''}
                                  </td>
                                </tr>
                              </table>
                              <!--<![endif]-->
                            </td>`;

              html += `                            <td class="card-content" style="vertical-align:middle;">
                              <h3 data-card-text="true" style="font-size:${comp.titleSize}px;color:${comp.titleColor};margin:0 0 10px 0;font-family:${comp.fontFamily};text-align:${titleAlign};">${comp.title}</h3>
                              <p data-card-text="true" style="font-size:${comp.descriptionSize}px;color:${comp.descriptionColor};margin:0 0 15px 0;line-height:1.6;font-family:${comp.fontFamily};text-align:${descriptionAlign};white-space:pre-wrap;">${comp.description}</p>
                              ${comp.showButton ? `
  <!--[if mso]>
  <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="${comp.buttonUrl}" style="height:40px;v-text-anchor:middle;width:180px;" arcsize="15%" stroke="f" fillcolor="${comp.buttonBgColor}">
    <w:anchorlock/>
    <center style="color:${comp.buttonTextColor};font-family:${comp.fontFamily};font-size:14px;font-weight:600;">${comp.buttonText}</center>
  </v:roundrect>
  <![endif]-->
  <!--[if !mso]><!-->
  <div style="text-align:${buttonAlign};margin-top:15px;">
    <table cellpadding="0" cellspacing="0" border="0" style="margin:0 auto;" data-card-button="true">
      <tr>
        <td align="center" bgcolor="${comp.buttonBgColor}" style="background-color:${comp.buttonBgColor};border-radius:6px;padding:10px 24px;">
          <a href="${comp.buttonUrl}" target="_blank" data-button-bg="${comp.buttonBgColor}" data-button-text-color="${comp.buttonTextColor}" style="color:${comp.buttonTextColor};font-family:${comp.fontFamily};font-size:14px;font-weight:600;text-decoration:none;display:inline-block;line-height:1.4;">${comp.buttonText}</a>
        </td>
      </tr>
    </table>
  </div>
  <!--<![endif]-->` : ''}
                            </td>
                  `;
            } else {
              html += `                            <td class="card-content" style="vertical-align:middle;">
                              <h3 data-card-text="true" style="font-size:${comp.titleSize}px;color:${comp.titleColor};margin:0 0 10px 0;font-family:${comp.fontFamily};text-align:${titleAlign};">${comp.title}</h3>
                              <p data-card-text="true" style="font-size:${comp.descriptionSize}px;color:${comp.descriptionColor};margin:0 0 15px 0;line-height:1.6;font-family:${comp.fontFamily};text-align:${descriptionAlign};white-space:pre-wrap;">${comp.description}</p>
                              ${comp.showButton ? `
  <!--[if mso]>
  <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="${comp.buttonUrl}" style="height:40px;v-text-anchor:middle;width:180px;" arcsize="15%" stroke="f" fillcolor="${comp.buttonBgColor}">
    <w:anchorlock/>
    <center style="color:${comp.buttonTextColor};font-family:${comp.fontFamily};font-size:14px;font-weight:600;">${comp.buttonText}</center>
  </v:roundrect>
  <![endif]-->
  <!--[if !mso]><!-->
  <div style="text-align:${buttonAlign};margin-top:15px;">
    <table cellpadding="0" cellspacing="0" border="0" style="margin:0 auto;" data-card-button="true">
      <tr>
        <td align="center" bgcolor="${comp.buttonBgColor}" style="background-color:${comp.buttonBgColor};border-radius:6px;padding:10px 24px;">
          <a href="${comp.buttonUrl}" target="_blank" data-button-bg="${comp.buttonBgColor}" data-button-text-color="${comp.buttonTextColor}" style="color:${comp.buttonTextColor};font-family:${comp.fontFamily};font-size:14px;font-weight:600;text-decoration:none;display:inline-block;line-height:1.4;">${comp.buttonText}</a>
        </td>
      </tr>
    </table>
  </div>
  <!--<![endif]-->` : ''}
                            </td>`;

              html += `                            <td width="${comp.imageWidth}%" class="card-image" style="padding-left:${imageGap}px;vertical-align:top;">
                              <!--[if mso]>
                              <v:rect xmlns:v="urn:schemas-microsoft-com:vml" stroked="false" style="width:${Math.round((800 * comp.imageWidth) / 100)}px;height:${baseImageHeight}px;">
                                <v:fill type="frame" src="${imgSrc}" />
                              </v:rect>
                              <![endif]-->
                              <!--[if !mso]><!-->
                              <table width="100%" cellpadding="0" cellspacing="0" border="0" style="${containerStyle}">
                                <tr>
                                  <td height="${baseImageHeight}" style="height:${baseImageHeight}px;">
                                    ${imgSrc ? `<img src="${imgSrc}" alt="${comp.imageAlt}" width="1" height="1" border="0" style="display:block;width:1px;height:1px;opacity:0;" />` : ''}
                                  </td>
                                </tr>
                              </table>
                              <!--<![endif]-->
                            </td>`;
            }

            html += `                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  `;
          }
          // Layout: Imagem no Topo
          else if (comp.layout === 'image-top') {
            const baseImageHeight = comp.imageHeight || 300;

            let bgSize = 'cover';
            if (imageZoom !== 1) {
              const scaledSize = Math.round(100 * imageZoom * 1.15);
              bgSize = `${scaledSize}% auto`;
            }

            let bgPosition = imagePosition.replace(' ', ' ');

            const containerStyle = `
              background-image: url('${imgSrc}');
              background-size: ${bgSize};
              background-position: ${bgPosition};
              background-repeat: no-repeat;
              height: ${baseImageHeight}px;
              border-radius: ${imageRadius}px;
              overflow: hidden;
            `.replace(/\s+/g, ' ').trim();

            html += `                        <table width="100%" cellpadding="0" cellspacing="0" border="0" class="email-card-wrapper" data-card-layout="image-top">
                          <tr>
                            <td style="padding-bottom:${imageGap}px;">
                              <!--[if mso]>
                              <v:rect xmlns:v="urn:schemas-microsoft-com:vml" stroked="false" style="width:100%;height:${baseImageHeight}px;">
                                <v:fill type="frame" src="${imgSrc}" />
                              </v:rect>
                              <![endif]-->
                              <!--[if !mso]><!-->
                              <table width="100%" cellpadding="0" cellspacing="0" border="0" style="${containerStyle}">
                                <tr>
                                  <td height="${baseImageHeight}" style="height:${baseImageHeight}px;">
                                    ${imgSrc ? `<img src="${imgSrc}" alt="${comp.imageAlt}" width="1" height="1" border="0" style="display:block;width:1px;height:1px;opacity:0;" />` : ''}
                                  </td>
                                </tr>
                              </table>
                              <!--<![endif]-->
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h3 data-card-text="true" style="font-size:${comp.titleSize}px;color:${comp.titleColor};margin:0 0 10px 0;font-family:${comp.fontFamily};text-align:${titleAlign};">${comp.title}</h3>
                              <p data-card-text="true" style="font-size:${comp.descriptionSize}px;color:${comp.descriptionColor};margin:0 0 15px 0;line-height:1.6;font-family:${comp.fontFamily};text-align:${descriptionAlign};white-space:pre-wrap;">${comp.description}</p>
                              ${comp.showButton ? `
  <!--[if mso]>
  <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="${comp.buttonUrl}" style="height:40px;v-text-anchor:middle;width:180px;" arcsize="15%" stroke="f" fillcolor="${comp.buttonBgColor}">
    <w:anchorlock/>
    <center style="color:${comp.buttonTextColor};font-family:${comp.fontFamily};font-size:14px;font-weight:600;">${comp.buttonText}</center>
  </v:roundrect>
  <![endif]-->
  <!--[if !mso]><!-->
  <div style="text-align:${buttonAlign};margin-top:15px;">
    <table cellpadding="0" cellspacing="0" border="0" style="margin:0 auto;" data-card-button="true">
      <tr>
        <td align="center" bgcolor="${comp.buttonBgColor}" style="background-color:${comp.buttonBgColor};border-radius:6px;padding:10px 24px;">
          <a href="${comp.buttonUrl}" target="_blank" data-button-bg="${comp.buttonBgColor}" data-button-text-color="${comp.buttonTextColor}" style="color:${comp.buttonTextColor};font-family:${comp.fontFamily};font-size:14px;font-weight:600;text-decoration:none;display:inline-block;line-height:1.4;">${comp.buttonText}</a>
        </td>
      </tr>
    </table>
  </div>
  <!--<![endif]-->` : ''}
                            </td>
                          </tr>
                        </table>
                  `;
          }
          // Layout: Grid (2, 3 ou 4 colunas)
          else if (comp.layout === 'grid-2' || comp.layout === 'grid-3' || comp.layout === 'grid-4') {
            const gridCount = comp.layout === 'grid-2' ? 2 : comp.layout === 'grid-3' ? 3 : 4;
            const gridItems = comp.gridItems.slice(0, gridCount);
            const cellWidth = Math.floor(100 / gridCount);

            html += `                        <table width="100%" cellpadding="0" cellspacing="0" border="0" data-grid-columns="${gridCount}">
                          <tr>
                  `;

            gridItems.forEach((item, idx) => {
              let itemImgSrc = item.imageUrl;
              if (itemImgSrc && itemImgSrc.startsWith('/')) {
                itemImgSrc = baseUrl + itemImgSrc;
              }
              const itemImagePosition = item.imagePosition || 'center';
              const itemImageZoom = item.imageZoom || 1;
              const isLast = idx === gridItems.length - 1;

              const gridImageHeight = comp.gridImageHeight || 180;

              let bgSize = 'cover';
              if (itemImageZoom !== 1) {
                const scaledSize = Math.round(100 * itemImageZoom * 1.15);
                bgSize = `${scaledSize}% auto`;
              }

              let bgPosition = itemImagePosition.replace(' ', ' ');

              const gridContainerStyle = `
                background-image: url('${itemImgSrc}');
                background-size: ${bgSize};
                background-position: ${bgPosition};
                background-repeat: no-repeat;
                height: ${gridImageHeight}px;
                border-radius: ${imageRadius}px;
                overflow: hidden;
              `.replace(/\s+/g, ' ').trim();

              html += `                            <td width="${cellWidth}%" valign="top" style="${isLast ? '' : `padding-right:${gridGap}px;`}">
                              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                                <tr>
                                  <td style="padding-bottom:15px;">
                                    <!--[if mso]>
                                    <v:rect xmlns:v="urn:schemas-microsoft-com:vml" stroked="false" style="width:100%;height:${gridImageHeight}px;">
                                      <v:fill type="frame" src="${itemImgSrc}" />
                                    </v:rect>
                                    <![endif]-->
                                    <!--[if !mso]><!-->
                                    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="${gridContainerStyle}">
                                      <tr>
                                        <td height="${gridImageHeight}" style="height:${gridImageHeight}px;">
                                          ${itemImgSrc ? `<img src="${itemImgSrc}" alt="${item.imageAlt || ''}" width="1" height="1" border="0" style="display:block;width:1px;height:1px;opacity:0;" />` : ''}
                                        </td>
                                      </tr>
                                    </table>
                                    <!--<![endif]-->
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <h4 style="font-size:${comp.titleSize}px;color:${comp.titleColor};margin:0 0 8px 0;font-family:${comp.fontFamily};text-align:${titleAlign};">${item.title || ''}</h4>
                                    <p style="font-size:${comp.descriptionSize}px;color:${comp.descriptionColor};margin:0 0 12px 0;line-height:1.6;font-family:${comp.fontFamily};text-align:${descriptionAlign};">${item.description || ''}</p>
                                    ${comp.showButton ? `
  <!--[if mso]>
  <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="${item.buttonUrl || '#'}" style="height:34px;v-text-anchor:middle;width:160px;" arcsize="18%" stroke="f" fillcolor="${comp.buttonBgColor}">
    <w:anchorlock/>
    <center style="color:${comp.buttonTextColor};font-family:${comp.fontFamily};font-size:13px;font-weight:600;">${comp.buttonText}</center>
  </v:roundrect>
  <![endif]-->
  <!--[if !mso]><!-->
  <div style="text-align:${buttonAlign};margin-top:12px;">
    <table cellpadding="0" cellspacing="0" border="0" style="margin:0 auto;" data-card-button="true">
      <tr>
        <td align="center" bgcolor="${comp.buttonBgColor}" style="background-color:${comp.buttonBgColor};border-radius:6px;padding:8px 18px;">
          <a href="${item.buttonUrl || '#'}" target="_blank" data-button-bg="${comp.buttonBgColor}" data-button-text-color="${comp.buttonTextColor}" style="color:${comp.buttonTextColor};font-family:${comp.fontFamily};font-size:13px;font-weight:600;text-decoration:none;display:inline-block;line-height:1.4;">${comp.buttonText}</a>
        </td>
      </tr>
    </table>
  </div>
  <!--<![endif]-->` : ''}
                                  </td>
                                </tr>
                              </table>
                            </td>
                  `;
            });

            html += `                          </tr>
                        </table>
                  `;
          }
          // Layout: Banner Grande
          else if (comp.layout === 'banner') {
            const bgSize = imageZoom > 1 ? `${Math.round(imageZoom * 100)}%` : 'cover';

            html += `                        <!-- BANNER START -->
                        <table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin:20px 0;" class="banner-card-table">
                          <tr>
                            <td style="padding:0;border-radius:${imageRadius}px;overflow:hidden;">
                              <div style="position:relative;width:100%;height:${comp.bannerHeight}px;background-image:url('${imgSrc}');background-size:${bgSize};background-position:${imagePosition};background-repeat:no-repeat;display:block;">
                                <table width="100%" cellpadding="0" cellspacing="0" border="0" style="height:${comp.bannerHeight}px;">
                                  <tr>
                                    <td style="padding:60px 30px;text-align:center;background:rgba(0,0,0,${comp.overlayOpacity});vertical-align:middle;">
                                      <h2 style="font-size:${comp.titleSize * 1.5}px;color:${comp.titleColor};margin:0 0 15px 0;font-family:${comp.fontFamily};font-weight:bold;text-shadow:2px 2px 4px rgba(0,0,0,0.5);">${comp.title}</h2>
                                      <p style="font-size:${comp.descriptionSize}px;color:${comp.descriptionColor};margin:0 0 20px 0;line-height:1.6;font-family:${comp.fontFamily};max-width:600px;display:inline-block;text-shadow:1px 1px 2px rgba(0,0,0,0.5);">${comp.description}</p>
                                      ${comp.showButton ? `
  <!--[if mso]>
  <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="${comp.buttonUrl}" style="height:48px;v-text-anchor:middle;width:220px;" arcsize="13%" stroke="f" fillcolor="${comp.buttonBgColor}">
    <w:anchorlock/>
    <center style="color:${comp.buttonTextColor};font-family:${comp.fontFamily};font-size:16px;font-weight:600;">${comp.buttonText}</center>
  </v:roundrect>
  <![endif]-->
  <!--[if !mso]><!-->
  <div style="margin-top:25px;">
    <table cellpadding="0" cellspacing="0" border="0" style="margin:0 auto;" data-card-button="true">
      <tr>
        <td align="center" bgcolor="${comp.buttonBgColor}" style="background-color:${comp.buttonBgColor};border-radius:6px;padding:14px 32px;box-shadow:0 4px 12px rgba(0,0,0,0.3);">
          <a href="${comp.buttonUrl}" target="_blank" data-button-bg="${comp.buttonBgColor}" data-button-text-color="${comp.buttonTextColor}" style="color:${comp.buttonTextColor};font-family:${comp.fontFamily};font-size:16px;font-weight:600;text-decoration:none;display:inline-block;line-height:1.4;">${comp.buttonText}</a>
        </td>
      </tr>
    </table>
  </div>
  <!--<![endif]-->` : ''}
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </td>
                          </tr>
                        </table>
                        <!-- BANNER END -->
                  `;
          }

          html += `                      </td>
                    </tr>
                  </table>\n`;
        }

      });

      html += `                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
</body>
</html>`;
      return html;
    },

    renderPreviewWithToggle() {
      // Container principal do preview
      const previewContainer = document.getElementById('preview-container'); // Ajuste o ID conforme seu HTML

      if (!previewContainer) {
        console.error('Container de preview não encontrado');
        return;
      }

      // Limpa o container
      previewContainer.innerHTML = '';

      // Cria o toggle
      const toggleWrapper = document.createElement('div');
      toggleWrapper.style.cssText = `
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    padding: 20px;
    background: #f8f9fa;
    border-bottom: 2px solid #e0e0e0;
  `;

      toggleWrapper.innerHTML = `
    <div style="display: flex; background: #ffffff; border-radius: 8px; padding: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
      <button id="toggle-desktop" class="view-toggle active" style="
        padding: 10px 20px;
        border: none;
        background: #667eea;
        color: white;
        border-radius: 6px !important;
        cursor: pointer;
        font-weight: 600;
        font-size: 14px;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        gap: 8px;
      ">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
          <line x1="8" y1="21" x2="16" y2="21"></line>
          <line x1="12" y1="17" x2="12" y2="21"></line>
        </svg>
        Desktop
      </button>
      <button id="toggle-mobile" class="view-toggle" style="
        padding: 10px 20px;
        border: none;
        background: transparent;
        color: #666;
        border-radius: 6px !important;
        cursor: pointer;
        font-weight: 600;
        font-size: 14px;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        gap: 8px;
      ">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
          <line x1="12" y1="18" x2="12.01" y2="18"></line>
        </svg>
        Mobile
      </button>
    </div>
    <div style="font-size: 13px; color: #666;">
      <span id="current-width"></span>
    </div>
  `;

      previewContainer.appendChild(toggleWrapper);

      // Cria o iframe do preview
      const iframeWrapper = document.createElement('div');
      iframeWrapper.id = 'iframe-wrapper';
      iframeWrapper.style.cssText = `
    display: flex;
    justify-content: center;
    padding: 40px 20px;
    background: #f0f0f0;
    min-height: 800px;
    transition: all 0.3s ease;
  `;

      const iframe = document.createElement('iframe');
      iframe.id = 'preview-iframe';
      iframe.style.cssText = `
    width: 100%;
    max-width: 100%;
    height: 800px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background: white;
    box-shadow: 0 4px 16px rgba(0,0,0,0.1);
    transition: all 0.3s ease;
  `;

      iframeWrapper.appendChild(iframe);
      previewContainer.appendChild(iframeWrapper);

      // Gera o HTML do email
      const emailHTML = this.generateHTML();
      iframe.srcdoc = emailHTML;

      // Variável para controlar o estado
      let isMobileView = false;

      // Função para atualizar a visualização
      const updateView = (mobile) => {
        isMobileView = mobile;
        const desktopBtn = document.getElementById('toggle-desktop');
        const mobileBtn = document.getElementById('toggle-mobile');
        const widthDisplay = document.getElementById('current-width');

        if (mobile) {
          // Visualização Mobile
          iframe.style.maxWidth = '400px';
          iframe.style.width = '400px';

          // Atualiza botões
          desktopBtn.style.background = 'transparent';
          desktopBtn.style.color = '#666';
          mobileBtn.style.background = '#667eea';
          mobileBtn.style.color = 'white';

          widthDisplay.textContent = '400px';
        } else {
          // Visualização Desktop
          iframe.style.maxWidth = '100%';
          iframe.style.width = '100%';

          // Atualiza botões
          desktopBtn.style.background = '#667eea';
          desktopBtn.style.color = 'white';
          mobileBtn.style.background = 'transparent';
          mobileBtn.style.color = '#666';

          widthDisplay.textContent = '100%';
        }
      };

      // Event listeners
      document.getElementById('toggle-desktop').addEventListener('click', () => {
        updateView(false);
      });

      document.getElementById('toggle-mobile').addEventListener('click', () => {
        updateView(true);
      });

      // Inicializa a visualização
      updateView(false);
    },

    async loadTemplate(templateId) {
      try {
        const response = await fetch(`/emails/api/brevo/templates/${templateId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
          }
        });

        const result = await response.json();

        if (result.success && result.data) {
          this.loadTemplateFromData(result.data);
        }
      } catch (error) {
        console.error('Erro ao carregar template:', error);
        this.errorMessage = 'Erro ao carregar o template.';
      }
    },

    loadTemplateFromData(templateData) {
      this.templateName = templateData.name || 'Template sem nome';
      this.emailSubject = templateData.subject || '';

      if (templateData.components) {
        try {
          this.components = JSON.parse(templateData.components);
        } catch (e) {
          this.parseHtmlToComponents(templateData.htmlContent);
        }
      } else {
        this.parseHtmlToComponents(templateData.htmlContent);
      }

      if (templateData.settings) {
        try {
          this.globalSettings = JSON.parse(templateData.settings);
        } catch (e) {
          console.warn('Erro ao parsear settings:', e);
        }
      }

      // 🆕 EXTRAI todas as imagens que já existiam no template
      this.extractInitialImages(templateData.htmlContent);
    },

    // 🆕 Método para extrair imagens iniciais do HTML
    extractInitialImages(htmlContent) {
      if (!htmlContent) {
        this.initialImages = [];
        return;
      }

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlContent;

      const images = tempDiv.querySelectorAll('img[src*="uploads/email-images/"]');

      this.initialImages = Array.from(images).map(img => {
        const url = img.getAttribute('src');
        const filename = url.split('/').pop();
        return filename;
      });
    },

    parseHtmlToComponents(htmlContent) {
      if (!htmlContent) {
        this.components = [];
        return;
      }

      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlContent;

      var components = [];
      var processedSignatures = new Set();
      var vm = this;

      var mainContainer = tempDiv.querySelector('table.responsive-table td.responsive-padding') || tempDiv;

      function processElement(element) {
        // Ignora elementos já processados
        if (element.hasAttribute('data-processed')) {
          return;
        }

        var tag = element.nodeName;

        // ========== PRIORIDADE 1: DETECÇÃO DE GRID COM DATA-ATTR ==========
        // ========== 🔥 PRIORIDADE ABSOLUTA: TABLES (CARDS PRIMEIRO) ==========
        if (tag === 'TABLE') {
          var classList = element.className || '';
          var dataLayout = element.getAttribute('data-card-layout');
          var isCardWrapper = classList.includes('email-card-wrapper');


          // ========== FASE 1: DETECTA SE É CARD ==========

          // 1️⃣ Verifica se JÁ É um card conhecido (tem atributo ou classe)
          if (dataLayout || isCardWrapper) {
            element.setAttribute('data-processed', 'true');
            var allInner = element.querySelectorAll('*');
            for (var i = 0; i < allInner.length; i++) {
              allInner[i].setAttribute('data-processed', 'true');
            }
          }

          // 2️⃣ Detecta card image-top pela estrutura
          if (!dataLayout && !isCardWrapper) {
            var allRows = element.querySelectorAll(':scope > tbody > tr, :scope > tr');

            if (allRows.length === 2) {
              var firstTd = allRows[0].querySelector('td');
              var secondTd = allRows[1].querySelector('td');

              if (firstTd && secondTd) {
                var hasImg = firstTd.querySelector('img[src]') || firstTd.querySelector('.placeholder-img');
                var hasTitle = secondTd.querySelector('h3, h2');
                var hasDesc = secondTd.querySelector('p');

                if (hasImg && (hasTitle || hasDesc)) {
                  dataLayout = 'image-top';
                  element.setAttribute('data-card-layout', 'image-top');
                  isCardWrapper = true;

                  element.setAttribute('data-processed', 'true');
                  var allInner2 = element.querySelectorAll('*');
                  for (var j = 0; j < allInner2.length; j++) {
                    allInner2[j].setAttribute('data-processed', 'true');
                  }
                }
              }
            }
          }

          // 3️⃣ Detecta card left/right pela estrutura
          if (!dataLayout && !isCardWrapper) {
            var innerTable = element.querySelector('table');
            if (innerTable) {
              var innerRow = innerTable.querySelector('tr');
              if (innerRow) {
                var cells = innerRow.querySelectorAll(':scope > td');

                if (cells.length === 2) {
                  var firstCell = cells[0];
                  var secondCell = cells[1];

                  var hasCardClasses = firstCell.classList.contains('card-image') ||
                    firstCell.classList.contains('card-content') ||
                    secondCell.classList.contains('card-image') ||
                    secondCell.classList.contains('card-content');

                  var hasImgOrPlaceholder = firstCell.querySelector('img[src]') ||
                    firstCell.querySelector('.placeholder-img') ||
                    secondCell.querySelector('img[src]') ||
                    secondCell.querySelector('.placeholder-img');

                  var hasContent = firstCell.querySelector('h3, h2') ||
                    secondCell.querySelector('h3, h2');

                  if (hasCardClasses || (hasImgOrPlaceholder && hasContent)) {
                    var isImageLeft = firstCell.classList.contains('card-image') ||
                      firstCell.querySelector('img[src]') ||
                      firstCell.querySelector('.placeholder-img');

                    dataLayout = isImageLeft ? 'image-left' : 'image-right';
                    element.setAttribute('data-card-layout', dataLayout);
                    isCardWrapper = true;

                    element.setAttribute('data-processed', 'true');
                    var allInner3 = element.querySelectorAll('*');
                    for (var k = 0; k < allInner3.length; k++) {
                      allInner3[k].setAttribute('data-processed', 'true');
                    }
                  }
                }
              }
            }
          }

          // ========== FASE 2: PROCESSA GRID COM DATA-ATTR ==========

          if (!dataLayout && !isCardWrapper) {
            var gridColumnsAttr = element.getAttribute('data-grid-columns');

            if (gridColumnsAttr) {
              var gridColumns = parseInt(gridColumnsAttr);
              var cardLayout = 'grid-' + gridColumns;

              var signature = 'card-grid-' + cardLayout + '-' + Date.now();
              if (processedSignatures.has(signature)) {
                return;
              }
              processedSignatures.add(signature);

              element.setAttribute('data-processed', 'true');
              var allChildren = element.querySelectorAll('*');
              for (var x = 0; x < allChildren.length; x++) {
                allChildren[x].setAttribute('data-processed', 'true');
              }

              var mainRow = element.querySelector(':scope > tbody > tr, :scope > tr');
              if (!mainRow) {
                mainRow = element.querySelector('tr');
              }

              var directCells = [];
              if (mainRow) {
                var allCellsInRow = mainRow.children;
                for (var c = 0; c < allCellsInRow.length; c++) {
                  if (allCellsInRow[c].tagName === 'TD') {
                    directCells.push(allCellsInRow[c]);
                  }
                }
              }

              var validCells = [];
              var processedImages = new Set();

              for (var c = 0; c < directCells.length; c++) {
                var cell = directCells[c];

                var img = null;
                var imgElements = cell.querySelectorAll('img[src]');

                for (var i = 0; i < imgElements.length; i++) {
                  var imgSrc = imgElements[i].getAttribute('src');
                  if (imgSrc && !processedImages.has(imgSrc)) {
                    img = imgElements[i];
                    processedImages.add(imgSrc);
                    break;
                  }
                }

                validCells.push(cell);
              }

              var finalCells = validCells.slice(0, gridColumns);

              if (finalCells.length !== gridColumns) {
                console.warn('⚠️ AVISO: Número de células (' + finalCells.length + ') diferente do esperado (' + gridColumns + ')');
              }

              var gridItems = [];
              for (var i = 0; i < gridColumns; i++) {
                if (finalCells[i]) {
                  var cell = finalCells[i];

                  // 🔥 EXTRAI IMAGEM E ESTILOS
                  var imgTable = cell.querySelector('table[style*="background-image"]');
                  var imgSrc = '';
                  var imagePosition = 'center';
                  var imageZoom = 1;

                  if (imgTable) {
                    var tableStyle = imgTable.getAttribute('style') || '';

                    // Extrai URL da imagem
                    var bgMatch = tableStyle.match(/background-image:\s*url\(['"]?([^'")\s]+)['"]?\)/);
                    if (bgMatch) imgSrc = bgMatch[1];

                    // 🔥 EXTRAI POSITION
                    var posMatch = tableStyle.match(/background-position:\s*([^;]+)/);
                    if (posMatch) imagePosition = posMatch[1].trim();

                    // 🔥 EXTRAI ZOOM do background-size
                    var sizeMatch = tableStyle.match(/background-size:\s*(\d+)%/);
                    if (sizeMatch) {
                      var sizePercent = parseInt(sizeMatch[1]);
                      // Calcula zoom baseado no tamanho (considerando o multiplicador usado no generateHTML)
                      imageZoom = sizePercent / 115; // 115 é o multiplicador base usado
                    }
                  }

                  var titleEl = cell.querySelector('h4, h3, h2');
                  var descEl = cell.querySelector('p');
                  var buttonEl = cell.querySelector('a[href]');

                  var itemTitleSize = 20;
                  var itemTitleColor = '#333333';
                  var itemDescSize = 14;
                  var itemDescColor = '#666666';

                  if (titleEl) {
                    var titleStyle = titleEl.getAttribute('style') || '';
                    var sizeMatch = titleStyle.match(/font-size:\s*(\d+)px/);
                    if (sizeMatch) itemTitleSize = parseInt(sizeMatch[1]);
                    var colorMatch = titleStyle.match(/color:\s*([^;]+)/);
                    if (colorMatch) itemTitleColor = vm.rgbToHex(colorMatch[1].trim()) || colorMatch[1].trim();
                  }

                  if (descEl) {
                    var descStyle = descEl.getAttribute('style') || '';
                    var descSizeMatch = descStyle.match(/font-size:\s*(\d+)px/);
                    if (descSizeMatch) itemDescSize = parseInt(descSizeMatch[1]);
                    var descColorMatch = descStyle.match(/color:\s*([^;]+)/);
                    if (descColorMatch) itemDescColor = vm.rgbToHex(descColorMatch[1].trim()) || descColorMatch[1].trim();
                  }

                  gridItems.push({
                    imageUrl: imgSrc,
                    imageAlt: '',
                    imagePosition: imagePosition, // 🔥 PRESERVA POSITION
                    imageZoom: imageZoom, // 🔥 PRESERVA ZOOM
                    title: titleEl ? titleEl.textContent.trim() : 'Item ' + (i + 1),
                    description: descEl ? descEl.textContent.trim() : 'Descrição ' + (i + 1),
                    buttonUrl: buttonEl ? buttonEl.getAttribute('href') : '#'
                  });
                } else {
                  gridItems.push({
                    imageUrl: '',
                    imageAlt: '',
                    imagePosition: 'center',
                    imageZoom: 1,
                    title: 'Item ' + (i + 1),
                    description: 'Descrição ' + (i + 1),
                    buttonUrl: '#'
                  });
                }
              }

              var gridImageHeight = 180;
              var imageRadius = 8;
              var gridGap = 20;
              var titleSize = 20;
              var titleColor = '#333333';
              var titleAlign = 'left';
              var descriptionSize = 14;
              var descriptionColor = '#666666';
              var buttonBgColor = '#667eea';
              var buttonTextColor = '#ffffff';

              if (validCells.length > 0) {
                var firstTable = validCells[0].querySelector('table[style*="background-image"]');
                if (firstTable) {
                  var heightMatch = (firstTable.getAttribute('style') || '').match(/height:\s*(\d+)px/);
                  if (heightMatch) gridImageHeight = parseInt(heightMatch[1]);

                  var imgRadiusMatch = (firstTable.getAttribute('style') || '').match(/border-radius:\s*(\d+)px/);
                  if (imgRadiusMatch) imageRadius = parseInt(imgRadiusMatch[1]);
                }

                if (validCells.length > 1) {
                  var cell1Style = validCells[0].getAttribute('style') || '';
                  var gapMatch = cell1Style.match(/padding-right:\s*(\d+)px/);
                  if (gapMatch) gridGap = parseInt(gapMatch[1]);
                }

                var firstTitle = validCells[0].querySelector('h3, h4, h2');
                if (firstTitle) {
                  var titleStyle = window.getComputedStyle(firstTitle);
                  titleSize = parseInt(titleStyle.fontSize) || 20;
                  titleColor = vm.rgbToHex(titleStyle.color) || '#333333';
                  titleAlign = titleStyle.textAlign || 'left';
                }

                // 🔥 EXTRAI CORES DO BOTÃO DO GRID
                var firstButton = validCells[0].querySelector('a[href]');
                if (firstButton) {
                  var btnBgAttr = firstButton.getAttribute('data-button-bg');
                  var btnTextAttr = firstButton.getAttribute('data-button-text-color');

                  if (btnBgAttr) {
                    buttonBgColor = btnBgAttr;
                  } else {
                    var btnTd = firstButton.closest('td[bgcolor]') || firstButton.closest('td[style*="background"]');
                    if (btnTd) {
                      var tdBgcolor = btnTd.getAttribute('bgcolor');
                      if (tdBgcolor) {
                        buttonBgColor = tdBgcolor.startsWith('#') ? tdBgcolor : vm.rgbToHex(tdBgcolor) || tdBgcolor;
                      } else {
                        var tdStyle = btnTd.getAttribute('style') || '';
                        var bgMatch = tdStyle.match(/background(?:-color)?:\s*([^;]+)/);
                        if (bgMatch) {
                          buttonBgColor = vm.rgbToHex(bgMatch[1].trim()) || bgMatch[1].trim();
                        }
                      }
                    }
                  }

                  if (btnTextAttr) {
                    buttonTextColor = btnTextAttr;
                  } else {
                    var btnInlineStyle = firstButton.getAttribute('style') || '';
                    var textColorMatch = btnInlineStyle.match(/color:\s*([^;]+)/);
                    if (textColorMatch) {
                      buttonTextColor = vm.rgbToHex(textColorMatch[1].trim()) || textColorMatch[1].trim();
                    }
                  }
                }
              }

              components.push({
                id: Date.now() + Math.random(),
                type: 'card',
                layout: cardLayout,

                gridItems: gridItems,
                gridImageHeight: gridImageHeight,
                imageRadius: imageRadius,
                gridGap: gridGap,

                title: 'Titulo do Card',
                titleSize: titleSize,
                titleColor: titleColor,
                titleAlign: titleAlign,

                description: 'Descrição ou texto do card. Adicione mais detalhes aqui.',
                descriptionSize: descriptionSize,
                descriptionColor: descriptionColor,
                descriptionAlign: 'left',

                buttonText: 'Saiba Mais',
                buttonBgColor: buttonBgColor,
                buttonTextColor: buttonTextColor,
                buttonAlign: 'left',
                showButton: true,

                backgroundColor: '#f0f0f0',
                borderColor: '#e0e0e0',
                borderWidth: 1,
                borderRadius: 8,
                padding: 20,
                fontFamily: 'Arial, sans-serif',

                imageUrl: '',
                imageAlt: '',
                imageWidth: 40,
                imageHeight: 200,
                imagePosition: 'center',
                imageZoom: 1,
                imageGap: 20,
                bannerHeight: 400,
                overlayOpacity: 0.4
              });
              return;
            }
          }

          // ========== FASE 3: PROCESSA CARDS DETECTADOS ==========

          if (dataLayout || isCardWrapper) {
            var cardLayout = dataLayout || 'image-left';

            var signature = 'card-' + cardLayout + '-' + Date.now();

            processedSignatures.add(signature);

            // ===== PROCESSAMENTO DO IMAGE-TOP =====
            if (cardLayout === 'image-top') {
              var containerTd = element.querySelector('td[style*="background-color"]') ||
                element.querySelector('td[style*="padding"]') ||
                element.querySelector('td[style*="border"]');

              if (!containerTd) {
                var outerTable = element.closest('table[style*="margin"]');
                if (outerTable) {
                  containerTd = outerTable.querySelector('td[style*="background"]') ||
                    outerTable.querySelector('td[style*="padding"]');
                }
              }

              var containerStyle = containerTd ? containerTd.getAttribute('style') : '';

              var backgroundColor = '#f0f0f0';
              var bgMatch = containerStyle.match(/background-color:\s*([^;]+)/);
              if (bgMatch) {
                backgroundColor = vm.rgbToHex(bgMatch[1].trim()) || bgMatch[1].trim();
              }

              var borderWidth = 0;
              var borderColor = '#e0e0e0';
              var borderMatch = containerStyle.match(/border:\s*(\d+)px\s+solid\s+([^;]+)/);
              if (borderMatch) {
                borderWidth = parseInt(borderMatch[1]);
                borderColor = vm.rgbToHex(borderMatch[2].trim()) || borderMatch[2].trim();
              }

              var borderRadius = 8;
              var radiusMatch = containerStyle.match(/border-radius:\s*(\d+)px/);
              if (radiusMatch) borderRadius = parseInt(radiusMatch[1]);

              var padding = 20;
              var paddingMatch = containerStyle.match(/padding:\s*(\d+)px/);
              if (paddingMatch) padding = parseInt(paddingMatch[1]);

              // 🔥 EXTRAI IMAGEM COM ZOOM E POSITION
              var imgTable = element.querySelector('table[style*="background-image"]');
              var imageUrl = '';
              var imagePosition = 'center';
              var imageZoom = 1;
              var imageHeight = 200;
              var imageRadius = 8;

              if (imgTable) {
                var tableStyle = imgTable.getAttribute('style') || '';

                // URL da imagem
                var bgMatch = tableStyle.match(/background-image:\s*url\(['"]?([^'")\s]+)['"]?\)/);
                if (bgMatch) imageUrl = bgMatch[1];

                // 🔥 POSITION
                var posMatch = tableStyle.match(/background-position:\s*([^;]+)/);
                if (posMatch) imagePosition = posMatch[1].trim();

                // 🔥 ZOOM do background-size
                var sizeMatch = tableStyle.match(/background-size:\s*(\d+)%/);
                if (sizeMatch) {
                  var sizePercent = parseInt(sizeMatch[1]);
                  imageZoom = sizePercent / 115; // Multiplicador base
                }

                // HEIGHT
                var heightMatch = tableStyle.match(/height:\s*(\d+)px/);
                if (heightMatch) imageHeight = parseInt(heightMatch[1]);

                // RADIUS
                var radiusMatch = tableStyle.match(/border-radius:\s*(\d+)px/);
                if (radiusMatch) imageRadius = parseInt(radiusMatch[1]);
              }

              var imageGap = 20;
              var imgTd = imgTable ? imgTable.closest('td') : null;
              if (imgTd) {
                var tdStyle = imgTd.getAttribute('style') || '';
                var gapMatch = tdStyle.match(/padding-bottom:\s*(\d+)px/);
                if (gapMatch) imageGap = parseInt(gapMatch[1]);
              }

              // 🔥 EXTRAI ESTILOS
              var titleEl = element.querySelector('h3, h2');
              var titleSize = 20;
              var titleColor = '#333333';
              var titleAlign = 'center';

              if (titleEl) {
                var titleInlineStyle = titleEl.getAttribute('style') || '';
                var sizeMatch = titleInlineStyle.match(/font-size:\s*(\d+)px/);
                if (sizeMatch) titleSize = parseInt(sizeMatch[1]);

                var colorMatch = titleInlineStyle.match(/color:\s*([^;]+)/);
                if (colorMatch) titleColor = vm.rgbToHex(colorMatch[1].trim()) || colorMatch[1].trim();

                var alignMatch = titleInlineStyle.match(/text-align:\s*(\w+)/);
                if (alignMatch) titleAlign = alignMatch[1];
              }

              var descEl = element.querySelector('p');
              var descriptionSize = 14;
              var descriptionColor = '#666666';
              var descriptionAlign = 'center';

              if (descEl) {
                var descInlineStyle = descEl.getAttribute('style') || '';
                var descSizeMatch = descInlineStyle.match(/font-size:\s*(\d+)px/);
                if (descSizeMatch) descriptionSize = parseInt(descSizeMatch[1]);

                var descColorMatch = descInlineStyle.match(/color:\s*([^;]+)/);
                if (descColorMatch) descriptionColor = vm.rgbToHex(descColorMatch[1].trim()) || descColorMatch[1].trim();

                var descAlignMatch = descInlineStyle.match(/text-align:\s*(\w+)/);
                if (descAlignMatch) descriptionAlign = descAlignMatch[1];
              }

              // 🔥 EXTRAI CORES DO BOTÃO
              var buttonEl = element.querySelector('a[href]');
              var buttonBgColor = '#667eea';
              var buttonTextColor = '#ffffff';
              var buttonAlign = 'center';

              if (buttonEl) {
                var btnBgAttr = buttonEl.getAttribute('data-button-bg');
                var btnTextAttr = buttonEl.getAttribute('data-button-text-color');

                if (btnBgAttr) {
                  buttonBgColor = btnBgAttr;
                } else {
                  var btnTd = buttonEl.closest('td[bgcolor]') || buttonEl.closest('td[style*="background"]');
                  if (btnTd) {
                    var tdBgcolor = btnTd.getAttribute('bgcolor');
                    if (tdBgcolor) {
                      buttonBgColor = tdBgcolor.startsWith('#') ? tdBgcolor : vm.rgbToHex(tdBgcolor) || tdBgcolor;
                    } else {
                      var tdStyle = btnTd.getAttribute('style') || '';
                      var bgMatch = tdStyle.match(/background(?:-color)?:\s*([^;]+)/);
                      if (bgMatch) {
                        buttonBgColor = vm.rgbToHex(bgMatch[1].trim()) || bgMatch[1].trim();
                      }
                    }
                  }
                }

                if (btnTextAttr) {
                  buttonTextColor = btnTextAttr;
                } else {
                  var btnInlineStyle = buttonEl.getAttribute('style') || '';
                  var textColorMatch = btnInlineStyle.match(/color:\s*([^;]+)/);
                  if (textColorMatch) {
                    buttonTextColor = vm.rgbToHex(textColorMatch[1].trim()) || textColorMatch[1].trim();
                  }
                }

                var btnParentDiv = buttonEl.closest('div');
                if (btnParentDiv) {
                  var divStyle = btnParentDiv.getAttribute('style') || '';
                  var btnAlignMatch = divStyle.match(/text-align:\s*(\w+)/);
                  if (btnAlignMatch) buttonAlign = btnAlignMatch[1];
                }
              }

              components.push({
                id: Date.now() + Math.random(),
                type: 'card',
                layout: 'image-top',

                imageUrl: imageUrl,
                imageAlt: '',
                imageWidth: 40,
                imageHeight: imageHeight,
                imagePosition: imagePosition, // 🔥 PRESERVADO
                imageZoom: imageZoom, // 🔥 PRESERVADO
                imageRadius: imageRadius,
                imageGap: imageGap,

                title: titleEl ? titleEl.textContent.trim() : 'Título do Card',
                titleSize: titleSize,
                titleColor: titleColor,
                titleAlign: titleAlign,

                description: descEl ? descEl.textContent.trim() : 'Descrição',
                descriptionSize: descriptionSize,
                descriptionColor: descriptionColor,
                descriptionAlign: descriptionAlign,

                buttonText: buttonEl ? buttonEl.textContent.trim() : 'Saiba Mais',
                buttonUrl: buttonEl ? buttonEl.getAttribute('href') : '#',
                buttonBgColor: buttonBgColor,
                buttonTextColor: buttonTextColor,
                buttonAlign: buttonAlign,
                showButton: !!buttonEl,

                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderWidth: borderWidth,
                borderRadius: borderRadius,
                padding: padding,
                fontFamily: 'Arial, sans-serif',

                gridItems: [],
                gridImageHeight: 180,
                gridGap: 20,
                bannerHeight: 400,
                overlayOpacity: 0.4
              });
              return;
            }

            if (classList.includes('banner-card-table') || cardLayout === 'banner') {
              var containerTd = element.querySelector('td[style*="border-radius"]') || element.querySelector('td');
              var containerStyle = containerTd ? containerTd.getAttribute('style') : '';

              var radiusMatch = containerStyle.match(/border-radius:\s*(\d+)px/);
              var imageRadius = radiusMatch ? parseInt(radiusMatch[1]) : 8;

              var bgDiv = element.querySelector('div[style*="background-image"]');

              var bgStyle = bgDiv.getAttribute('style') || '';

              var bgMatch = bgStyle.match(/background-image:\s*url\(['"]?([^'")\s]+)['"]?\)/);
              var bgImg = bgMatch ? bgMatch[1] : '';

              var posMatch = bgStyle.match(/background-position:\s*([^;]+)/);
              var imagePosition = posMatch ? posMatch[1].trim() : 'center';

              // 🔥 EXTRAI ZOOM DO BANNER
              var imageZoom = 1;
              var sizeMatch = bgStyle.match(/background-size:\s*(\d+)%/);
              if (sizeMatch) {
                var sizePercent = parseInt(sizeMatch[1]);
                imageZoom = sizePercent / 100;
              } else if (bgStyle.includes('background-size: cover')) {
                imageZoom = 1;
              }

              var heightMatch = bgStyle.match(/height:\s*(\d+)px/);
              var bannerHeight = heightMatch ? parseInt(heightMatch[1]) : 400;

              var overlayTd = element.querySelector('td[style*="rgba(0,0,0"]');
              var overlayStyle = overlayTd ? overlayTd.getAttribute('style') : '';
              var overlayMatch = overlayStyle.match(/rgba\(0,0,0,([\d.]+)\)/);
              var overlayOpacity = overlayMatch ? parseFloat(overlayMatch[1]) : 0.4;

              var paddingMatch = overlayStyle.match(/padding:\s*(\d+)px\s+(\d+)px/);
              var verticalPadding = paddingMatch ? parseInt(paddingMatch[1]) : 60;

              var imageGap = Math.round(verticalPadding / 3);

              // 🔥 EXTRAI ESTILOS DO BANNER
              var titleEl = element.querySelector('h2');
              var titleColor = '#ffffff';
              var titleSize = 20;
              if (titleEl) {
                var titleStyle = titleEl.getAttribute('style') || '';
                var colorMatch = titleStyle.match(/color:\s*([^;]+)/);
                if (colorMatch) titleColor = vm.rgbToHex(colorMatch[1].trim()) || colorMatch[1].trim();

                var sizeMatch = titleStyle.match(/font-size:\s*(\d+)px/);
                if (sizeMatch) {
                  var bannerTitleSize = parseInt(sizeMatch[1]);
                  titleSize = Math.round(bannerTitleSize / 1.5);
                }
              }

              var descEl = element.querySelector('p');
              var descColor = '#ffffff';
              var descSize = 14;
              if (descEl) {
                var descStyle = descEl.getAttribute('style') || '';
                var descColorMatch = descStyle.match(/color:\s*([^;]+)/);
                if (descColorMatch) descColor = vm.rgbToHex(descColorMatch[1].trim()) || descColorMatch[1].trim();

                var descSizeMatch = descStyle.match(/font-size:\s*(\d+)px/);
                if (descSizeMatch) descSize = parseInt(descSizeMatch[1]) || 14;
              }

              // 🔥 EXTRAI CORES DO BOTÃO
              var buttonEl = element.querySelector('a[href]');
              var buttonBgColor = '#667eea';
              var buttonTextColor = '#ffffff';

              if (buttonEl) {
                var btnBgAttr = buttonEl.getAttribute('data-button-bg');
                var btnTextAttr = buttonEl.getAttribute('data-button-text-color');

                if (btnBgAttr) {
                  buttonBgColor = btnBgAttr;
                } else {
                  var btnTd = buttonEl.closest('td[bgcolor]') || buttonEl.closest('td[style*="background"]');
                  if (btnTd) {
                    var tdBgcolor = btnTd.getAttribute('bgcolor');
                    if (tdBgcolor) {
                      buttonBgColor = tdBgcolor.startsWith('#') ? tdBgcolor : vm.rgbToHex(tdBgcolor) || tdBgcolor;
                    } else {
                      var tdStyle = btnTd.getAttribute('style') || '';
                      var bgMatch = tdStyle.match(/background(?:-color)?:\s*([^;]+)/);
                      if (bgMatch) {
                        buttonBgColor = vm.rgbToHex(bgMatch[1].trim()) || bgMatch[1].trim();
                      }
                    }
                  }
                }

                if (btnTextAttr) {
                  buttonTextColor = btnTextAttr;
                } else {
                  var btnInlineStyle = buttonEl.getAttribute('style') || '';
                  var textColorMatch = btnInlineStyle.match(/color:\s*([^;]+)/);
                  if (textColorMatch) {
                    buttonTextColor = vm.rgbToHex(textColorMatch[1].trim()) || textColorMatch[1].trim();
                  }
                }
              }

              components.push({
                id: Date.now() + Math.random(),
                type: 'card',
                layout: 'banner',

                imageUrl: bgImg,
                imageAlt: 'Banner',
                imagePosition: imagePosition, // 🔥 PRESERVADO
                imageZoom: imageZoom, // 🔥 PRESERVADO
                imageRadius: imageRadius,
                imageGap: imageGap,

                bannerHeight: bannerHeight,
                overlayOpacity: overlayOpacity,

                title: titleEl ? titleEl.textContent.trim() : 'Título do Banner',
                titleSize: titleSize,
                titleColor: titleColor,
                titleAlign: 'center',

                description: descEl ? descEl.textContent.trim() : 'Descrição',
                descriptionSize: descSize,
                descriptionColor: descColor,
                descriptionAlign: 'center',

                buttonText: buttonEl ? buttonEl.textContent.trim() : 'Saiba Mais',
                buttonUrl: buttonEl ? buttonEl.getAttribute('href') : '#',
                buttonBgColor: buttonBgColor,
                buttonTextColor: buttonTextColor,
                buttonAlign: 'center',
                showButton: !!buttonEl,

                backgroundColor: '#ffffff',
                borderColor: '#e0e0e0',
                borderWidth: 0,
                borderRadius: imageRadius,
                padding: 0,
                fontFamily: 'Arial, sans-serif',

                gridItems: [],
                imageWidth: 40,
                imageHeight: 200,
                gridImageHeight: 180,
                gridGap: 20
              });
              return;
            }

            // ===== PROCESSAMENTO DE IMAGE-LEFT E IMAGE-RIGHT =====

            var containerTd = element.querySelector('td[style*="background-color"]');
            if (!containerTd) {
              containerTd = element.querySelector('td[style*="padding"]');
            }
            if (!containerTd) {
              containerTd = element.querySelector('td');
            }

            var containerStyle = containerTd ? containerTd.getAttribute('style') : '';

            var backgroundColor = '#ffffff';
            var bgMatch = containerStyle.match(/background-color:\s*([^;]+)/);
            if (bgMatch) {
              var bgValue = bgMatch[1].trim();
              backgroundColor = vm.rgbToHex(bgValue) || bgValue;
            }

            var borderWidth = 1;
            var borderColor = '#e0e0e0';
            var borderMatch = containerStyle.match(/border:\s*(\d+)px\s+solid\s+([^;]+)/);
            if (borderMatch) {
              borderWidth = parseInt(borderMatch[1]);
              borderColor = vm.rgbToHex(borderMatch[2].trim()) || borderMatch[2].trim();
            } else {
              var widthMatch = containerStyle.match(/border-width:\s*(\d+)px/);
              var colorMatch = containerStyle.match(/border-color:\s*([^;]+)/);
              if (widthMatch) borderWidth = parseInt(widthMatch[1]);
              if (colorMatch) borderColor = vm.rgbToHex(colorMatch[1].trim()) || colorMatch[1].trim();
            }

            var borderRadius = 8;
            var radiusMatch = containerStyle.match(/border-radius:\s*(\d+)px/);
            if (radiusMatch) borderRadius = parseInt(radiusMatch[1]);

            var padding = 20;
            var paddingMatch = containerStyle.match(/padding:\s*(\d+)px/);
            if (paddingMatch) padding = parseInt(paddingMatch[1]);

            // 🔥 EXTRAI IMAGEM COM ZOOM E POSITION
            var imgTable = element.querySelector('table[style*="background-image"]');
            var imageUrl = '';
            var imagePosition = 'center';
            var imageZoom = 1;
            var imageRadius = 8;

            if (imgTable) {
              var tableStyle = imgTable.getAttribute('style') || '';

              // URL
              var bgMatch = tableStyle.match(/background-image:\s*url\(['"]?([^'")\s]+)['"]?\)/);
              if (bgMatch) imageUrl = bgMatch[1];

              // 🔥 POSITION
              var posMatch = tableStyle.match(/background-position:\s*([^;]+)/);
              if (posMatch) imagePosition = posMatch[1].trim();

              // 🔥 ZOOM
              var sizeMatch = tableStyle.match(/background-size:\s*(\d+)%/);
              if (sizeMatch) {
                var sizePercent = parseInt(sizeMatch[1]);
                imageZoom = sizePercent / 115;
              }

              // RADIUS
              var radiusMatch = tableStyle.match(/border-radius:\s*(\d+)px/);
              if (radiusMatch) imageRadius = parseInt(radiusMatch[1]);
            }

            var imageWidth = 40;
            var imageHeight = 200;
            var imageGap = 20;

            if (cardLayout === 'image-left' || cardLayout === 'image-right') {
              var imgTd = element.querySelector('td.card-image') || (imgTable ? imgTable.closest('td') : null);
              if (imgTd) {
                var widthAttr = imgTd.getAttribute('width');
                if (widthAttr && widthAttr.includes('%')) {
                  imageWidth = parseInt(widthAttr);
                }
                var tdStyle = imgTd.getAttribute('style') || '';
                var gapMatch = tdStyle.match(/padding-(?:right|left):\s*(\d+)px/);
                if (gapMatch) imageGap = parseInt(gapMatch[1]);
              }
            }

            // 🔥 EXTRAI ESTILOS
            var titleEl = element.querySelector('h3, h2');
            var titleSize = 20;
            var titleColor = '#333333';
            var titleAlign = 'left';

            if (titleEl) {
              var titleInlineStyle = titleEl.getAttribute('style') || '';
              var sizeMatch = titleInlineStyle.match(/font-size:\s*(\d+)px/);
              if (sizeMatch) titleSize = parseInt(sizeMatch[1]);

              var colorMatch = titleInlineStyle.match(/color:\s*([^;]+)/);
              if (colorMatch) titleColor = vm.rgbToHex(colorMatch[1].trim()) || colorMatch[1].trim();

              var alignMatch = titleInlineStyle.match(/text-align:\s*(\w+)/);
              if (alignMatch) titleAlign = alignMatch[1];
            }

            var descEl = element.querySelector('p');
            var descriptionSize = 14;
            var descriptionColor = '#666666';
            var descriptionAlign = 'left';

            if (descEl) {
              var descInlineStyle = descEl.getAttribute('style') || '';
              var descSizeMatch = descInlineStyle.match(/font-size:\s*(\d+)px/);
              if (descSizeMatch) descriptionSize = parseInt(descSizeMatch[1]);

              var descColorMatch = descInlineStyle.match(/color:\s*([^;]+)/);
              if (descColorMatch) descriptionColor = vm.rgbToHex(descColorMatch[1].trim()) || descColorMatch[1].trim();

              var descAlignMatch = descInlineStyle.match(/text-align:\s*(\w+)/);
              if (descAlignMatch) descriptionAlign = descAlignMatch[1];
            }

            // 🔥 EXTRAI CORES DO BOTÃO
            var buttonEl = element.querySelector('a[href]');
            var buttonBgColor = '#667eea';
            var buttonTextColor = '#ffffff';
            var buttonAlign = 'left';

            if (buttonEl) {
              var btnBgAttr = buttonEl.getAttribute('data-button-bg');
              var btnTextAttr = buttonEl.getAttribute('data-button-text-color');

              if (btnBgAttr) {
                buttonBgColor = btnBgAttr;
              } else {
                var btnTd = buttonEl.closest('td[bgcolor]') || buttonEl.closest('td[style*="background"]');
                if (btnTd) {
                  var tdBgcolor = btnTd.getAttribute('bgcolor');
                  if (tdBgcolor) {
                    buttonBgColor = tdBgcolor.startsWith('#') ? tdBgcolor : vm.rgbToHex(tdBgcolor) || tdBgcolor;
                  } else {
                    var tdStyle = btnTd.getAttribute('style') || '';
                    var bgMatch = tdStyle.match(/background(?:-color)?:\s*([^;]+)/);
                    if (bgMatch) {
                      buttonBgColor = vm.rgbToHex(bgMatch[1].trim()) || bgMatch[1].trim();
                    }
                  }
                }
              }

              if (btnTextAttr) {
                buttonTextColor = btnTextAttr;
              } else {
                var btnInlineStyle = buttonEl.getAttribute('style') || '';
                var textColorMatch = btnInlineStyle.match(/color:\s*([^;]+)/);
                if (textColorMatch) {
                  buttonTextColor = vm.rgbToHex(textColorMatch[1].trim()) || textColorMatch[1].trim();
                }
              }

              var btnParentDiv = buttonEl.closest('div');
              if (btnParentDiv) {
                var divStyle = btnParentDiv.getAttribute('style') || '';
                var btnAlignMatch = divStyle.match(/text-align:\s*(\w+)/);
                if (btnAlignMatch) buttonAlign = btnAlignMatch[1];
              }
            }

            components.push({
              id: Date.now() + Math.random(),
              type: 'card',
              layout: cardLayout,

              imageUrl: imageUrl,
              imageAlt: '',
              imageWidth: imageWidth,
              imageHeight: imageHeight,
              imagePosition: imagePosition, // 🔥 PRESERVADO
              imageZoom: imageZoom, // 🔥 PRESERVADO
              imageRadius: imageRadius,
              imageGap: imageGap,

              title: titleEl ? titleEl.textContent.trim() : 'Título do Card',
              titleSize: titleSize,
              titleColor: titleColor,
              titleAlign: titleAlign,

              description: descEl ? descEl.textContent.trim() : 'Descrição',
              descriptionSize: descriptionSize,
              descriptionColor: descriptionColor,
              descriptionAlign: descriptionAlign,

              buttonText: buttonEl ? buttonEl.textContent.trim() : 'Saiba Mais',
              buttonUrl: buttonEl ? buttonEl.getAttribute('href') : '#',
              buttonBgColor: buttonBgColor,
              buttonTextColor: buttonTextColor,
              buttonAlign: buttonAlign,
              showButton: !!buttonEl,

              backgroundColor: backgroundColor,
              borderColor: borderColor,
              borderWidth: borderWidth,
              borderRadius: borderRadius,
              padding: padding,
              fontFamily: 'Arial, sans-serif',

              gridItems: [],
              gridImageHeight: 180,
              gridGap: 20,
              bannerHeight: 400,
              overlayOpacity: 0.4
            });
            return;
          }

          // ========== FASE 4: SE NÃO É CARD, VERIFICA OUTRAS TABLES ==========

          var style = element.getAttribute('style') || '';
          var bgcolor = element.getAttribute('bgcolor') || '';

          // FOOTER
          if (style.includes('background-color:#2c3e50') || bgcolor === '#2c3e50') {
            var signature = 'footer';
            if (processedSignatures.has(signature)) {
              return;
            }
            processedSignatures.add(signature);

            var anchors = element.querySelectorAll('a[href]');
            var privacyHref = '';
            var termsHref = '';
            var unsubscribeHref = '';

            function stripAccents(s) {
              return s ? s.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : '';
            }

            // 🔥 EXTRAI OS LINKS
            for (var i = 0; i < anchors.length; i++) {
              var a = anchors[i];
              var href = a.getAttribute('href') || '';
              var text = (a.textContent || '').trim();
              var ntext = stripAccents(text.toLowerCase());
              var lhref = (href || '').toLowerCase();

              if (!privacyHref && (ntext.indexOf('privacidade') !== -1 || ntext.indexOf('politica') !== -1 || lhref.indexOf('privacidade') !== -1 || lhref.indexOf('privacy') !== -1)) {
                privacyHref = href;
              }

              if (!termsHref && (ntext.indexOf('termo') !== -1 || ntext.indexOf('uso') !== -1 || lhref.indexOf('termos') !== -1 || lhref.indexOf('terms') !== -1)) {
                termsHref = href;
              }

              if (!unsubscribeHref && (ntext.indexOf('descadastrar') !== -1 || ntext.indexOf('descadastro') !== -1 || lhref.indexOf('unsubscribe') !== -1)) {
                unsubscribeHref = href;
              }
            }

            // 🔥 PROCURA ELEMENTOS ESPECÍFICOS POR ESTILO
            var allDivs = element.querySelectorAll('div, p, td');
            var companyName = '';
            var address = '';
            var legalText = '';
            var copyright = '';

            for (var i = 0; i < allDivs.length; i++) {
              var div = allDivs[i];
              var divStyle = div.getAttribute('style') || '';
              var divText = div.textContent.trim();
              var lowerText = stripAccents(divText.toLowerCase());

              // Ignora divs vazios ou com links
              if (!divText || div.querySelector('a')) continue;

              // 🔥 COMPANY NAME - primeiro div com font-size:20px e font-weight:bold
              if (!companyName && divStyle.includes('font-size:20px') && divStyle.includes('font-weight:bold')) {
                companyName = divText;
                continue;
              }

              // 🔥 ADDRESS - div com font-size:14px logo após company name
              if (companyName && !address && divStyle.includes('font-size:14px') && divStyle.includes('margin-bottom:15px')) {
                // Verifica se não contém palavras-chave de outros textos
                if (!lowerText.includes('recebendo') && !lowerText.includes('email') &&
                  !lowerText.includes('direitos') && !lowerText.includes('reservados')) {
                  address = divText;
                  continue;
                }
              }

              // 🔥 LEGAL TEXT - div com font-size:12px e margin-top:20px
              if (!legalText && divStyle.includes('font-size:12px') && divStyle.includes('margin-top:20px')) {
                // Verifica se contém texto sobre recebimento de email
                if (lowerText.includes('recebendo') || lowerText.includes('email') || lowerText.includes('inscre')) {
                  legalText = divText;
                  continue;
                }
              }

              // 🔥 COPYRIGHT - último div com font-size:12px e margin-top:15px
              if (!copyright && divStyle.includes('font-size:12px') && divStyle.includes('margin-top:15px')) {
                // Verifica se contém "direitos reservados" ou ano
                if (lowerText.includes('direitos') || lowerText.includes('reservados') || lowerText.includes('2025')) {
                  copyright = divText;
                  continue;
                }
              }
            }

            // 🔥 FALLBACK: Se não encontrou pelos estilos, usa a lógica anterior melhorada
            if (!companyName || !address) {
              var clone = element.cloneNode(true);
              var cloneAnchors = clone.querySelectorAll('a');
              for (var j = 0; j < cloneAnchors.length; j++) {
                cloneAnchors[j].remove();
              }

              var allText = clone.textContent.trim();
              var lines = allText.split('\n').map(function (l) { return l.trim(); }).filter(function (l) { return l && l.length > 2; });

              // Remove linhas que contenham palavras-chave de links
              var filteredLines = lines.filter(function (line) {
                var lowerLine = stripAccents(line.toLowerCase());
                return !lowerLine.includes('privacidade') &&
                  !lowerLine.includes('politica') &&
                  !lowerLine.includes('termos') &&
                  !lowerLine.includes('descadastrar');
              });

              if (!companyName) companyName = filteredLines[0] || 'Wurth do Brasil';

              // 🔥 ADDRESS: pega apenas linhas com endereço (contém "R." ou números)
              if (!address) {
                var addressLines = filteredLines.filter(function (line) {
                  return (line.includes('R.') || line.includes('Rua') || /\d{3,}/.test(line)) &&
                    !line.includes('recebendo') &&
                    !line.includes('©') &&
                    line !== companyName;
                });
                address = addressLines.join('\n');
              }

              // 🔥 LEGAL TEXT: linhas com "recebendo", "email", etc
              if (!legalText) {
                var legalLines = filteredLines.filter(function (line) {
                  var lower = stripAccents(line.toLowerCase());
                  return (lower.includes('recebendo') || lower.includes('email') || lower.includes('inscre')) &&
                    !lower.includes('direitos') &&
                    !lower.includes('©');
                });
                legalText = legalLines.join('\n');
              }

              // 🔥 COPYRIGHT: última linha com "©" ou "direitos"
              if (!copyright) {
                copyright = filteredLines.filter(function (line) {
                  return line.includes('©') || line.includes('direitos');
                })[0] || '';
              }
            }

            components.push({
              id: Date.now() + Math.random(),
              type: 'footer',
              companyName: companyName || 'Wurth do Brasil',
              address: address || '\nR. Adolf Wurth, 557 - Cotia - SP',
              bgColor: '#2c3e50',
              textColor: '#ffffff',
              fontFamily: 'Arial, sans-serif',
              align: 'center',
              socialLinks: {},
              usefulLinks: {
                privacy: privacyHref || '',
                terms: termsHref || '',
                unsubscribe: unsubscribeHref || "{{ UNSUBSCRIBE_URL }}"
              },
              legalText: legalText || '\nVocê está recebendo este email devido à relação comercial existente entre você e Wurth do Brasil referente aos títulos em aberto.\nSe não deseja mais receber, clique no link de descadastro acima.',
              copyright: copyright || '© 2025 Wurth do Brasil. Todos os direitos reservados.'
            });
            return;
          }

          // SOCIAL - DEVE VIR ANTES DE COLUMNS
          var socialIcons = element.querySelectorAll('img[src*="/icons/"]');
          if (socialIcons.length >= 1) {
            var hasSocialAlready = components.some(function (c) { return c.type === 'social'; });

            if (!hasSocialAlready) {
              var isInFooter = element.closest('table[bgcolor="#2c3e50"]') ||
                element.closest('table[style*="background-color:#2c3e50"]');
              var isInCard = element.closest('.email-card-wrapper') ||
                element.closest('[data-card-layout]');

              if (!isInFooter && !isInCard) {
                var signature = 'social-' + Date.now();
                if (processedSignatures.has(signature)) {
                  return;
                }
                processedSignatures.add(signature);

                var socialLinks = {
                  facebook: '', instagram: '', twitter: '', linkedin: '',
                  youtube: '', tiktok: '', whatsapp: '', telegram: ''
                };

                var foundCount = 0;
                var allSocialLinks = element.querySelectorAll('a[href]');

                for (var i = 0; i < allSocialLinks.length; i++) {
                  var link = allSocialLinks[i];
                  var href = (link.getAttribute('href') || '').trim().toLowerCase();
                  var linkImg = link.querySelector('img[src*="/icons/"]');
                  var imgSrc = linkImg ? (linkImg.getAttribute('src') || '').toLowerCase() : '';

                  if (!href) continue;

                  if ((imgSrc.includes('facebook') || href.includes('facebook.com')) && !socialLinks.facebook) {
                    socialLinks.facebook = link.getAttribute('href');
                    foundCount++;
                  } else if ((imgSrc.includes('instagram') || href.includes('instagram.com')) && !socialLinks.instagram) {
                    socialLinks.instagram = link.getAttribute('href');
                    foundCount++;
                  } else if ((imgSrc.includes('twitter') || href.includes('x.com') || href.includes('x.com')) && !socialLinks.twitter) {
                    socialLinks.twitter = link.getAttribute('href');
                    foundCount++;
                  } else if ((imgSrc.includes('linkedin') || href.includes('linkedin.com')) && !socialLinks.linkedin) {
                    socialLinks.linkedin = link.getAttribute('href');
                    foundCount++;
                  } else if ((imgSrc.includes('youtube') || (href.includes('youtube.com') && !href.includes('watch'))) && !socialLinks.youtube) {
                    socialLinks.youtube = link.getAttribute('href');
                    foundCount++;
                  } else if ((imgSrc.includes('tiktok') || href.includes('tiktok.com')) && !socialLinks.tiktok) {
                    socialLinks.tiktok = link.getAttribute('href');
                    foundCount++;
                  } else if ((imgSrc.includes('whatsapp') || href.includes('wa.me') || href.includes('whatsapp')) && !socialLinks.whatsapp) {
                    socialLinks.whatsapp = link.getAttribute('href');
                    foundCount++;
                  } else if ((imgSrc.includes('telegram') || href.includes('t.me') || href.includes('telegram')) && !socialLinks.telegram) {
                    socialLinks.telegram = link.getAttribute('href');
                    foundCount++;
                  }
                }

                if (foundCount > 0) {
                  var titleElement = element.querySelector('div[style*="font-size:18px"], div[style*="font-weight:bold"]');
                  var socialTitle = 'Siga-nos nas redes sociais';

                  if (!titleElement) {
                    titleElement = element.querySelector('div, h1, h2, h3, h4, h5, h6, p');
                  }

                  if (titleElement) {
                    var titleText = titleElement.textContent.trim();
                    var lowerTitle = titleText.toLowerCase();
                    if (titleText && titleText.length > 0 && titleText.length < 100 &&
                      (lowerTitle.includes('siga') || lowerTitle.includes('redes') ||
                        lowerTitle.includes('sociais') || lowerTitle.includes('social'))) {
                      socialTitle = titleText;
                    }
                  }

                  var iconSize = 50;
                  var firstIconTable = socialIcons[0] ? socialIcons[0].closest('table') : null;
                  if (firstIconTable) {
                    var sizeAttr = firstIconTable.getAttribute('width') || firstIconTable.getAttribute('height');
                    if (sizeAttr) iconSize = parseInt(sizeAttr) || 50;
                  }

                  var iconStyle = 'circle';
                  if (firstIconTable) {
                    var tableStyle = (firstIconTable.getAttribute('style') || '').toLowerCase();
                    if (tableStyle.includes('border-radius:50%') || tableStyle.includes('border-radius: 50%')) {
                      iconStyle = 'circle';
                    } else if (tableStyle.includes('border-radius:8px') || tableStyle.includes('border-radius: 8px')) {
                      iconStyle = 'rounded';
                    } else if (tableStyle.includes('border-radius:0')) {
                      iconStyle = 'square';
                    }
                  }

                  var spacing = 15;
                  var iconWrapper = element.querySelector('.social-icon-wrapper, span[style*="margin-right"]');
                  if (iconWrapper) {
                    var wrapperStyle = iconWrapper.getAttribute('style') || '';
                    var spacingMatch = wrapperStyle.match(/margin-right:\s*(\d+)px/);
                    if (spacingMatch) spacing = parseInt(spacingMatch[1]);
                  }

                  var containerTd = element.querySelector('td[align], td[style*="text-align"]');
                  var align = 'center';
                  if (containerTd) {
                    align = containerTd.getAttribute('align') || 'center';
                    if (!align || align === '') {
                      var tdStyle = containerTd.getAttribute('style') || '';
                      var alignMatch = tdStyle.match(/text-align:\s*(\w+)/);
                      if (alignMatch) align = alignMatch[1];
                    }
                  }

                  components.push({
                    id: Date.now() + Math.random(),
                    type: 'social',
                    title: socialTitle,
                    titleColor: '#333333',
                    bgColor: 'transparent',
                    align: align,
                    fontFamily: 'Arial, sans-serif',
                    iconSize: iconSize,
                    iconStyle: iconStyle,
                    iconBgColor: '#ffffff',
                    iconColor: '#333333',
                    iconBorderColor: '#dddddd',
                    spacing: spacing,
                    showShadow: true,
                    links: socialLinks
                  });

                  return;
                }
              }
            }
          }

          // COLUMNS: TABLE com múltiplas colunas (TR > TD + TD)
          var firstRow = element.querySelector('tr');
          if (firstRow) {
            var cells = firstRow.querySelectorAll('td');

            // 🔥 IGNORA se for estrutura de botão (já marcada)
            if (element.hasAttribute('data-button-structure')) {
              return;
            }

            // 🔥 IGNORA se contém um link de botão dentro
            var hasButtonLink = element.querySelector('a[data-button-link]');
            if (hasButtonLink) {
              return;
            }

            // 🔥 IGNORA se é a table wrapper (margin + apenas 1 TD)
            if (cells.length === 1) {
              var singleCell = cells[0];
              var cellStyle = singleCell.getAttribute('style') || '';
              var hasNestedTable = singleCell.querySelector('table');
              var hasButtonInside = singleCell.querySelector('a[href][style*="padding"]');

              if (hasNestedTable || hasButtonInside) {
                return;
              }
            }

            var hasCardInside = element.querySelector('.email-card-wrapper') ||
              element.querySelector('[data-card-layout]') ||
              element.querySelector('.email-card-grid');

            if (cells.length >= 2 && cells.length <= 3 && !hasCardInside) {
              if (cells.length === 2) {
                var firstCell = cells[0];
                var secondCell = cells[1];

                var hasCardClasses = firstCell.classList.contains('card-image') ||
                  firstCell.classList.contains('card-content') ||
                  secondCell.classList.contains('card-image') ||
                  secondCell.classList.contains('card-content');

                var cell1HasCardStructure = firstCell.querySelector('h3, h2') &&
                  firstCell.querySelector('p') &&
                  (firstCell.querySelector('a[href]') || firstCell.querySelector('img'));

                var cell2HasCardStructure = secondCell.querySelector('h3, h2') &&
                  secondCell.querySelector('p') &&
                  (secondCell.querySelector('a[href]') || secondCell.querySelector('img'));

                var isCardLeft = (firstCell.querySelector('img') || firstCell.querySelector('.placeholder-img')) &&
                  cell2HasCardStructure;

                var isCardRight = cell1HasCardStructure &&
                  (secondCell.querySelector('img') || secondCell.querySelector('.placeholder-img'));

                var hasPlaceholder = firstCell.querySelector('.placeholder-img') ||
                  secondCell.querySelector('.placeholder-img');

                if (hasCardClasses || isCardLeft || isCardRight || hasPlaceholder) {
                  return;
                }
              }

              var hasText = false;
              for (var j = 0; j < cells.length; j++) {
                if (cells[j].textContent.trim().length > 0) {
                  hasText = true;
                  break;
                }
              }

              if (hasText) {
                var signature = 'columns:' + components.filter(function (c) { return c.type === 'columns'; }).length;
                if (processedSignatures.has(signature)) {
                  return;
                }
                processedSignatures.add(signature);

                var columnsData = [];
                for (var k = 0; k < cells.length; k++) {
                  columnsData.push({
                    content: cells[k].innerHTML.trim() || ''
                  });
                }

                components.push({
                  id: Date.now() + Math.random(),
                  type: 'columns',
                  columnCount: cells.length,
                  columns: columnsData
                });
                return;
              }
            }
          }
        }

        var isInsideBanner = element.closest('.banner-card-table');

        var isHeading = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'].includes(tag);

        if (
          isHeading &&
          element.hasAttribute('data-heading') &&
          !element.hasAttribute('data-card-text') &&
          !element.closest('.email-card-wrapper') &&
          !element.closest('.email-card-grid') &&
          !element.closest('table.card-responsive')
        ) {
          var signature = 'heading:' + element.innerHTML;
          if (processedSignatures.has(signature)) return;
          processedSignatures.add(signature);

          // 🔥 SEMPRE prioriza data-*
          var color = element.getAttribute('data-color') || '#333333';
          var align = element.getAttribute('data-align') || 'left';
          var fontSize = parseInt(element.getAttribute('data-font-size')) || 26;
          var fontFamily = element.getAttribute('data-font-family') || 'Arial, sans-serif';

          var content = element.innerHTML
            .replace(/<br\s*\/?>/gi, '\n')
            .replace(/<(?!\/?strong)(?!\/?a\s)(?!\/?a>)([^>]+)>/g, '')
            .replace(/&nbsp;/g, ' ')
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .trim();

          components.push({
            id: Date.now() + Math.random(),
            type: 'heading',
            content: content,
            fontSize: fontSize,
            color: color,
            align: align,
            fontFamily: fontFamily
          });

          return;
        }


        if (tag === 'P') {
          var text = element.textContent.trim();
          var isInFooter = element.closest('table[bgcolor="#2c3e50"]');
          var isInSocial = text.includes('Siga-nos') && text.length < 100;
          var isInCard = element.hasAttribute('data-card-text') || element.closest('.email-card-wrapper') || element.closest('.email-card-grid') || element.closest('table.card-responsive');

          if (text && text.length > 5 && !isInFooter && !isInSocial && !isInCard) {
            var signature = 'text:' + text.substring(0, 50);
            if (processedSignatures.has(signature)) {
              return;
            }
            processedSignatures.add(signature);

            var computedStyle = window.getComputedStyle(element);
            var inlineStyle = element.getAttribute('style') || '';

            var align = 'left';
            if (inlineStyle.includes('text-align')) {
              var match = inlineStyle.match(/text-align:\s*(\w+)/);
              if (match) align = match[1];
            } else {
              align = computedStyle.textAlign || 'left';
            }

            var fontFamily = 'Arial, sans-serif';
            if (inlineStyle.includes('font-family')) {
              var match2 = inlineStyle.match(/font-family:\s*([^;]+)/);
              if (match2) fontFamily = match2[1].trim().replace(/['"]/g, '');
            } else if (computedStyle.fontFamily) {
              fontFamily = computedStyle.fontFamily.split(',')[0].trim().replace(/['"]/g, '') + ', sans-serif';
            }

            var innerHTML = element.innerHTML;

            var content = innerHTML
              .replace(/<br\s*\/?>/gi, '\n')
              .replace(/<strong>/gi, '<strong>')
              .replace(/<\/strong>/gi, '</strong>')
              .replace(/<a\s+([^>]*)>/gi, '<a $1>')
              .replace(/<\/a>/gi, '</a>')
              .replace(/<(?!\/?strong)(?!\/?a\s)(?!\/?a>)([^>]+)>/g, '')
              .replace(/&nbsp;/g, ' ')
              .replace(/&amp;/g, '&')
              .replace(/&lt;/g, '<')
              .replace(/&gt;/g, '>')
              .replace(/&quot;/g, '"')
              .trim();

            components.push({
              id: Date.now() + Math.random(),
              type: 'text',
              content: content,
              fontSize: parseInt(computedStyle.fontSize) || 16,
              color: vm.rgbToHex(computedStyle.color) || '#333333',
              align: align,
              fontFamily: fontFamily
            });
          }
          return;
        }

        if (tag === 'IMG') {
          var src = element.getAttribute('src');
          if (!src) return;

          // Ignorar ícones / imagens internas
          var isIcon = src.includes('/icons/');
          var isInVideoLink = element.closest('a[href*="youtube"]');
          var isCardImage = element.hasAttribute('data-card-image');
          var isInsideCard =
            element.closest('.email-card-wrapper') ||
            element.closest('.email-card-grid') ||
            element.closest('table.card-responsive');

          if (isIcon || isInVideoLink || isCardImage || isInsideCard) {
            return;
          }

          var signature = 'image:' + src;
          if (processedSignatures.has(signature)) {
            return;
          }
          processedSignatures.add(signature);

          var parentTd = element.closest('td');
          var alignAttr = parentTd ? parentTd.getAttribute('align') : null;

          // 🔥 largura: SEMPRE prioriza data-width-percent
          var widthPercent = 100;
          var dataWidth = element.getAttribute('data-width-percent');

          if (dataWidth) {
            widthPercent = parseFloat(dataWidth);
          } else {
            var inlineStyle = element.getAttribute('style') || '';
            var styleMatch = inlineStyle.match(/width:\s*([\d.]+)%/);

            if (styleMatch) {
              widthPercent = parseFloat(styleMatch[1]);
            } else {
              var widthAttr = parseInt(element.getAttribute('width')) || 0;
              if (widthAttr > 0) {
                const containerWidth = 800 - (vm.globalSettings?.padding || 0) * 2;
                widthPercent = Math.round((widthAttr / containerWidth) * 100);
              }
            }
          }

          // Verifica se a imagem está dentro de um link
          const parentAnchor = element.closest('a[href]');
          const imageLink = parentAnchor ? parentAnchor.getAttribute('href') : '';
          const imageLinkTarget = parentAnchor ? (parentAnchor.getAttribute('target') || '_blank') : '_blank';

          components.push({
            id: Date.now() + Math.random(),
            type: 'image',
            src: src,
            alt: element.getAttribute('alt') || '',
            width: widthPercent,
            align: alignAttr || 'center',
            link: imageLink,
            linkTarget: imageLinkTarget
          });

          return;
        }

        if (tag === 'HR') {
          var signature = 'divider:' + components.filter(function (c) { return c.type === 'divider'; }).length;
          if (processedSignatures.has(signature)) {
            return;
          }
          processedSignatures.add(signature);

          var computedStyle = window.getComputedStyle(element);
          var style = element.getAttribute('style') || '';

          var color = '#dddddd';
          var thickness = 1;
          var borderStyle = 'solid';

          var borderMatch = style.match(/border-top:\s*(\d+)px\s+(\w+)\s+([^;]+)/);
          if (borderMatch) {
            thickness = parseInt(borderMatch[1]);
            borderStyle = borderMatch[2];
            color = vm.rgbToHex(borderMatch[3].trim()) || '#dddddd';
          } else {
            color = vm.rgbToHex(computedStyle.borderTopColor) || '#dddddd';
            thickness = parseInt(computedStyle.borderTopWidth) || 1;
            borderStyle = computedStyle.borderTopStyle || 'solid';
          }

          components.push({
            id: Date.now() + Math.random(),
            type: 'divider',
            color: color,
            style: borderStyle,
            thickness: thickness
          });
          return;
        }

        // ===== DETECÇÃO DE BOTÕES =====
        if (tag === 'A') {
          var href = element.getAttribute('href') || '';
          var style = element.getAttribute('style') || '';
          var text = element.textContent.trim();

          // Ignora se já foi processado
          if (element.hasAttribute('data-processed')) {
            return;
          }

          var isYouTubeChannel = href.includes('youtube.com/c/') || href.includes('youtube.com/channel/') || href.includes('youtube.com/@');
          var isYouTubeVideo = (href.includes('youtube.com/watch') || href.includes('youtu.be/')) && element.querySelector('img, table');

          // VIDEO
          if (isYouTubeVideo && !isYouTubeChannel) {
            var videoId = href.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?]+)/);
            var signature = 'video:' + (videoId ? videoId[1] : href);

            if (processedSignatures.has(signature)) {
              return;
            }
            processedSignatures.add(signature);

            components.push({
              id: Date.now() + Math.random(),
              type: 'video',
              videoUrl: href,
              scale: 100
            });
            return;
          }

          // 🔥 VERIFICA SE FOI MARCADO COMO BOTÃO
          if (!element.hasAttribute('data-is-button')) {
            return; // Não é botão, continua processando normalmente
          }

          // É um botão marcado, processa
          var elementPath = '';
          var current = element;
          var depth = 0;

          while (current && current !== document.body && depth < 5) {
            var index = Array.from(current.parentNode?.children || []).indexOf(current);
            elementPath = current.nodeName + index + elementPath;
            current = current.parentNode;
            depth++;
          }

          var cleanText = text.replace(/\{\{\s*contact\.\w+\s*\}\}/g, '').trim();
          var signature = 'button:' + elementPath + ':' + cleanText + ':' + href;

          if (processedSignatures.has(signature)) {
            return;
          }
          processedSignatures.add(signature);

          // Marca como processado
          element.setAttribute('data-processed', 'true');

          // Extrai estilos
          var bgColor = '#007bff';
          var textColor = '#ffffff';
          var align = 'center';

          var parentTd = element.closest('td[bgcolor]') || element.closest('td[style*="background"]');

          if (parentTd) {
            var bgcolor = parentTd.getAttribute('bgcolor');
            if (bgcolor) {
              bgColor = bgcolor.startsWith('#') ? bgcolor : vm.rgbToHex(bgcolor) || bgcolor;
            } else {
              var tdStyle = parentTd.getAttribute('style') || '';
              var bgMatch = tdStyle.match(/background(?:-color)?:\s*([^;]+)/);
              if (bgMatch) {
                bgColor = vm.rgbToHex(bgMatch[1].trim()) || bgMatch[1].trim();
              }
            }

            var grandparentTd = parentTd.closest('table')?.closest('td');
            if (grandparentTd) {
              align = grandparentTd.getAttribute('align') || 'center';
            }
          }

          var hasButtonStyle = style.includes('padding') &&
            (style.includes('background') || style.includes('background-color'));

          if (bgColor === '#007bff' && hasButtonStyle) {
            var linkStyle = element.getAttribute('style') || '';
            var bgMatch = linkStyle.match(/background(?:-color)?:\s*([^;]+)/);
            if (bgMatch) {
              bgColor = vm.rgbToHex(bgMatch[1].trim()) || bgMatch[1].trim();
            }
          }

          var linkInlineStyle = element.getAttribute('style') || '';
          var colorMatch = linkInlineStyle.match(/color:\s*([^;]+)/);
          if (colorMatch) {
            textColor = vm.rgbToHex(colorMatch[1].trim()) || colorMatch[1].trim();
          } else {
            var computedStyle = window.getComputedStyle(element);
            textColor = vm.rgbToHex(computedStyle.color) || '#ffffff';
          }

          components.push({
            id: Date.now() + Math.random(),
            type: 'button',
            text: text,
            url: href,
            bgColor: bgColor,
            textColor: textColor,
            align: align
          });

          return;
        }
        // ========== TABELA ==========
        if (tag === 'TABLE') {
          // 🔥 IGNORA se já foi processado
          if (element.hasAttribute('data-processed')) {
            return;
          }

          // 🔥 IGNORA tables wrapper (que têm margin e só 1 TD)
          var style = element.getAttribute('style') || '';
          var hasMargin = style.includes('margin');
          var hasSingleCell = element.querySelectorAll(':scope > tbody > tr, :scope > tr').length === 1 &&
            element.querySelector('tr')?.children.length === 1;

          if (hasMargin && hasSingleCell) {
            // É uma wrapper, pega a table interna
            var innerTable = element.querySelector('table[style*="border-collapse"]');
            if (innerTable) {
              processElement(innerTable); // Processa a table real
              element.setAttribute('data-processed', 'true');
            }
            return;
          }

          // ✅ DETECTA apenas tables REAIS de dados
          var hasTheadTbody = element.querySelector(':scope > thead, :scope > tbody > thead') &&
            element.querySelector(':scope > tbody, :scope > tbody > tbody');

          var hasBorderCollapse = style.includes('border-collapse') ||
            element.getAttribute('cellpadding') === '0';

          var headerCells = element.querySelectorAll('thead th');
          var hasMultipleColumns = headerCells.length >= 2;

          // Se não é uma table de dados real, retorna
          if (!hasTheadTbody || !hasBorderCollapse || !hasMultipleColumns) {
            return;
          }

          // 🔥 VERIFICA contexto (não pode estar em card, footer, etc)
          var isInCard = element.closest('.email-card-wrapper') ||
            element.closest('[data-card-layout]');
          var isInFooter = element.closest('table[bgcolor="#2c3e50"]');
          var isInButton = element.closest('table[data-button-structure]');

          if (isInCard || isInFooter || isInButton) {
            return;
          }

          // ✅ CRIA ASSINATURA ÚNICA
          var signature = 'table:' + headerCells.length + ':' + Date.now();
          if (processedSignatures.has(signature)) {
            return;
          }
          processedSignatures.add(signature);

          // Marca como processado
          element.setAttribute('data-processed', 'true');

          console.log('✅ Processando tabela real:', headerCells.length, 'colunas');

          // ✅ EXTRAI HEADERS (texto visível)
          var headers = [];
          for (var i = 0; i < headerCells.length; i++) {
            headers.push(headerCells[i].textContent.trim());
          }

          // ✅ EXTRAI ROWS (PRESERVANDO VARIÁVEIS ORIGINAIS)
          var tbody = element.querySelector('tbody');
          var bodyRows = tbody ? tbody.querySelectorAll(':scope > tr') : [];
          var rows = [];

          for (var i = 0; i < bodyRows.length; i++) {
            var rowCells = bodyRows[i].querySelectorAll(':scope > td');

            // 🔥 VALIDA: linha deve ter exatamente o mesmo número de colunas
            if (rowCells.length !== headers.length) {
              console.warn('⚠️ Linha', i, 'tem', rowCells.length, 'células, esperado', headers.length);
              continue; // Pula linhas inválidas
            }

            var row = [];
            for (var j = 0; j < rowCells.length; j++) {
              // 🔥 PRESERVA O CONTEÚDO ORIGINAL (incluindo variáveis {{ params.X }})
              var cellContent = rowCells[j].innerHTML
                .replace(/<br\s*\/?>/gi, '\n')
                .replace(/&nbsp;/g, ' ')
                .trim();

              row.push(cellContent);
            }
            rows.push(row);
          }

          console.log('📊 Tabela extraída:', headers.length, 'colunas x', rows.length, 'linhas');
          console.log('📌 Primeira linha (variáveis):', rows[0]); // 🔥 LOG DE DEBUG

          // ✅ EXTRAI ESTILOS
          var headerStyle = headerCells[0] ? headerCells[0].getAttribute('style') : '';
          var cellStyle = bodyRows[0] ? bodyRows[0].querySelector('td')?.getAttribute('style') : '';

          var headerColor = '#333333';
          var headerFontSize = 14;
          var cellColor = '#555555';
          var cellFontSize = 13;
          var borderColor = '#dddddd';
          var evenRowColor = '#ffffff';
          var oddRowColor = '#f9f9f9';
          var headerAlign = 'left';
          var cellAlign = 'left';

          if (headerStyle) {
            var match = headerStyle.match(/color:\s*([^;]+)/);
            if (match) headerColor = vm.rgbToHex(match[1].trim()) || match[1].trim();

            match = headerStyle.match(/font-size:\s*(\d+)px/);
            if (match) headerFontSize = parseInt(match[1]);

            match = headerStyle.match(/text-align:\s*(\w+)/);
            if (match) headerAlign = match[1];
          }

          if (cellStyle) {
            var match = cellStyle.match(/color:\s*([^;]+)/);
            if (match) cellColor = vm.rgbToHex(match[1].trim()) || match[1].trim();

            match = cellStyle.match(/font-size:\s*(\d+)px/);
            if (match) cellFontSize = parseInt(match[1]);

            match = cellStyle.match(/text-align:\s*(\w+)/);
            if (match) cellAlign = match[1];

            match = cellStyle.match(/border-bottom:\s*\d+px\s+solid\s+([^;]+)/);
            if (match) borderColor = vm.rgbToHex(match[1].trim()) || match[1].trim();
          }

          if (bodyRows.length > 0) {
            var row0Style = bodyRows[0].getAttribute('style') || '';
            var match = row0Style.match(/background-color:\s*([^;]+)/);
            if (match) evenRowColor = vm.rgbToHex(match[1].trim()) || match[1].trim();

            if (bodyRows.length > 1) {
              var row1Style = bodyRows[1].getAttribute('style') || '';
              match = row1Style.match(/background-color:\s*([^;]+)/);
              if (match) oddRowColor = vm.rgbToHex(match[1].trim()) || match[1].trim();
            }
          }

          // 🔥 SALVA O COMPONENTE COM ROWS PRESERVADAS
          components.push({
            id: Date.now() + Math.random(),
            type: 'table',
            headers: headers,
            rows: rows, // 🔥 AGORA CONTÉM AS VARIÁVEIS ORIGINAIS
            headerAlign: headerAlign,
            cellAlign: cellAlign,
            headerFontSize: headerFontSize,
            cellFontSize: cellFontSize,
            headerColor: headerColor,
            cellColor: cellColor,
            borderColor: borderColor,
            evenRowColor: evenRowColor,
            oddRowColor: oddRowColor
          });

          return;
        }

        if (tag === 'DIV') {
          var style = element.getAttribute('style') || '';
          var computedStyle = window.getComputedStyle(element);
          var height = parseInt(style.match(/height:\s*(\d+)px/) ? style.match(/height:\s*(\d+)px/)[1] : computedStyle.height);
          var isEmpty = element.textContent.trim().length === 0;
          var hasMinimalChildren = element.children.length === 0;

          if (height > 0 && isEmpty && hasMinimalChildren) {
            var signature = 'spacer:' + components.filter(function (c) { return c.type === 'spacer'; }).length;

            if (processedSignatures.has(signature)) {
              return;
            }
            processedSignatures.add(signature);

            components.push({
              id: Date.now() + Math.random(),
              type: 'spacer',
              height: height
            });
            return;
          }
        }
      }

      function processChildren(parent) {
        var children = parent.children;

        // 🔥 PASSO 1: MARCA todas as tables de botão (sem criar componentes ainda)
        var allLinks = parent.querySelectorAll('a[href]');
        for (var i = 0; i < allLinks.length; i++) {
          var link = allLinks[i];
          var linkStyle = link.getAttribute('style') || '';
          var text = link.textContent.trim();

          // Verifica se é um botão
          var hasButtonStyle = linkStyle.includes('padding') &&
            (linkStyle.includes('background') || linkStyle.includes('background-color'));

          var parentTd = link.closest('td[bgcolor]') || link.closest('td[style*="background"]');
          var isInButtonTable = parentTd && parentTd.querySelector('a[href]') === link;

          var isSocial = link.href.includes('facebook') || link.href.includes('instagram') ||
            link.href.includes('x.com') || link.href.includes('twitter.com') ||
            link.href.includes('linkedin') || link.href.includes('youtube') ||
            link.href.includes('tiktok') || link.href.includes('whatsapp') ||
            link.href.includes('telegram') || link.href.includes('t.me');

          var isInCard = link.closest('.email-card-wrapper') ||
            link.closest('[data-card-layout]') ||
            link.closest('table[data-grid-columns]');

          var isInFooter = link.closest('table[bgcolor="#2c3e50"]') ||
            link.closest('table[style*="background-color:#2c3e50"]');

          // Se é um botão, marca as tables ancestrais
          if ((hasButtonStyle || isInButtonTable) && text && !isSocial && !isInCard && !isInFooter) {
            link.setAttribute('data-is-button', 'true');

            var currentParent = link.parentElement;
            while (currentParent && currentParent !== parent) {
              if (currentParent.tagName === 'TABLE') {
                currentParent.setAttribute('data-button-structure', 'true');
              }
              currentParent = currentParent.parentElement;
            }
          }
        }

        // 🔥 PASSO 2: Processa os elementos NA ORDEM ORIGINAL
        for (var i = 0; i < children.length; i++) {
          var child = children[i];

          // Pula se já foi processado
          if (child.hasAttribute('data-processed')) {
            continue;
          }

          var isBannerTable = child.classList && child.classList.contains('banner-card-table');
          var hasBannerClass = child.className && child.className.includes('banner-card-table');

          if (isBannerTable || hasBannerClass) {
            processElement(child);
            continue;
          }

          processElement(child);

          if (child.children.length > 0 && !isBannerTable && !hasBannerClass && !child.hasAttribute('data-processed')) {
            processChildren(child);
          }
        }
      }

      processChildren(mainContainer);

      var bannerCount = components.filter(c => c.type === 'card' && c.layout === 'banner').length;
      if (bannerCount > 1) {
        var firstBannerIndex = components.findIndex(c => c.type === 'card' && c.layout === 'banner');
        components = components.filter((c, idx) => {
          if (c.type === 'card' && c.layout === 'banner') {
            return idx === firstBannerIndex;
          }
          return true;
        });
      }

      this.components = components;

      // 🔥 LOG PARA DEBUG
      console.log('📥 Componentes carregados:', this.components);
    },

    rgbToHex(rgb) {
      if (!rgb) return null;
      if (rgb.startsWith('#')) return rgb;
      if (rgb === 'transparent') return 'transparent';

      const match = rgb.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/);
      if (match) {
        const r = parseInt(match[1]);
        const g = parseInt(match[2]);
        const b = parseInt(match[3]);
        return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
      }
      return null;
    },

    extractBgColor(styleString) {
      const match = styleString.match(/background(?:-color)?\s*:\s*([^;]+)/i);
      if (match) {
        return this.rgbToHex(match[1].trim());
      }
      return null;
    },

    isDarkColor(hexColor) {
      if (!hexColor || hexColor === 'transparent') return false;

      const hex = hexColor.replace('#', '');
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);

      // Calcula luminosidade
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luminance < 0.5;
    },

    async saveTemplate() {
      if (!this.templateName) {
        this.showAlertModal('Atenção', 'Por favor, dê um nome ao template.');
        return;
      }

      // 🆕 Verifica conformidade antes de pedir o assunto
      this.checkCompliance();
      this.showComplianceModal = true;
    },

    checkCompliance() {
      const htmlContent = this.generateHTML();

      // Verifica se há um link de descadastro
      this.hasUnsubscribeLink = this.detectUnsubscribeLink(htmlContent);

      // Se não tem link, adiciona aviso
      if (!this.hasUnsubscribeLink) {
        this.complianceWarnings.push({
          type: 'warning',
          message: 'Nenhum link de descadastro detectado. Um Footer será adicionado automaticamente.'
        });
      }

      // Auto-marca o checkbox de unsubscribe se já existe
      if (this.hasUnsubscribeLink) {
        this.complianceChecks.hasUnsubscribeLink = true;
      }
    },

    detectUnsubscribeLink(htmlContent) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlContent;

      // Procura por links com palavras-chave
      const links = tempDiv.querySelectorAll('a[href]');
      const unsubscribeKeywords = [
        'unsubscribe', 'descadastrar', 'cancelar', 'opt-out',
        'desinscrever', 'sair da lista', 'remover'
      ];

      for (let link of links) {
        const text = link.textContent.toLowerCase();
        const href = link.getAttribute('href').toLowerCase();

        if (unsubscribeKeywords.some(keyword =>
          text.includes(keyword) || href.includes(keyword)
        )) {
          return true;
        }
      }

      // Verifica se há componente Footer
      const hasFooter = this.components.some(c => c.type === 'footer');

      return hasFooter;
    },

    // 🆕 Adiciona Footer automaticamente se necessário
    addUnsubscribeFooter() {
      // Verifica se já existe Footer
      const hasFooter = this.components.some(c => c.type === 'footer');

      if (!hasFooter) {
        const footerComponent = {
          id: Date.now() + Math.random(),
          type: 'footer',
          companyName: 'Wurth do Brasil',
          address: '\nR. Adolf Wurth, 557 - Cotia - SP',
          bgColor: '#2c3e50',
          textColor: '#ffffff',
          fontFamily: 'Arial, sans-serif',
          align: 'center',
          socialLinks: {},
          usefulLinks: {
            privacy: 'https://www.wurth.com.br/politica/privacidade',
            terms: 'https://www.wurthdobrasil.com.br/PT/TERMO%20LGPD%20-%20WURTH_v3.pdf',
            unsubscribe: '{{ UNSUBSCRIBE_URL }}'
          },
          legalText: '\nVocê está recebendo este email devido à relação comercial existente entre você e Wurth do Brasil referente aos títulos em aberto.\nSe não deseja mais receber, clique no link de descadastro acima.',
          copyright: '© 2025 Wurth do Brasil. Todos os direitos reservados.'
        };

        this.components.push(footerComponent);
      }
    },

    // 🆕 Fecha o modal de conformidade
    closeComplianceModal() {
      this.showComplianceModal = false;
      this.complianceWarnings = [];
    },

    // 🆕 Procede com o salvamento após conformidade
    proceedWithSave() {
      // Adiciona Footer se necessário
      if (!this.hasUnsubscribeLink) {
        this.addUnsubscribeFooter();
      }

      // Fecha o modal
      this.closeComplianceModal();

      // Continua com o fluxo normal de salvamento
      this.showSubjectPrompt();
    },

    showSubjectPrompt() {
      const modalHtml = `
    <div id="subject-modal-overlay" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.6); display: flex; align-items: center; justify-content: center; z-index: 10000;">
      <div style="background: white; border-radius: 12px; max-width: 600px; width: 90%; box-shadow: 0 10px 40px rgba(0,0,0,0.3); padding: 30px;">
        <h3 style="margin: 0 0 20px 0; font-size: 22px; color: #333;">
          <i class="fa-solid fa-envelope-open-text"></i> Assunto do Email
        </h3>
        
        <p style="margin: 0 0 15px 0; color: #666;">Digite o assunto que aparecerá no email:</p>
        
        <input 
          id="subject-input" 
          type="text" 
          placeholder="Ex: Olá {{ params.CPD }}, confira nossas novidades!" 
          style="width: 100%; padding: 12px; border: 2px solid #e0e0e0; border-radius: 6px; font-size: 14px; outline: none; box-sizing: border-box; margin-bottom: 15px;"
        />

        <div style="background: #f8f9fa; border-radius: 8px; padding: 15px; margin-bottom: 20px;">
          <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
            <i class="fa-solid fa-code" style="color: #667eea;"></i>
            <span style="font-weight: 600; color: #333; font-size: 14px;">Variáveis Disponíveis</span>
          </div>
          
          <!-- Grid de Botões de Variáveis -->
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); gap: 8px; margin-bottom: 10px;">
            <button 
              type="button" 
              class="var-btn" 
              data-var="CPD"
              style="padding: 8px 12px; background: white; border: 1px solid #e0e0e0; border-radius: 6px; cursor: pointer; font-size: 12px; color: #333; display: flex; align-items: center; justify-content: center; gap: 6px; transition: all 0.2s; white-space: nowrap;"
              onmouseover="this.style.background='#667eea'; this.style.color='white'; this.style.borderColor='#667eea';"
              onmouseout="this.style.background='white'; this.style.color='#333'; this.style.borderColor='#e0e0e0';"
            >
              <i class="fa-solid fa-plus-circle" style="font-size: 11px;"></i>
              <span>CPD</span>
            </button>

            <button 
              type="button" 
              class="var-btn" 
              data-var="RAZAO_SOCIAL"
              style="padding: 8px 12px; background: white; border: 1px solid #e0e0e0; border-radius: 6px; cursor: pointer; font-size: 12px; color: #333; display: flex; align-items: center; justify-content: center; gap: 6px; transition: all 0.2s; white-space: nowrap;"
              onmouseover="this.style.background='#667eea'; this.style.color='white'; this.style.borderColor='#667eea';"
              onmouseout="this.style.background='white'; this.style.color='#333'; this.style.borderColor='#e0e0e0';"
            >
              <i class="fa-solid fa-plus-circle" style="font-size: 11px;"></i>
              <span>Razão Social</span>
            </button>

            <button 
              type="button" 
              class="var-btn" 
              data-var="CPF_CNPJ"
              style="padding: 8px 12px; background: white; border: 1px solid #e0e0e0; border-radius: 6px; cursor: pointer; font-size: 12px; color: #333; display: flex; align-items: center; justify-content: center; gap: 6px; transition: all 0.2s; white-space: nowrap;"
              onmouseover="this.style.background='#667eea'; this.style.color='white'; this.style.borderColor='#667eea';"
              onmouseout="this.style.background='white'; this.style.color='#333'; this.style.borderColor='#e0e0e0';"
            >
              <i class="fa-solid fa-plus-circle" style="font-size: 11px;"></i>
              <span>CPF/CNPJ</span>
            </button>
          </div>
          
          <small style="display: block; color: #666; font-size: 12px;">
            <i class="fa-solid fa-lightbulb"></i>
            Clique em uma variável para inseri-la no assunto
          </small>
        </div>

        <div style="display: flex; gap: 10px; justify-content: flex-end;">
          <button 
            id="cancel-subject" 
            type="button" 
            style="padding: 10px 20px; background: #6c757d; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 14px;"
          >
            Cancelar
          </button>
          <button 
            id="confirm-subject" 
            type="button" 
            style="padding: 10px 20px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 14px;"
          >
            Salvar Template
          </button>
        </div>
      </div>
    </div>
  `;

      const modalContainer = document.createElement('div');
      modalContainer.innerHTML = modalHtml;
      document.body.appendChild(modalContainer);

      const input = document.getElementById('subject-input');
      const cancelBtn = document.getElementById('cancel-subject');
      const confirmBtn = document.getElementById('confirm-subject');
      const overlay = document.getElementById('subject-modal-overlay');

      // Preenche com o assunto existente se houver
      if (this.emailSubject) {
        input.value = this.emailSubject;
      }

      setTimeout(() => input.focus(), 100);

      // 🔥 EVENT LISTENER PARA TODOS OS BOTÕES DE VARIÁVEIS
      const varBtns = modalContainer.querySelectorAll('.var-btn');
      varBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const varKey = btn.getAttribute('data-var');
          const cursorPos = input.selectionStart || 0;
          const textBefore = input.value.substring(0, cursorPos);
          const textAfter = input.value.substring(input.selectionEnd || cursorPos);

          input.value = textBefore + `{{ params.${varKey} }}` + textAfter;

          const newPos = cursorPos + varKey.length + 13; // 13 = "{{ params. }}"
          input.focus();
          input.setSelectionRange(newPos, newPos);
        });
      });

      input.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleConfirm();
        }
      });

      const closeModal = () => {
        if (modalContainer && modalContainer.parentNode) {
          document.body.removeChild(modalContainer);
        }
      };

      const handleConfirm = () => {
        const subject = input.value.trim();

        if (!subject) {
          input.style.borderColor = '#dc3545';
          input.placeholder = 'O assunto é obrigatório!';
          input.focus();
          return;
        }

        this.emailSubject = subject;
        closeModal();
        this.performSave();
      };

      cancelBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });

      confirmBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        handleConfirm();
      });

      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
          closeModal();
        }
      });
    },

    async performSave() {
      this.saving = true;
      this.errorMessage = null;

      try {
        const templateData = {
          name: this.templateName,
          subject: this.emailSubject,
          htmlContent: this.generateHTML(),
          isActive: true
        };

        const url = this.templateId
          ? `/emails/api/brevo/templates/${this.templateId}`
          : '/emails/api/brevo/templates';

        const method = this.templateId ? 'PUT' : 'POST';

        const response = await fetch(url, {
          method: method,
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
          },
          body: JSON.stringify(templateData)
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.message || `Erro ${response.status}`);
        }

        if (result.success) {
          const templateId = result.data?.id || this.templateId;

          // 🆕 LIMPA imagens não usadas APÓS salvar
          if (templateId) {
            await this.cleanUnusedImages(templateId);
          }

          this.showSuccess = true;
          this.$emit('saved', 'Template salvo com sucesso!');

          setTimeout(() => {
            this.$emit('close');
          }, 2000);
        }
      } catch (error) {
        console.error('Erro:', error);
        this.errorMessage = error.message || 'Erro ao conectar com o servidor.';
      } finally {
        this.saving = false;
      }
    },

    // 🆕 Método para limpar imagens não usadas
    async cleanUnusedImages(templateId) {
      try {
        const htmlContent = this.generateHTML();

        const response = await fetch('/emails/api/brevo/clean-unused-images', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
          },
          body: JSON.stringify({
            template_id: templateId,
            htmlContent: htmlContent
          })
        });

        const result = await response.json();

        if (result.success && result.deleted > 0) {
          console.log(`✅ ${result.deleted} imagem(ns) não utilizada(s) removida(s)`);
        }
      } catch (error) {
        console.error('Erro ao limpar imagens não usadas:', error);
        // Não bloqueia o salvamento se falhar
      }
    },

    canChangeLayout(currentLayout, newLayout) {
      // 🆕 Se não há layout atual (card novo), permite qualquer layout
      if (!currentLayout) {
        return true;
      }

      // Se o layout atual é igual ao novo, permite
      if (currentLayout === newLayout) {
        return true;
      }

      // Banner não pode mudar
      if (currentLayout === 'banner') {
        return false;
      }

      // Permite troca entre image-left e image-right
      if ((currentLayout === 'image-left' && newLayout === 'image-right') ||
        (currentLayout === 'image-right' && newLayout === 'image-left')) {
        return true;
      }

      // Permite troca entre image-left/right e image-top
      if ((currentLayout === 'image-left' || currentLayout === 'image-right') && newLayout === 'image-top') {
        return true;
      }
      if (currentLayout === 'image-top' && (newLayout === 'image-left' || newLayout === 'image-right')) {
        return true;
      }

      // 🆕 PERMITE mudar de qualquer layout normal (image-*) para grid
      const isCurrentNormalLayout = ['image-left', 'image-right', 'image-top'].includes(currentLayout);
      const isNewGridLayout = newLayout.startsWith('grid-');

      if (isCurrentNormalLayout && isNewGridLayout) {
        return true; // ✅ Permite criar grid a partir de layout normal
      }

      // Para grids, só permite diminuir (não pode voltar para layout normal)
      if (currentLayout === 'grid-4') {
        return newLayout === 'grid-3' || newLayout === 'grid-2';
      }
      if (currentLayout === 'grid-3') {
        return newLayout === 'grid-2';
      }
      if (currentLayout === 'grid-2') {
        return false; // Grid-2 não pode mudar
      }

      // Se chegou aqui, não permite
      return false;
    },
    updateCardLayout(index, newLayout) {
      const currentLayout = this.components[index].layout;

      // Atualiza o layout diretamente
      this.$set(this.components[index], 'layout', newLayout);

      // Se mudou para grid, garante que tem items suficientes
      if (newLayout.startsWith('grid-')) {
        const newGridCount = parseInt(newLayout.split('-')[1]);
        const currentItems = this.components[index].gridItems || [];

        // 🆕 APENAS ADICIONA novos items se necessário, NUNCA remove
        while (currentItems.length < newGridCount) {
          currentItems.push({
            imageUrl: '',
            imageAlt: '',
            imagePosition: 'center',
            imageZoom: 1,
            title: 'Item ' + (currentItems.length + 1),
            description: 'Descrição ' + (currentItems.length + 1),
            buttonUrl: '#'
          });
        }

        // 🆕 NÃO faz slice! Mantém todos os items
        this.$set(this.components[index], 'gridItems', currentItems);
      }
    },

    getLayoutChangeMessage(currentLayout, newLayout) {
      if (currentLayout === 'banner') {
        return 'O layout Banner não pode ser alterado.';
      }

      if (currentLayout === 'grid-2') {
        return 'O layout Grid 2 colunas não pode ser alterado para outro grid. Você pode apenas editar o conteúdo dos cards existentes.';
      }

      if (currentLayout === 'grid-3' && newLayout === 'grid-4') {
        return 'O layout Grid 3 colunas só pode ser reduzido para Grid 2 colunas. Não é possível aumentar o número de colunas.';
      }

      if (currentLayout === 'grid-4' && newLayout === 'grid-4') {
        return 'O Grid 4 colunas pode ser reduzido para Grid 3 ou Grid 2 colunas.';
      }

      return 'Esta mudança de layout não é permitida.';
    },

    // Método para associar imagens ao template
    async associateImagesToTemplate(templateId) {
      try {
        // Extrai todas as URLs de imagens dos componentes
        const imageUrls = this.components
          .filter(c => c.type === 'image' && c.src)
          .map(c => c.src);

        const response = await fetch('/emails/api/brevo/associate-images', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
          },
          body: JSON.stringify({
            template_id: templateId,
            image_urls: imageUrls
          })
        });

        const result = await response.json();

        if (result.success && result.urls) {
          // Atualiza as URLs nos componentes com as novas URLs renomeadas
          this.components.forEach(comp => {
            if (comp.type === 'image' && result.urls[comp.src]) {
              comp.src = result.urls[comp.src];
            }
          });
        }
      } catch (error) {
        console.error('Erro ao associar imagens:', error);
      }
    },

    async updateTemplateHtml(templateId) {
      try {
        const htmlContent = this.generateHTML();

        const response = await fetch(`/emails/api/brevo/templates/${templateId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
          },
          body: JSON.stringify({
            htmlContent: htmlContent
          })
        });

        const result = await response.json();

        if (result.success) {
          console.log('✅ HTML do template atualizado com sucesso');
        } else {
          console.warn('⚠️ Erro ao atualizar HTML:', result.message);
        }
      } catch (error) {
        console.error('Erro ao atualizar HTML do template:', error);
      }
    },

    async renameTemporaryImages(templateId) {
      try {
        // Extrai todas as URLs de imagens dos componentes
        const imageUrls = this.components
          .filter(c => c.type === 'image' && c.src)
          .map(c => c.src);

        if (imageUrls.length === 0) {
          return;
        }

        const response = await fetch('/emails/api/brevo/rename-images', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
          },
          body: JSON.stringify({
            template_id: templateId,
            image_urls: imageUrls
          })
        });

        const result = await response.json();

        if (result.success && result.urls) {
          // Atualiza as URLs nos componentes
          this.components.forEach(comp => {
            if (comp.type === 'image' && result.urls[comp.src]) {
              comp.src = result.urls[comp.src];
            }
          });
        }
      } catch (error) {
        console.error('Erro ao renomear imagens:', error);
        // Não bloqueia o salvamento se falhar
      }
    },

    // Método auxiliar para salvar componentes e settings (opcional)
    // async saveCustomData(templateId) {
    //   try {
    //     const customData = {
    //       template_id: templateId,
    //       components: JSON.stringify(this.components),
    //       settings: JSON.stringify(this.globalSettings)
    //     };

    //     // Você pode criar uma tabela local para salvar esses dados extras
    //     // que o Brevo não suporta nativamente
    //     await fetch('/emails/api/brevo/templates/custom-data', {
    //       method: 'POST',
    //       headers: {
    //         'Content-Type': 'application/json',
    //         'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
    //       },
    //       body: JSON.stringify(customData)
    //     });
    //   } catch (error) {
    //     console.error('Erro ao salvar dados customizados:', error);
    //     // Não bloqueia o salvamento principal se falhar
    //   }
    // },

    handleSuccessClose() {
      this.showSuccess = false;
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.test-modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
}

.test-modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
}

.test-modal-container {
  position: relative;
  background: white;
  border-radius: 16px;
  width: 90%;
  max-width: 700px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.test-modal-header {
  padding: 25px 30px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px 16px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.test-modal-header h3 {
  margin: 0;
  color: white;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 12px;
}

.test-close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  font-size: 18px;
}

.test-close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.test-modal-body {
  padding: 30px;
  overflow-y: auto;
  flex: 1;
}

.test-section {
  margin-bottom: 25px;
}

.test-label {
  display: block;
  margin-bottom: 12px;
  font-weight: 600;
  color: #333;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-container {
  display: flex;
  gap: 12px;
}

.test-input {
  flex: 1;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s;
  font-family: inherit;
  width: 100%;
}

.test-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.btn-search {
  padding: 12px 24px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;
}

.btn-search:hover:not(:disabled) {
  background: #5568d3;
  transform: translateY(-1px);
}

.btn-search:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.contacts-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 300px;
  overflow-y: auto;
}

.contact-card {
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.contact-card:hover {
  border-color: #667eea;
  background: #f9fafb;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
}

.contact-card.selected {
  border-color: #667eea;
  background: #eef2ff;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.contact-info {
  flex: 1;
}

.contact-name {
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
}

.contact-details {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 13px;
  color: #6b7280;
}

.contact-details span {
  display: flex;
  align-items: center;
  gap: 6px;
}

.contact-check {
  color: #667eea;
  font-size: 28px;
  margin-left: 16px;
}

.params-preview {
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  max-height: 200px;
  overflow-y: auto;
}

.param-item {
  padding: 8px 0;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  gap: 12px;
  font-size: 13px;
}

.param-item:last-child {
  border-bottom: none;
}

.param-key {
  font-weight: 600;
  color: #667eea;
  min-width: 140px;
}

.param-value {
  color: #374151;
  word-break: break-word;
}

.test-textarea {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  transition: all 0.2s;
}

.test-textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.help-text {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: #6b7280;
}

.test-alert {
  padding: 14px 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  margin-top: 16px;
  animation: slideIn 0.3s ease-out;
}

.test-alert-error {
  background: #fef2f2;
  border: 2px solid #fecaca;
  color: #991b1b;
}

.test-alert-success {
  background: #f0fdf4;
  border: 2px solid #bbf7d0;
  color: #166534;
}

.test-modal-footer {
  padding: 20px 30px;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
  border-radius: 0 0 16px 16px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.test-btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;
}

.test-btn-cancel {
  background: white;
  color: #374151;
  border: 2px solid #e0e0e0;
}

.test-btn-cancel:hover:not(:disabled) {
  background: #f9fafb;
  border-color: #d1d5db;
}

.test-btn-send {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.test-btn-send:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.test-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Animação Fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.compliance-modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.compliance-modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
}

.compliance-modal-container {
  position: relative;
  background: white;
  border-radius: 16px;
  max-width: 700px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.compliance-modal-header {
  padding: 24px 28px;
  border-bottom: 2px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.compliance-modal-header h3 {
  margin: 0;
  font-size: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.compliance-close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  transition: all 0.2s;
}

.compliance-close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.compliance-modal-body {
  padding: 28px;
  overflow-y: auto;
  flex: 1;
}

.compliance-intro {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: #e3f2fd;
  border-left: 4px solid #2196f3;
  border-radius: 8px;
  margin-bottom: 24px;
}

.compliance-intro i {
  font-size: 24px;
  color: #2196f3;
  flex-shrink: 0;
}

.compliance-intro p {
  margin: 0;
  color: #0d47a1;
  font-weight: 500;
}

.compliance-checklist {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.compliance-item {
  display: flex;
  gap: 16px;
  padding: 20px;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  transition: all 0.3s;
  background: white;
}

.compliance-item.has-warning {
  border-color: #ff9800;
  background: #fff3e0;
}

.compliance-item:hover {
  border-color: #667eea;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
}

.compliance-checkbox {
  position: relative;
  display: block;
  width: 24px;
  height: 24px;
  cursor: pointer;
  flex-shrink: 0;
}

.compliance-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.compliance-checkbox .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 24px;
  width: 24px;
  background-color: #fff;
  border: 2px solid #ccc;
  border-radius: 6px;
  transition: all 0.2s;
}

.compliance-checkbox:hover .checkmark {
  border-color: #667eea;
}

.compliance-checkbox input:checked~.checkmark {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-color: #667eea;
}

.compliance-checkbox .checkmark:after {
  content: "";
  position: absolute;
  display: none;
  left: 7px;
  top: 3px;
  width: 6px;
  height: 11px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.compliance-checkbox input:checked~.checkmark:after {
  display: block;
}

.compliance-checkbox input:disabled~.checkmark {
  opacity: 0.5;
  cursor: not-allowed;
}

.compliance-content {
  flex: 1;
}

.compliance-content strong {
  display: block;
  font-size: 16px;
  color: #333;
  margin-bottom: 6px;
}

.compliance-content p {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}

.compliance-warning {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 12px;
  padding: 12px;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  color: #856404;
  font-size: 13px;
}

.compliance-warning i {
  font-size: 18px;
  flex-shrink: 0;
  margin-top: 2px;
}

.compliance-success {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 12px;
  background: #d4edda;
  border: 1px solid #28a745;
  border-radius: 8px;
  color: #155724;
  font-size: 13px;
}

.compliance-success i {
  font-size: 18px;
  color: #28a745;
}

.compliance-info-box {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  margin-top: 24px;
}

.compliance-info-box i {
  font-size: 24px;
  color: #ffc107;
  flex-shrink: 0;
}

.compliance-info-box strong {
  display: block;
  color: #333;
  margin-bottom: 4px;
}

.compliance-info-box p {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}

.compliance-modal-footer {
  padding: 20px 28px;
  border-top: 2px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background: #f8f9fa;
}

.compliance-btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.compliance-btn-cancel {
  background: #6c757d;
  color: white;
}

.compliance-btn-cancel:hover {
  background: #5a6268;
}

.compliance-btn-save {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.compliance-btn-save:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.compliance-btn-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* Animação fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.editable-title {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 0;
}

.template-name-title {
  font-size: 1.2rem;
  font-weight: 600;
  border: none;
  border-bottom: 2px solid #999;
  background: transparent;
  padding: 4px 0;
  width: 280px;
  transition: border-color 0.2s;
}

.template-name-title:focus {
  outline: none;
  border-color: #6a4dfd;
}

.edit-icon {
  font-size: 14px;
  color: #6a4dfd;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.edit-icon:hover {
  opacity: 1;
}

.link-modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.link-modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
}

.link-modal-container {
  position: relative;
  background: white;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  z-index: 10001;
}

.link-modal-header {
  padding: 20px 25px;
  border-bottom: 2px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.link-modal-header h3 {
  margin: 0;
  font-size: 20px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 10px;
}

.link-modal-header h3 i {
  color: #28a745;
}

.link-close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.link-close-btn:hover {
  background: #f0f0f0;
  color: #333;
}

.link-modal-body {
  padding: 25px;
}

.link-preview {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 15px 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 500;
}

.link-preview i {
  opacity: 0.7;
  font-size: 12px;
}

.link-form-group {
  margin-bottom: 20px;
}

.link-form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.link-form-group input {
  width: 100%;
  padding: 12px;
  border: 2px solid #e0e0e0;
  border-radius: 6px !important;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s;
}

.link-form-group input:focus {
  border-color: #28a745;
}

.link-form-group small {
  display: block;
  margin-top: 8px;
  color: #666;
  font-size: 12px;
}

.link-info-box {
  background: #f0f9ff;
  border-left: 4px solid #28a745;
  padding: 15px;
  border-radius: 6px !important;
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.link-info-box i {
  color: #28a745;
  font-size: 20px;
  margin-top: 2px;
}

.link-info-box strong {
  display: block;
  color: #333;
  margin-bottom: 5px;
  font-size: 14px;
}

.link-info-box p {
  color: #666;
  font-size: 13px;
  line-height: 1.5;
  margin: 0;
}

.link-modal-footer {
  padding: 20px 25px;
  border-top: 2px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.link-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px !important;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.link-btn-cancel {
  background: #6c757d;
  color: white;
}

.link-btn-cancel:hover {
  background: #5a6268;
}

.link-btn-insert {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
}

.link-btn-insert:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.link-btn-insert:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* Animação do modal */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ✅ CANVAS EM MODO MOBILE */
.canvas-container.mobile-view {
  max-width: 400px;
  margin: 0 auto;
}

.canvas-container.mobile-view .email-canvas {
  width: 400px !important;
  max-width: 400px !important;
  padding: 20px 15px !important;
  overflow-x: hidden !important;
}

/* ✅ ÍCONES SOCIAIS NO CANVAS MOBILE */
.canvas-container.mobile-view .social-block {
  padding: 0 10px !important;
}

.canvas-container.mobile-view .social-block>div>div {
  display: flex !important;
  flex-wrap: wrap !important;
  justify-content: center !important;
  gap: 8px !important;
  max-width: 100% !important;
}

.canvas-container.mobile-view .social-block a {
  margin: 0 4px 8px 4px !important;
}

.canvas-container.mobile-view .social-block table {
  width: 44px !important;
  height: 44px !important;
}

.canvas-container.mobile-view .social-block img {
  width: 26px !important;
  height: 26px !important;
}

/* ✅ VÍDEOS NO CANVAS MOBILE */
.canvas-container.mobile-view .video-block {
  padding: 0 10px !important;
}

.canvas-container.mobile-view .video-block>div {
  max-width: 100% !important;
}

/* ✅ IMAGENS NO CANVAS MOBILE */
.canvas-container.mobile-view .image-block img {
  max-width: 100% !important;
  height: auto !important;
}

/* ✅ TEXTO NO CANVAS MOBILE */
.canvas-container.mobile-view .text-block,
.canvas-container.mobile-view .heading-block {
  padding: 10px !important;
}

/* ✅ CARDS NO CANVAS MOBILE */
.canvas-container.mobile-view .card-block {
  padding: 0 10px !important;
}

/* ✅ FOOTER NO CANVAS MOBILE */
.canvas-container.mobile-view .footer-block {
  padding: 20px 15px !important;
  font-size: 14px !important;
}

/* Container de Variáveis */
.variables-container {
  margin-top: 15px;
  padding: 15px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  border-radius: 8px;
  border: 2px solid #d1d9e6;
}

.variables-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-weight: 600;
  color: #4a5568;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.variables-header i {
  color: #667eea;
  font-size: 16px;
}

.variables-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 10px;
  margin-bottom: 12px;
}

.variable-btn {
  padding: 10px 14px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 6px !important;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
  position: relative;
  overflow: hidden;
}

.variable-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s;
}

.variable-btn:hover::before {
  left: 100%;
}

.variable-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.5);
}

.variable-btn:active {
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(102, 126, 234, 0.4);
}

.variable-btn i {
  font-size: 14px;
}

.variable-btn span {
  white-space: nowrap;
}

.variables-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #718096;
  font-size: 12px;
  font-style: italic;
  margin-top: 8px;
}

.variables-hint i {
  color: #f6ad55;
  font-size: 14px;
}

/* Destaque das variáveis no textarea */
.form-textarea,
.form-input {
  font-family: 'Courier New', Consolas, monospace !important;
  line-height: 1.6 !important;
}

/* Efeito visual para variáveis Brevo */
.form-textarea:focus,
.form-input:focus {
  border-color: #667eea !important;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;
}

/* Adicione no <style> do componente ou no CSS global */
.form-button:hover {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.form-button:active {
  transform: translateY(0);
}

.form-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.editor-image-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #e0e0e0;
  /* A linha abaixo será dinâmica via :style no template */
}

/* ===== VIEWPORT REAL (EDITOR) ===== */
.image-viewport-real {
  position: relative;
  width: 100%;
  background: #f5f5f5;
  border: 3px solid #667eea;
  border-radius: 8px;
  overflow: hidden;
  cursor: move;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.editor-preview-banner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.editor-image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  user-select: none;
  pointer-events: none;
  transition: none;
}

.editor-banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px;
  text-align: center;
  pointer-events: none;
}

/* Preview Horizontal */
.editor-preview-horizontal {
  display: flex;
  gap: 20px;
  background: white;
  overflow: hidden;
}

.editor-preview-horizontal.reverse {
  flex-direction: row-reverse;
}

.editor-content-preview {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  pointer-events: none;
}

.editor-content-preview h3,
.editor-content-preview h4 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 18px;
}

.editor-content-preview p {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

/* Preview Vertical */
.editor-preview-vertical {
  background: white;
  overflow: hidden;
}

/* Preview Grid */
.editor-preview-grid {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  max-width: 300px;
  margin: 0 auto;
}

.viewport-grid {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 10;
}

.grid-line {
  position: absolute;
  background: rgba(102, 126, 234, 0.5);
}

.grid-line.vertical {
  width: 2px;
  height: 100%;
  top: 0;
}

.grid-line.horizontal {
  height: 2px;
  width: 100%;
  left: 0;
}

.center-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  border: 2px solid #667eea;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667eea;
  font-size: 20px;
  pointer-events: none;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 20;
}

/* ===== PREVIEW FINAL (COLUNA DIREITA) ===== */
.real-preview-container {
  background: #f0f0f0;
  border-radius: 8px;
  padding: 20px;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #e0e0e0;
}

.preview-banner {
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px;
  text-align: center;
}

.banner-title {
  color: white;
  font-size: 28px;
  font-weight: bold;
  margin: 0 0 15px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.banner-description {
  color: white;
  font-size: 16px;
  margin: 0 0 20px 0;
  max-width: 600px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  line-height: 1.6;
}

.banner-button-preview {
  margin-top: 10px;
}

/* Preview Card Horizontal */
.preview-card-horizontal {
  display: flex;
  gap: 20px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.preview-card-horizontal.reverse {
  flex-direction: row-reverse;
}

.preview-image-container {
  overflow: hidden;
  background: #f5f5f5;
}

.preview-content {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.preview-content h3,
.preview-content h4 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 18px;
}

.preview-content p {
  margin: 0 0 15px 0;
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

.preview-button-container {
  margin-top: auto;
}

/* Preview Card Vertical */
.preview-card-vertical {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Preview Grid Item */
.preview-grid-item {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  max-width: 300px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* ===== MODAL DE EDIÇÃO MELHORADO (WIDE) ===== */
.image-edit-overlay-improved {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  backdrop-filter: blur(5px);
  animation: fadeIn 0.2s ease-out;
  padding: 20px;
}

.image-edit-modal-wide {
  background: white;
  border-radius: 12px;
  width: 95%;
  max-width: 1400px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  animation: slideUp 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.edit-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 25px;
  border-bottom: 2px solid #e0e0e0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 12px 12px 0 0;
}

.edit-modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn-close-edit {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.2s;
}

.btn-close-edit:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}

/* ===== LAYOUT DE 2 COLUNAS ===== */
.edit-modal-body-split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 25px;
  padding: 25px;
  flex: 1;
  overflow: auto;
}

.edit-column,
.preview-column {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.column-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e0e0e0;
}

/* ===== VIEWPORT DO EDITOR ===== */
.image-viewport {
  position: relative;
  width: 100%;
  height: 400px;
  background: #f5f5f5;
  border: 3px solid #667eea;
  border-radius: 8px;
  overflow: hidden;
  cursor: move;
  box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.1);
}

.image-draggable {
  position: absolute;
  width: 100%;
  height: 100%;
  transition: transform 0.05s ease-out;
  user-select: none;
}

.viewport-grid {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.grid-line {
  position: absolute;
  background: rgba(102, 126, 234, 0.3);
}

.grid-line.vertical {
  width: 1px;
  height: 100%;
  top: 0;
}

.grid-line.horizontal {
  height: 1px;
  width: 100%;
  left: 0;
}

.center-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  border: 2px solid #667eea;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667eea;
  font-size: 20px;
  pointer-events: none;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.edit-hint {
  font-size: 13px;
  color: #666;
  text-align: center;
  margin: 0;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px !important;
}

/* ===== PREVIEW REAL ===== */
.real-preview-container {
  background: #f0f0f0;
  border-radius: 8px;
  padding: 20px;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #e0e0e0;
}

/* Preview Banner */
.preview-banner {
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px;
  text-align: center;
}

.banner-title {
  color: white;
  font-size: 28px;
  font-weight: bold;
  margin: 0 0 15px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.banner-description {
  color: white;
  font-size: 16px;
  margin: 0;
  max-width: 600px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

/* Preview Card Horizontal */
.preview-card-horizontal {
  display: flex;
  gap: 20px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.preview-card-horizontal.reverse {
  flex-direction: row-reverse;
}

.preview-image-container {
  overflow: hidden;
  background: #f5f5f5;
}

.preview-content {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.preview-content h3,
.preview-content h4 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 18px;
}

.preview-content p {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

/* Preview Card Vertical */
.preview-card-vertical {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Preview Grid Item */
.preview-grid-item {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  max-width: 300px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* ===== INFO DA POSIÇÃO ===== */
.position-info {
  display: flex;
  gap: 15px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  justify-content: space-around;
}

.info-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.info-label {
  font-size: 11px;
  color: #666;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 20px;
  color: #667eea;
  font-weight: bold;
}

/* ===== CONTROLES ===== */
.edit-modal-footer {
  padding: 20px 25px;
  border-top: 2px solid #e0e0e0;
  background: #f8f9fa;
  border-radius: 0 0 12px 12px;
}

.zoom-control-group {
  margin-bottom: 20px;
}

.zoom-control-group label {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.zoom-buttons {
  display: flex;
  align-items: center;
  gap: 15px;
}

.zoom-btn {
  width: 40px;
  height: 40px;
  border: 2px solid #667eea;
  background: white;
  color: #667eea;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.2s;
}

.zoom-btn:hover:not(:disabled) {
  background: #667eea;
  color: white;
  transform: scale(1.1);
}

.zoom-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.zoom-slider {
  flex: 1;
  height: 8px;
  -webkit-appearance: none;
  background: #e0e0e0;
  border-radius: 10px;
  outline: none;
}

.zoom-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  background: #667eea;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: all 0.2s;
}

.zoom-slider::-webkit-slider-thumb:hover {
  transform: scale(1.2);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.zoom-slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  background: #667eea;
  border-radius: 50%;
  cursor: pointer;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.zoom-value {
  min-width: 50px;
  text-align: center;
  font-weight: 600;
  color: #667eea;
  font-size: 14px;
}

.action-buttons {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.btn-reset,
.btn-save {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;
}

.btn-reset {
  background: #6c757d;
  color: white;
}

.btn-reset:hover {
  background: #5a6268;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.btn-save {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-save:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* ===== RESPONSIVO ===== */
@media (max-width: 1200px) {
  .edit-modal-body-split {
    grid-template-columns: 1fr;
  }

  .image-viewport {
    height: 300px;
  }

  .real-preview-container {
    min-height: 300px;
  }
}

@media (max-width: 768px) {
  .image-edit-modal-wide {
    width: 100%;
    max-height: 100vh;
    border-radius: 0;
  }

  .edit-modal-body-split {
    padding: 15px;
    gap: 15px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .btn-reset,
  .btn-save {
    width: 100%;
    justify-content: center;
  }
}

/* Editor Inline de Imagem */
.image-edit-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 20px;
  pointer-events: none;
}

.image-edit-controls {
  background: white;
  border-radius: 12px 12px 0 0;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 100%;
  pointer-events: auto;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.edit-control-header {
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.edit-control-header h4 {
  margin: 0;
  font-size: 18px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn-close-edit {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.btn-close-edit:hover {
  background: #f0f0f0;
  color: #333;
}

.edit-control-body {
  padding: 20px;
}

.edit-hint {
  background: #f8f9fa;
  padding: 12px;
  border-radius: 6px !important;
  font-size: 13px;
  color: #666;
  margin: 0 0 20px 0;
  line-height: 1.8;
}

.edit-hint i {
  color: #667eea;
  margin-right: 5px;
}

.zoom-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-bottom: 15px;
}

.zoom-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid #667eea;
  background: white;
  color: #667eea;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.2s;
}

.zoom-btn:hover:not(:disabled) {
  background: #667eea;
  color: white;
}

.zoom-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.zoom-value {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  min-width: 60px;
  text-align: center;
}

.btn-reset-edit {
  width: 100%;
  padding: 12px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 6px !important;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s;
}

.btn-reset-edit:hover {
  background: #5a6268;
}

.btn-save-edit {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 6px !important;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s;
}

.btn-save-edit:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* Cursor de movimento na imagem */
.banner-image-wrapper[style*="cursor: move"] img {
  cursor: move !important;
}

/* Image Crop Editor */
.image-crop-editor {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.crop-editor-container {
  background: #2a2a2a;
  border-radius: 12px;
  max-width: 95vw;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.crop-editor-header {
  padding: 20px 30px;
  border-bottom: 1px solid #444;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #1f1f1f;
}

.crop-editor-header h3 {
  margin: 0;
  font-size: 18px;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 10px;
}

.crop-editor-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.crop-editor-close:hover {
  background: #444;
  color: #fff;
}

.crop-editor-content {
  flex: 1;
  overflow: hidden;
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1a1a1a;
  position: relative;
}

.crop-canvas-wrapper {
  position: relative;
  display: inline-block;
  max-width: 100%;
  max-height: 100%;
}

.crop-canvas-image {
  display: block;
  max-width: 100%;
  max-height: 70vh;
  user-select: none;
  -webkit-user-drag: none;
}

.crop-selection-box {
  position: absolute;
  border: 2px solid #667eea;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);
  cursor: move;
  transition: box-shadow 0.2s;
}

.crop-selection-box:hover {
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.6);
}

.crop-selection-inner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

/* Grade 3x3 */
.crop-grid-line {
  position: absolute;
  background: rgba(255, 255, 255, 0.3);
}

.crop-grid-line.horizontal {
  width: 100%;
  height: 1px;
}

.crop-grid-line.vertical {
  height: 100%;
  width: 1px;
}

/* Handles de redimensionamento */
.crop-handle {
  position: absolute;
  width: 12px;
  height: 12px;
  background: #667eea;
  border: 2px solid #fff;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  z-index: 10;
}

.crop-handle.nw {
  top: -6px;
  left: -6px;
  cursor: nw-resize;
}

.crop-handle.ne {
  top: -6px;
  right: -6px;
  cursor: ne-resize;
}

.crop-handle.sw {
  bottom: -6px;
  left: -6px;
  cursor: sw-resize;
}

.crop-handle.se {
  bottom: -6px;
  right: -6px;
  cursor: se-resize;
}

.crop-handle.n {
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  cursor: n-resize;
}

.crop-handle.s {
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  cursor: s-resize;
}

.crop-handle.w {
  top: 50%;
  left: -6px;
  transform: translateY(-50%);
  cursor: w-resize;
}

.crop-handle.e {
  top: 50%;
  right: -6px;
  transform: translateY(-50%);
  cursor: e-resize;
}

.crop-editor-footer {
  padding: 20px 30px;
  border-top: 1px solid #444;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #1f1f1f;
  gap: 20px;
  flex-wrap: wrap;
}

.crop-info {
  display: flex;
  gap: 20px;
  color: #999;
  font-size: 13px;
}

.crop-info-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

.crop-info-label {
  color: #666;
}

.crop-info-value {
  color: #fff;
  font-weight: 600;
}

.crop-editor-buttons {
  display: flex;
  gap: 10px;
}

.crop-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px !important;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.crop-btn-reset {
  background: #444;
  color: #fff;
}

.crop-btn-reset:hover {
  background: #555;
}

.crop-btn-apply {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.crop-btn-apply:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.crop-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Adicione no seu CSS */
.image-position-editor {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.position-editor-container {
  background: white;
  border-radius: 12px;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.position-editor-header {
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.position-editor-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.position-editor-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.position-editor-close:hover {
  background: #f0f0f0;
  color: #333;
}

.position-editor-content {
  flex: 1;
  overflow: auto;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.position-editor-viewport {
  position: relative;
  overflow: hidden;
  border: 2px solid #667eea;
  border-radius: 8px;
  cursor: move;
  background: #f0f0f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.position-editor-image {
  display: block;
  user-select: none;
  -webkit-user-drag: none;
  pointer-events: none;
}

.position-editor-grid {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.position-editor-grid-line {
  position: absolute;
  background: rgba(255, 255, 255, 0.3);
}

.position-editor-grid-line.horizontal {
  width: 100%;
  height: 1px;
}

.position-editor-grid-line.vertical {
  height: 100%;
  width: 1px;
}

.position-editor-controls {
  display: flex;
  gap: 10px;
  align-items: center;
}

.position-editor-button {
  padding: 10px 20px;
  border: none;
  border-radius: 6px !important;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.2s;
}

.position-editor-button.primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.position-editor-button.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.position-editor-button.secondary {
  background: #6c757d;
  color: white;
}

.position-editor-button.secondary:hover {
  background: #5a6268;
}

.position-editor-info {
  text-align: center;
  color: #666;
  font-size: 13px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px !important;
  max-width: 600px;
}

.position-editor-zoom {
  display: flex;
  gap: 10px;
  align-items: center;
}

.position-editor-zoom button {
  width: 36px;
  height: 36px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 6px !important;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.position-editor-zoom button:hover {
  background: #f0f0f0;
  border-color: #667eea;
}

.position-editor-zoom span {
  min-width: 60px;
  text-align: center;
  font-weight: 600;
  color: #333;
}

/* Cards responsivos */
@media only screen and (max-width: 800px) {
  table[class="card-responsive"] {
    width: 100% !important;
  }

  td[class="card-image"] {
    display: block !important;
    width: 100% !important;
    padding: 0 0 15px 0 !important;
  }

  td[class="card-content"] {
    display: block !important;
    width: 100% !important;
  }
}

.preview-iframe {
  width: 100%;
  min-height: 800px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: white;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  display: block;
  overflow: hidden !important;
  transition: height 0.3s ease;
}

/* Modal de Envio de Teste - Garantido por cima de tudo */
.test-modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.test-modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 99999;
}

.test-modal-container {
  position: relative;
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  max-width: 550px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  z-index: 100000;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.test-modal-header {
  padding: 20px 25px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
}

.test-modal-header h3 {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #333;
  font-size: 18px;
}

.test-modal-header h3 i {
  color: #667eea;
  font-size: 20px;
}

.test-close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  padding: 5px;
  line-height: 1;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
}

.test-close-btn:hover {
  background: #e0e0e0;
  color: #333;
}

.test-modal-body {
  padding: 25px;
  max-height: 60vh;
  overflow-y: auto;
}

.test-description {
  margin: 0 0 20px 0;
  color: #666;
  font-size: 14px;
}

.test-form-group {
  margin-bottom: 20px;
}

.test-form-group label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
  font-size: 14px;
}

.test-form-group input {
  width: 100%;
  padding: 12px 15px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  box-sizing: border-box;
  transition: all 0.3s;
  font-family: inherit;
}

.test-form-group input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.test-form-group small {
  display: block;
  color: #999;
  margin-top: 5px;
  font-size: 12px;
}

.test-alert {
  margin-top: 15px;
  padding: 12px 15px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}

.test-alert-error {
  background: #fee;
  border-left: 4px solid #f44336;
  color: #c62828;
}

.test-alert-success {
  background: #e8f5e9;
  border-left: 4px solid #4caf50;
  color: #2e7d32;
}

.test-modal-footer {
  padding: 15px 25px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  background: #f8f9fa;
}

.test-btn {
  padding: 10px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s;
  font-family: inherit;
}

.test-btn-cancel {
  background: #6c757d;
  color: white;
}

.test-btn-cancel:hover:not(:disabled) {
  background: #5a6268;
}

.test-btn-send {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.test-btn-send:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.test-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Transição fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Animação spinner */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.fa-spin {
  animation: spin 1s linear infinite;
}


/* Hover no botão enviar teste */
.btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.preview-toggle-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  padding: 15px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
}

.toggle-buttons {
  display: flex;
  background: #ffffff;
  border-radius: 8px;
  padding: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  gap: 4px;
}

.toggle-btn {
  padding: 8px 16px;
  border: none;
  background: transparent;
  color: #666;
  border-radius: 6px !important;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.toggle-btn:hover {
  background: #f5f5f5;
}

.toggle-btn.active {
  background: #667eea;
  color: white;
  border-radius: 8px !important;
}

.toggle-btn svg {
  flex-shrink: 0;
}

.width-indicator {
  font-size: 13px;
  color: #666;
  font-weight: 500;
  min-width: 60px;
  text-align: center;
}

/* Wrapper do Preview */
.preview-content-wrapper {
  display: flex;
  justify-content: center;
  padding: 30px 20px;
  background: #f0f0f0;
  overflow-y: auto;
  max-height: calc(85vh - 140px);
}

.iframe-container {
  width: 100%;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
}

.iframe-container.desktop {
  max-width: 100%;
}

.iframe-container.mobile {
  max-width: 400px;
}

.preview-iframe {
  width: 100%;
  height: 800px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: white;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

/* Ajuste no modal para acomodar o toggle */
.modal-box-preview.preview-modal {
  max-width: 95vw;
  width: 1200px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.preview-header {
  flex-shrink: 0;
}

/* Remove o padding do preview-content antigo se existir */
.preview-content {
  padding: 0;
}

.block-icon-lg {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
}

/* .block-card:hover .block-icon-lg {
  color: white;
} */

.block-icon-lg svg {
  width: 32px;
  height: 32px;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.brevo-editor {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  z-index: 9999;
}

/* Barra de Ações */
.action-bar {
  background: white;
  padding: 12px 20px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  z-index: 100;
  flex-shrink: 0;
}

.action-left {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(90deg, #6366f1, #8b5cf6);
  color: white;
  border: none;
  border-radius: 8px !important;
  padding: 8px 14px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.action-btn:hover {
  background: linear-gradient(90deg, #4f46e5, #7c3aed);
  transform: translateY(-1px);
}

.action-btn i {
  font-size: 16px;
}

.template-name-input {
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 6px 8px;
  transition: border-color 0.3s;
  max-width: 350px;
  width: 100%;
}

.template-name-input:focus {
  outline: none;
  border-bottom-color: #007bff;
}

.action-right {
  display: flex;
  gap: 10px;
}

.icon {
  font-size: 16px;
}

/* Workspace */
.workspace {
  display: flex;
  flex: 1;
  overflow: hidden;
}

/* Painel Esquerdo */
.left-panel {
  width: 450px;
  background: white;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.tabs {
  display: flex;
  background: #f7f7f9;
  border-bottom: 1px solid #ddd;
  font-size: 16px;
}

.tab {
  flex: 1;
  text-align: center;
  padding: 10px 0;
  font-weight: 500;
  color: #555;
  cursor: pointer;
  transition: all 0.25s;
  border-bottom: 2px solid transparent;
}

.tab.active {
  color: #5b47f5;
  border-bottom: 2px solid #5b47f5;
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.tab:hover {
  background: #f8f9fa;
  color: #5b47f5;
}

.tab-content {
  flex: 1;
  overflow-y: auto;
}

/* Aba Blocos */
.blocks-tab {
  padding: 20px 15px;
}

.blocks-section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 12px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  margin-bottom: 12px;
  padding-left: 5px;
}

.blocks-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.block-card {
  background: #f8f9fa;
  border: 2px solid #e0e0e0;
  border-radius: 8px !important;
  padding: 15px 10px;
  text-align: center;
  cursor: grab;
  transition: all 0.2s;
}

.block-card:hover {
  border: 1px solid var(--sib-color_surface-hover-background, #000000);
  transform: translateY(-2px);
}

.block-card:active {
  cursor: grabbing;
}

.block-icon-lg {
  font-size: 32px;
  margin-bottom: 8px;
}

.block-name {
  font-size: 13px;
  font-weight: 600;
}

/* Aba Editar */
.edit-tab {
  padding: 20px 15px;
}

.edit-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #e0e0e0;
}

.btn-delete-small {
  padding: 6px 10px;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 4px !important;
  cursor: pointer;
  font-size: 14px;
}

.btn-delete-small:hover {
  background: #c82333;
}

.empty-edit {
  padding: 40px 20px;
  text-align: center;
  color: #999;
}

/* Upload de Imagem */
.upload-area {
  border: 2px dashed #ddd;
  border-radius: 8px !important;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  background: #f9f9f9;
}

.upload-area:hover {
  border-color: #007bff;
  background: #f0f7ff;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: #666;
}

.upload-icon {
  font-size: 48px;
}

.upload-preview {
  max-width: 100%;
  max-height: 200px;
  border-radius: 4px !important;
}

/* Formulários */
.editor-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.form-group label {
  font-size: 13px;
  font-weight: 600;
  color: #555;
}

.form-input,
.form-select,
.form-textarea {
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px !important;
  font-size: 14px;
  font-family: inherit;
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
  outline: none;
  border-color: #007bff;
}

.form-textarea {
  resize: vertical;
}

.form-color {
  width: 100%;
  height: 40px;
  border: 1px solid #ddd;
  border-radius: 4px !important;
  cursor: pointer;
}

.form-range {
  width: 100%;
}

.range-value {
  font-size: 13px;
  color: #666;
  font-weight: 500;
}

.align-buttons {
  display: flex;
  gap: 5px;
}

.align-btn {
  flex: 1;
  padding: 8px;
  background: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 4px !important;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.2s;
}

.align-btn:hover {
  background: #e9ecef;
}

.align-btn.active {
  background: #007bff;
  color: white;
  border-color: #007bff;
}

.form-group small {
  font-size: 11px;
  color: #999;
}

/* Aba Configurações */
.settings-tab {
  padding: 20px 15px;
}

/* Canvas */
.canvas-panel {
  flex: 1;
  background: #f5f5f5;
  overflow-y: auto;
  padding: 30px;
}

.canvas-container {
  max-width: 100%;
  transition: all 0.3s;
}

.canvas-container.mobile-view {
  max-width: 400px;
  margin: 0 auto;
}

.email-canvas {
  min-height: 400px;
  background: white;
  border-radius: 8px;
  position: relative;
  transition: all 0.3s ease;
  overflow-x: hidden;
  /* ✅ IMPORTANTE: Esconde overflow horizontal */
}

/* ✅ AJUSTE ESPECÍFICO PARA MOBILE */
.mobile-view .email-canvas {
  width: 400px !important;
  max-width: 400px !important;
  padding: 20px 10px !important;
  /* ✅ Reduz padding lateral */
  box-sizing: border-box !important;
}

/* ✅ FORÇA QUEBRA DE ELEMENTOS NO MOBILE */
.mobile-view .canvas-block {
  max-width: 100% !important;
  overflow-x: hidden !important;
}

.mobile-view .block-wrapper {
  max-width: 100% !important;
  overflow-x: hidden !important;
}

/* Blocos Melhorados */
.canvas-block {
  position: relative;
  transition: all 0.2s;
  cursor: pointer;
}

.canvas-block.hover .block-wrapper {
  background: rgba(0, 123, 255, 0.03);
}

.canvas-block.selected .block-wrapper {
  background: rgba(0, 123, 255, 0.08);
  box-shadow: inset 0 0 0 2px #007bff;
}

.block-wrapper {
  position: relative;
  border-radius: 4px !important;
  transition: all 0.2s;
}

.mini-toolbar {
  position: absolute;
  top: -35px;
  right: 5px;
  display: flex;
  gap: 4px;
  background: white;
  padding: 4px;
  border-radius: 4px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.mini-btn {
  width: 28px;
  height: 28px;
  border: none;
  background: #f8f9fa;
  border-radius: 3px !important;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s;
}

.mini-btn:hover:not(:disabled) {
  background: #007bff;
  color: white;
}

.mini-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.mini-delete:hover {
  background: #dc3545 !important;
}

.empty-canvas {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 500px;
  color: #999;
  text-align: center;
  padding: 40px;
}

.empty-icon {
  font-size: 80px;
  margin-bottom: 20px;
}

.empty-canvas h3 {
  font-size: 22px;
  margin: 10px 0;
  color: #666;
}

.empty-canvas p {
  font-size: 15px;
  color: #999;
}

/* Renderização */
.text-render {
  padding: 10px;
}

.placeholder-img,
.placeholder-video {
  padding: 60px 40px;
  background: #f8f9fa;
  border: 2px dashed #ddd;
  border-radius: 8px !important;
  text-align: center;
  color: #999;
  font-size: 14px;
}

/* Modal Preview */
.preview-modal {
  max-width: 90vw;
  max-height: 90vh;
  width: 800px;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid #e0e0e0;
  background: #f8f9fa;
}

.preview-header h2 {
  margin: 0;
  font-size: 20px;
  color: #333;
}

.btn-close {
  width: 32px;
  height: 32px;
  border: none;
  background: #e0e0e0;
  border-radius: 50% !important;
  cursor: pointer;
  font-size: 18px;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.btn-close:hover {
  background: #dc3545;
  color: white;
}

.preview-content {
  flex: 1;
  overflow-y: auto;
  padding: 30px;
  background: #f5f5f5;
}

/* Modais */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  animation: fadeIn 0.2s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.modal-box {
  background: white;
  padding: 40px;
  border-radius: 12px !important;
  text-align: center;
  max-width: 450px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  animation: slideUp 0.3s ease-out;
}

.modal-box-preview {
  background: white;
  padding: 40px;
  border-radius: 12px !important;
  text-align: center;
  max-width: 800px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(30px) scale(0.95);
    opacity: 0;
  }

  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

.modal-icon {
  font-size: 70px;
  margin-bottom: 20px;
}

.modal-box h2 {
  margin: 15px 0;
  color: #333;
  font-size: 26px;
  font-weight: 600;
}

.modal-box p {
  color: #666;
  margin: 15px 0 30px 0;
  font-size: 16px;
  line-height: 1.5;
}

.modal-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.btn-modal-primary {
  padding: 12px 32px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 6px !important;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
}

.btn-modal-primary:hover {
  background: #0056b3;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.4);
}

.btn-modal-secondary {
  padding: 12px 32px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 6px !important;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  transition: all 0.2s;
}

.btn-modal-secondary:hover {
  background: #5a6268;
  transform: translateY(-1px);
}

.btn-modal-danger {
  padding: 12px 32px;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 6px !important;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
}

.btn-modal-danger:hover {
  background: #c82333;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.4);
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px !important;
}

::-webkit-scrollbar-thumb:hover {
  background: #999;
}
</style>